var ll = Object.defineProperty, il = Object.defineProperties;
var nl = Object.getOwnPropertyDescriptors;
var pr = Object.getOwnPropertySymbols;
var U_ = Object.prototype.hasOwnProperty, L_ = Object.prototype.propertyIsEnumerable;
var t_ = (e, a, r) => a in e ? ll(e, a, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[a] = r, y = (e, a) => {
  for (var r in a || (a = {}))
    U_.call(a, r) && t_(e, r, a[r]);
  if (pr)
    for (var r of pr(a))
      L_.call(a, r) && t_(e, r, a[r]);
  return e;
}, B = (e, a) => il(e, nl(a));
var U = (e, a) => {
  var r = {};
  for (var _ in e)
    U_.call(e, _) && a.indexOf(_) < 0 && (r[_] = e[_]);
  if (e != null && pr)
    for (var _ of pr(e))
      a.indexOf(_) < 0 && L_.call(e, _) && (r[_] = e[_]);
  return r;
};
var a_ = (e, a, r) => t_(e, typeof a != "symbol" ? a + "" : a, r);
import * as v from "react";
import { useState as de, useCallback as kt, useLayoutEffect as cl, useEffect as V, createContext as yo, useContext as ko, useMemo as wa, useRef as Xt, useReducer as sl, memo as dl } from "react";
import wo from "lodash.debounce";
import { jsx as t, jsxs as h, Fragment as Z } from "react/jsx-runtime";
import { ChevronDown as ta, Check as Na, Close as dt, Info as Mr, Warning as Co, CheckCircle as T_, Block as $o, ChevronRight as Ur, VisibilityOn as ul, VisibilityOff as ml, Person as pl, ChevronUp as or, DoubleArrowLeft as gl, ChevronLeft as hl, DoubleArrowRight as fl, Error as No, People as bl, Bot as vl, Add as yl, ChatBotColored as kl, PersonAdd as wl, TextLogoFull as Cl, LiveChatMono as $l, ChatBotMono as Nl, HelpDeskMono as Sl, KnowledgeBaseMono as xl, OpenWidgetMono as El, HelloMono as Tl, TextLogo as Bl, Calendar as Il, Search as Al, LockBlack as Dl, ArrowDownward as Ol, ArrowUpward as Ml, ArrowsSort as Pl, Call as Fl, OneColored as So, Refresh as Rl, MoreHoriz as Gl } from "@livechat/design-system-icons";
import u from "clsx";
import { useFloatingParentNodeId as Lr, useFloatingNodeId as lr, useFloating as ir, offset as nr, flip as qr, size as xo, autoUpdate as cr, useClick as sr, useDismiss as dr, useRole as ur, useInteractions as mr, useTransitionStyles as zr, FloatingNode as Sa, FloatingTree as Hr, shift as B_, arrow as Ul, hide as Ll, useHover as ql, safePolygon as zl, useFocus as Hl, useTransitionStatus as Vl, FloatingArrow as Wl, FloatingPortal as $a, FloatingFocusManager as C_, useListNavigation as Kl, FloatingOverlay as Yl } from "@floating-ui/react";
import * as Xl from "react-dom";
import { flushSync as Zl, createPortal as jl } from "react-dom";
import { Virtuoso as Jl } from "react-virtuoso";
import { getContrast as I_ } from "polished";
import { DayPicker as Ql } from "react-day-picker";
import { isSameMonth as er, subMonths as ia, differenceInCalendarMonths as q_, addMonths as z_, isSameDay as $_, isAfter as N_, differenceInCalendarDays as Eo, isBefore as ei, isPast as ti, format as gr, startOfToday as To, subDays as hr, startOfMonth as H_, endOfMonth as ai } from "date-fns";
import "react-day-picker/style.css";
import V_ from "lodash.escape";
import { TransitionGroup as Bo, CSSTransition as Io } from "react-transition-group";
import { useFloating as ri, shift as _i, flip as oi, autoUpdate as li } from "@floating-ui/react-dom";
const ii = (e, a) => {
  v.useEffect(() => {
    const r = () => {
      document.visibilityState === "visible" && e();
    };
    return a && document.addEventListener("visibilitychange", r), () => {
      a && document.removeEventListener(
        "visibilitychange",
        r
      );
    };
  }, [e, a]);
}, sa = ({
  isVisible: e,
  elementRef: a,
  includeSleepWakeScenario: r = !1
}) => {
  const [_, o] = v.useState(e), [l, i] = v.useState(e), [n, d] = v.useState(e), s = v.useRef(null), c = () => {
    o(!1), s.current && clearTimeout(s.current);
  };
  return v.useEffect(() => {
    const p = a.current;
    if (!n && p)
      return p.addEventListener("transitionend", c), i(!1), s.current = window.setTimeout(c, 300), () => {
        clearTimeout(s.current), p.removeEventListener(
          "transitionend",
          c
        );
      };
    n && (o(!0), requestAnimationFrame(() => i(!0)));
  }, [n]), v.useEffect(() => {
    d(e);
  }, [e]), ii(
    () => d(e),
    r
  ), {
    isOpen: l,
    isMounted: _,
    setShouldBeVisible: d
  };
}, W_ = /* @__PURE__ */ (() => {
  let e = null;
  const a = /* @__PURE__ */ new Map();
  return {
    observe: (o, l) => {
      e || (e = new ResizeObserver((i) => {
        i.forEach((n) => {
          const d = n.target, s = a.get(d);
          s && s(n.contentRect);
        });
      })), o && (a.set(o, l), e.observe(o));
    },
    unobserve: (o) => {
      e && o && (e.unobserve(o), a.delete(o), a.size === 0 && (e.disconnect(), e = null));
    }
  };
})(), ar = (e, a) => {
  window.ResizeObserver && (e !== null ? W_.observe(e, (_) => {
    a(_);
  }) : W_.unobserve(e));
}, Ao = () => {
  const [e, a] = v.useState(0), r = v.useCallback(
    (_) => ar(
      _,
      (o) => a(o.height)
    ),
    []
  );
  return {
    size: e,
    handleResizeRef: r
  };
}, ni = ({
  mobileBreakpoint: e
}) => {
  const [a, r] = v.useState(!1), _ = v.useCallback(
    (o) => ar(
      o,
      (l) => r(l.width <= e)
    ),
    []
  );
  return {
    isMobile: a,
    handleResizeRef: _
  };
}, ci = ["input", "button", "select", "textarea", "a"], si = ({
  onClick: e
}) => ({
  handleInteractiveClick: v.useCallback(
    (r) => {
      const _ = r.target;
      if (!(_ instanceof HTMLElement)) return;
      const o = _.tagName.toLowerCase();
      ci.includes(o) || e(r);
    },
    [e]
  )
}), di = (e = !1) => {
  const [a, r] = de(e);
  return {
    isHovered: a,
    handleMouseOver: () => r(!0),
    handleMouseOut: () => r(!1)
  };
}, ui = (e) => {
  const [a, r] = de(!1), _ = kt(() => {
    if (e.current) {
      const l = e.current.scrollHeight > e.current.offsetHeight || e.current.scrollWidth > e.current.offsetWidth;
      r(l);
    }
  }, [e]), o = wo(() => {
    _();
  }, 100);
  return cl(() => {
    _();
    const l = e.current;
    return l && ar(l, () => {
      o();
    }), () => {
      ar(null, () => {
      });
    };
  }, [e, o, _]), V(() => () => {
    o.cancel();
  }, [o]), a;
}, jd = {
  Background01: "--background-01",
  Background02: "--background-02",
  Background03: "--background-03",
  SurfacePrimaryDefault: "--surface-primary-default",
  SurfaceSecondaryDefault: "--surface-secondary-default",
  SurfaceSecondaryHover: "--surface-secondary-hover",
  SurfaceSecondaryActive: "--surface-secondary-active",
  SurfaceSecondaryDisabled: "--surface-secondary-disabled",
  SurfacePrimaryHover: "--surface-primary-hover",
  SurfacePrimaryActive: "--surface-primary-active",
  SurfacePrimaryActiveColored: "--surface-primary-active-colored",
  SurfacePrimaryDisabled: "--surface-primary-disabled",
  SurfaceTertiaryDefault: "--surface-tertiary-default",
  SurfaceModerateDefault: "--surface-moderate-default",
  SurfaceModerateHover: "--surface-moderate-hover",
  SurfaceModerateActive: "--surface-moderate-active",
  SurfaceTertiaryHover: "--surface-tertiary-hover",
  SurfaceTertiaryActive: "--surface-tertiary-active",
  SurfaceTertiaryDisabled: "--surface-tertiary-disabled",
  SurfaceAccentEmphasisLowInfo: "--surface-accent-emphasis-low-info",
  SurfaceAccentEmphasisLowNegative: "--surface-accent-emphasis-low-negative",
  SurfaceAccentEmphasisLowWarning: "--surface-accent-emphasis-low-warning",
  SurfaceAccentEmphasisLowPositive: "--surface-accent-emphasis-low-positive",
  SurfaceAccentEmphasisLowPurple: "--surface-accent-emphasis-low-purple",
  SurfaceAccentEmphasisMinInfo: "--surface-accent-emphasis-min-info",
  SurfaceAccentEmphasisMinNegative: "--surface-accent-emphasis-min-negative",
  SurfaceAccentEmphasisMinWarning: "--surface-accent-emphasis-min-warning",
  SurfaceAccentEmphasisMinPositive: "--surface-accent-emphasis-min-positive",
  SurfaceAccentEmphasisMinPurple: "--surface-accent-emphasis-min-purple",
  SurfaceAccentOndarkNegativeDefault: "--surface-accent-ondark-negative-default",
  SurfaceAccentOndarkNegativeHover: "--surface-accent-ondark-negative-hover",
  SurfaceAccentOndarkWarningDefault: "--surface-accent-ondark-warning-default",
  SurfaceAccentOndarkWarningHover: "--surface-accent-ondark-warning-hover",
  SurfaceAccentOndarkInfoDefault: "--surface-accent-ondark-info-default",
  SurfaceAccentOndarkInfoHover: "--surface-accent-ondark-info-hover",
  SurfaceAccentOndarkPositiveDefault: "--surface-accent-ondark-positive-default",
  SurfaceAccentOndarkPositiveHover: "--surface-accent-ondark-positive-hover",
  SurfaceAccentEmphasisSubtleNegative: "--surface-accent-emphasis-subtle-negative",
  SurfaceAccentEmphasisSubtleWarning: "--surface-accent-emphasis-subtle-warning",
  SurfaceAccentEmphasisSubtleInfo: "--surface-accent-emphasis-subtle-info",
  SurfaceAccentEmphasisSubtlePositive: "--surface-accent-emphasis-subtle-positive",
  SurfaceInvertPrimary: "--surface-invert-primary",
  SurfaceInvertSecondary: "--surface-invert-secondary",
  SurfaceInvertDisabled: "--surface-invert-disabled",
  SurfaceLockedDefault: "--surface-locked-default",
  SurfaceLockedHover: "--surface-locked-hover",
  SurfaceLockedActive: "--surface-locked-active",
  SurfaceLockedDisabled: "--surface-locked-disabled",
  SurfaceLockedWhite: "--surface-locked-white",
  SurfaceLockedBlack: "--surface-locked-black",
  SurfaceAccentEmphasisMediumNegative: "--surface-accent-emphasis-medium-negative",
  SurfaceAccentEmphasisMediumPositive: "--surface-accent-emphasis-medium-positive",
  SurfaceAccentEmphasisHighInfo: "--surface-accent-emphasis-high-info",
  SurfaceAccentEmphasisHighNegative: "--surface-accent-emphasis-high-negative",
  SurfaceAccentEmphasisHighWarning: "--surface-accent-emphasis-high-warning",
  SurfaceAccentEmphasisHighPositive: "--surface-accent-emphasis-high-positive",
  SurfaceAccentEmphasisHighPurple: "--surface-accent-emphasis-high-purple",
  SurfaceOpacityBasicHover: "--surface-opacity-basic-hover",
  SurfaceOpacityBasicActive: "--surface-opacity-basic-active",
  SurfaceOpacityInvertHover: "--surface-opacity-invert-hover",
  SurfaceOpacityInvertActive: "--surface-opacity-invert-active",
  SurfaceGradient01: "--surface-gradient-01",
  SurfaceGradient02: "--surface-gradient-02",
  SurfaceGradient03: "--surface-gradient-03",
  SurfaceGradient04: "--surface-gradient-04",
  SurfaceGradient05: "--surface-gradient-05",
  SurfaceGradient06: "--surface-gradient-06",
  SurfaceGradient07: "--surface-gradient-07",
  SurfaceGradient08: "--surface-gradient-08",
  SurfaceGradient09: "--surface-gradient-09",
  SurfaceGradient10: "--surface-gradient-10",
  SurfaceGradient11: "--surface-gradient-11",
  SurfaceGradient12: "--surface-gradient-12",
  SurfaceGradient13: "--surface-gradient-13",
  SurfaceGradient14: "--surface-gradient-14",
  SurfaceOtherOverlay: "--surface-other-overlay",
  SurfaceOtherAgent: "--surface-other-agent",
  SurfaceOtherAgentHover: "--surface-other-agent-hover",
  SurfaceOtherSkeleton: "--surface-other-skeleton",
  SurfaceOtherInternalNoteHover: "--surface-other-internal-note-hover",
  SurfaceOtherVisitor: "--surface-other-visitor",
  SurfaceOtherVisitorHover: "--surface-other-visitor-hover",
  ContentBasicPrimary: "--content-basic-primary",
  ContentBasicSecondary: "--content-basic-secondary",
  ContentBasicDisabled: "--content-basic-disabled",
  ContentBasicNegative: "--content-basic-negative",
  ContentBasicWarning: "--content-basic-warning",
  ContentBasicPositive: "--content-basic-positive",
  ContentBasicInfo: "--content-basic-info",
  ContentBasicPurple: "--content-basic-purple",
  ContentBasicGradient01: "--content-basic-gradient-01",
  ContentLockedWhite: "--content-locked-white",
  ContentLockedBlack: "--content-locked-black",
  ContentLockedDefault: "--content-locked-default",
  ContentLockedHover: "--content-locked-hover",
  ContentLockedActive: "--content-locked-active",
  ContentLockedDisabled: "--content-locked-disabled",
  ContentInvertPrimary: "--content-invert-primary",
  ContentInvertSecondary: "--content-invert-secondary",
  ContentInvertDisabled: "--content-invert-disabled",
  ContentInvertGradient01: "--content-invert-gradient-01",
  BorderBasicPrimary: "--border-basic-primary",
  BorderBasicSecondary: "--border-basic-secondary",
  BorderBasicTertiary: "--border-basic-tertiary",
  BorderBasicHover: "--border-basic-hover",
  BorderBasicDisabled: "--border-basic-disabled",
  BorderBasicNegative: "--border-basic-negative",
  BorderBasicWarning: "--border-basic-warning",
  BorderBasicPositive: "--border-basic-positive",
  BorderBasicInfo: "--border-basic-info",
  BorderBasicPurple: "--border-basic-purple",
  BorderBasicContrast: "--border-basic-contrast",
  BorderInvertPrimary: "--border-invert-primary",
  BorderInvertSecondary: "--border-invert-secondary",
  BorderInvertHover: "--border-invert-hover",
  BorderInvertDisabled: "--border-invert-disabled",
  ActionPrimaryActive: "--action-primary-active",
  ActionPrimaryHover: "--action-primary-hover",
  ActionPrimaryDefault: "--action-primary-default",
  ColorActionDefaultRgb: "--color-action-default-rgb",
  ActionPrimaryDisabled: "--action-primary-disabled",
  ActionNegativeActive: "--action-negative-active",
  ActionNegativeHover: "--action-negative-hover",
  ActionNegativeDefault: "--action-negative-default",
  ActionNegativeDisabled: "--action-negative-disabled",
  ActionWarningDefault: "--action-warning-default",
  ActionWarningHover: "--action-warning-hover",
  ActionWarningDisabled: "--action-warning-disabled",
  ActionPositiveDefault: "--action-positive-default",
  ActionPositiveHover: "--action-positive-hover",
  ActionPositiveDisabled: "--action-positive-disabled",
  ActionNeutralDefault: "--action-neutral-default",
  ActionNeutralHover: "--action-neutral-hover",
  ActionNeutralDisabled: "--action-neutral-disabled",
  ActionHighContrastDefault: "--action-high-contrast-default",
  ActionHighContrastHover: "--action-high-contrast-hover",
  ActionHighContrastActive: "--action-high-contrast-active",
  ActionHighContrastDisabled: "--action-high-contrast-disabled",
  SurfaceOtherBot: "--surface-other-bot",
  SurfaceOtherBotHover: "--surface-other-bot-hover",
  ColorBlack: "--color-black",
  ColorWhite: "--color-white",
  DecorBlue900: "--decor-blue900",
  DecorBlue800: "--decor-blue800",
  DecorBlue700: "--decor-blue700",
  DecorBlue600: "--decor-blue600",
  DecorBlue500: "--decor-blue500",
  DecorBlue400: "--decor-blue400",
  DecorBlue300: "--decor-blue300",
  DecorBlue200: "--decor-blue200",
  DecorBlue100: "--decor-blue100",
  DecorBlue50: "--decor-blue50",
  DecorOrange900: "--decor-orange900",
  DecorOrange800: "--decor-orange800",
  DecorOrange700: "--decor-orange700",
  DecorOrange600: "--decor-orange600",
  DecorOrange500: "--decor-orange500",
  DecorOrange400: "--decor-orange400",
  DecorOrange300: "--decor-orange300",
  DecorOrange200: "--decor-orange200",
  DecorOrange100: "--decor-orange100",
  DecorOrange50: "--decor-orange50",
  DecorYellow900: "--decor-yellow900",
  DecorYellow800: "--decor-yellow800",
  DecorYellow700: "--decor-yellow700",
  DecorYellow600: "--decor-yellow600",
  DecorYellow500: "--decor-yellow500",
  DecorYellow400: "--decor-yellow400",
  DecorYellow300: "--decor-yellow300",
  DecorYellow200: "--decor-yellow200",
  DecorYellow100: "--decor-yellow100",
  DecorYellow50: "--decor-yellow50",
  DecorGray950: "--decor-gray950",
  DecorGray900: "--decor-gray900",
  DecorGray800: "--decor-gray800",
  DecorGray700: "--decor-gray700",
  DecorGray600: "--decor-gray600",
  DecorGray500: "--decor-gray500",
  DecorGray400: "--decor-gray400",
  DecorGray300: "--decor-gray300",
  DecorGray200: "--decor-gray200",
  DecorGray150: "--decor-gray150",
  DecorGray100: "--decor-gray100",
  DecorGray75: "--decor-gray75",
  DecorGray50: "--decor-gray50",
  DecorGray40: "--decor-gray40",
  DecorGray20: "--decor-gray20",
  DecorGreen900: "--decor-green900",
  DecorGreen800: "--decor-green800",
  DecorGreen700: "--decor-green700",
  DecorGreen600: "--decor-green600",
  DecorGreen500: "--decor-green500",
  DecorGreen400: "--decor-green400",
  DecorGreen300: "--decor-green300",
  DecorGreen200: "--decor-green200",
  DecorGreen100: "--decor-green100",
  DecorGreen50: "--decor-green50",
  DecorRed900: "--decor-red900",
  DecorRed800: "--decor-red800",
  DecorRed700: "--decor-red700",
  DecorRed600: "--decor-red600",
  DecorRed500: "--decor-red500",
  DecorRed400: "--decor-red400",
  DecorRed300: "--decor-red300",
  DecorRed200: "--decor-red200",
  DecorRed100: "--decor-red100",
  DecorRed50: "--decor-red50",
  DecorPurple900: "--decor-purple900",
  DecorPurple800: "--decor-purple800",
  DecorPurple700: "--decor-purple700",
  DecorPurple600: "--decor-purple600",
  DecorPurple500: "--decor-purple500",
  DecorPurple400: "--decor-purple400",
  DecorPurple300: "--decor-purple300",
  DecorPurple200: "--decor-purple200",
  DecorPurple100: "--decor-purple100",
  DecorPurple50: "--decor-purple50",
  DecorBrown50: "--decor-brown50",
  DecorBrown300: "--decor-brown300",
  ProductsLivechat: "--products-livechat",
  ProductsHelpdesk: "--products-helpdesk",
  ProductsChatbot: "--products-chatbot",
  ProductsKnowledgebase: "--products-knowledgebase",
  IllustrationsPrimary: "--illustrations-primary",
  IllustrationsSecondary: "--illustrations-secondary",
  IllustrationsStroke: "--illustrations-stroke",
  TagSurface01: "--tag-surface-01",
  TagContent01: "--tag-content-01",
  BtnBasicBackgroundEnabled: "--btn-basic-background-enabled",
  BtnBasicBackgroundHover: "--btn-basic-background-hover",
  BtnBasicBackgroundDisabled: "--btn-basic-background-disabled",
  BtnBasicBackgroundActive: "--btn-basic-background-active",
  BtnBasicBackgroundLoading: "--btn-basic-background-loading",
  BtnSecondaryBackgroundEnabled: "--btn-secondary-background-enabled",
  BtnSecondaryBackgroundHover: "--btn-secondary-background-hover",
  BtnSecondaryBackgroundDisabled: "--btn-secondary-background-disabled",
  BtnSecondaryBackgroundActive: "--btn-secondary-background-active",
  BtnSecondaryBackgroundLoading: "--btn-secondary-background-loading",
  BtnPlainIconBackgroundHover: "--btn-plain-icon-background-hover",
  BtnPlainIconBackgroundActive: "--btn-plain-icon-background-active",
  PickerListBackground: "--picker-list-background",
  PickerListGroupBackground: "--picker-list-group-background",
  PickerListOptionBackgroundHover: "--picker-list-option-background-hover",
  PickerListOptionBackgroundActiveHover: "--picker-list-option-background-active-hover",
  PickerListOptionBackgroundFocus: "--picker-list-option-background-focus",
  PickerListOptionBackgroundActive: "--picker-list-option-background-active",
  PopoverBackground: "--popover-background",
  SurfaceAvatar1: "--surface-avatar-1",
  SurfaceAvatar2: "--surface-avatar-2",
  SurfaceAvatar3: "--surface-avatar-3",
  SurfaceAvatar4: "--surface-avatar-4",
  SurfaceAvatar5: "--surface-avatar-5",
  SurfaceAvatar6: "--surface-avatar-6",
  SurfaceAvatar7: "--surface-avatar-7",
  SurfaceAvatar8: "--surface-avatar-8",
  SurfaceAvatar9: "--surface-avatar-9",
  SurfaceAvatar10: "--surface-avatar-10",
  NavbarBackground: "--navbar-background",
  TooltipBackgroundBasic: "--tooltip-background-basic",
  TooltipBackgroundInvert: "--tooltip-background-invert",
  TooltipBorder: "--tooltip-border",
  TooltipBorderForSvg: "--tooltip-border-for-svg",
  AnimatedGradientValue1: "--animated-gradient-value-1",
  AnimatedGradientValue2: "--animated-gradient-value-2",
  AnimatedGradientValue3: "--animated-gradient-value-3",
  ContentBasicInternalNote: "--content-basic-internal-note",
  ContentBasicBot: "--content-basic-bot",
  ActionLockDefault: "--action-lock-default",
  ActionLockHover: "--action-lock-hover",
  ActionLockActive: "--action-lock-active",
  ActionLockDisabled: "--action-lock-disabled",
  SurfaceOtherInternalNoteMessageArea: "--surface-other-internal-note-message-area",
  SurfaceOtherInternalNoteDefault: "--surface-other-internal-note-default",
  ContentBasicInternalNoteMessagePlaceholder: "--content-basic-internal-note-message-placeholder",
  ContentBasicInternalNoteMessageActive: "--content-basic-internal-note-message-active",
  OnePopoverMessageBackgroundDefault: "--one-popover-message-background-default",
  OnePopoverBorderDefault: "--one-popover-border-default",
  OnePopoverBorderActive: "--one-popover-border-active",
  OneTooltipBackground: "--one-tooltip-background",
  ContentBasicAutofill: "--content-basic-autofill",
  ProductsHello: "--products-hello",
  ProductsPlatform: "--products-platform",
  SurfaceCheckListItemOpenBackground: "--surface-check-list-item-open-background",
  SurfaceCheckListBackground: "--surface-check-list-background",
  ContentBasicPlaceholder: "--content-basic-placeholder",
  InputPromoBorderDefault: "--input-promo-border-default",
  InputPromoBorderHover: "--input-promo-border-hover",
  SurfaceAiCopilotBasicDefault: "--surface-ai-copilot-basic-default",
  SurfaceAiCopilotBasicHover: "--surface-ai-copilot-basic-hover",
  SurfaceAiCopilotBasicActive: "--surface-ai-copilot-basic-active",
  SurfaceAiCopilotInvert01: "--surface-ai-copilot-invert-01",
  SurfaceAiCopilotInvert02: "--surface-ai-copilot-invert-02",
  SurfaceAiOther01Default: "--surface-ai-other-01-default",
  SurfaceAiOther01Hover: "--surface-ai-other-01-hover",
  SurfaceAiOther01Active: "--surface-ai-other-01-active",
  SurfaceAiOther02Default: "--surface-ai-other-02-default",
  BorderAiCopilotBasicDefault: "--border-ai-copilot-basic-default",
  BorderAiCopilotBasicHover: "--border-ai-copilot-basic-hover",
  BorderAiCopilotBasicActive: "--border-ai-copilot-basic-active",
  BorderAiOther01: "--border-ai-other-01",
  ContentAiCopilotBasic: "--content-ai-copilot-basic",
  ContentAiCopilotInvert: "--content-ai-copilot-invert",
  ContentAiOther1Default: "--content-ai-other-1-default",
  CategoricalMain1: "--categorical-main-1",
  CategoricalMain2: "--categorical-main-2",
  CategoricalMain3: "--categorical-main-3",
  CategoricalMain4: "--categorical-main-4",
  CategoricalMain5: "--categorical-main-5",
  CategoricalMain6: "--categorical-main-6",
  CategoricalMain7: "--categorical-main-7",
  CategoricalMain8: "--categorical-main-8",
  CategoricalMain9: "--categorical-main-9",
  CategoricalMain10: "--categorical-main-10",
  CategoricalMain11: "--categorical-main-11",
  CategoricalMain12: "--categorical-main-12",
  CategoricalMain13: "--categorical-main-13",
  CategoricalMain14: "--categorical-main-14",
  SequentialBlue25: "--sequential-blue-25",
  SequentialBlue50: "--sequential-blue-50",
  SequentialBlue100: "--sequential-blue-100",
  SequentialBlue200: "--sequential-blue-200",
  SequentialBlue300: "--sequential-blue-300",
  SequentialBlue400: "--sequential-blue-400",
  SequentialBlue500: "--sequential-blue-500",
  SequentialBlue600: "--sequential-blue-600",
  SequentialBlue700: "--sequential-blue-700",
  SequentialBlue800: "--sequential-blue-800",
  SequentialBlue900: "--sequential-blue-900",
  SequentialBlue950: "--sequential-blue-950",
  SequentialYellow25: "--sequential-yellow-25",
  SequentialYellow50: "--sequential-yellow-50",
  SequentialYellow100: "--sequential-yellow-100",
  SequentialYellow200: "--sequential-yellow-200",
  SequentialYellow300: "--sequential-yellow-300",
  SequentialYellow400: "--sequential-yellow-400",
  SequentialYellow500: "--sequential-yellow-500",
  SequentialYellow600: "--sequential-yellow-600",
  SequentialYellow700: "--sequential-yellow-700",
  SequentialYellow800: "--sequential-yellow-800",
  SequentialYellow900: "--sequential-yellow-900",
  SequentialYellow950: "--sequential-yellow-950",
  SequentialGreen25: "--sequential-green-25",
  SequentialGreen50: "--sequential-green-50",
  SequentialGreen100: "--sequential-green-100",
  SequentialGreen200: "--sequential-green-200",
  SequentialGreen300: "--sequential-green-300",
  SequentialGreen400: "--sequential-green-400",
  SequentialGreen500: "--sequential-green-500",
  SequentialGreen600: "--sequential-green-600",
  SequentialGreen700: "--sequential-green-700",
  SequentialGreen800: "--sequential-green-800",
  SequentialGreen900: "--sequential-green-900",
  SequentialGreen950: "--sequential-green-950",
  SequentialMagenta25: "--sequential-magenta-25",
  SequentialMagenta50: "--sequential-magenta-50",
  SequentialMagenta100: "--sequential-magenta-100",
  SequentialMagenta200: "--sequential-magenta-200",
  SequentialMagenta300: "--sequential-magenta-300",
  SequentialMagenta400: "--sequential-magenta-400",
  SequentialMagenta500: "--sequential-magenta-500",
  SequentialMagenta600: "--sequential-magenta-600",
  SequentialMagenta700: "--sequential-magenta-700",
  SequentialMagenta800: "--sequential-magenta-800",
  SequentialMagenta900: "--sequential-magenta-900",
  SequentialMagenta950: "--sequential-magenta-950",
  SequentialOrange25: "--sequential-orange-25",
  SequentialOrange50: "--sequential-orange-50",
  SequentialOrange100: "--sequential-orange-100",
  SequentialOrange200: "--sequential-orange-200",
  SequentialOrange300: "--sequential-orange-300",
  SequentialOrange400: "--sequential-orange-400",
  SequentialOrange500: "--sequential-orange-500",
  SequentialOrange600: "--sequential-orange-600",
  SequentialOrange700: "--sequential-orange-700",
  SequentialOrange800: "--sequential-orange-800",
  SequentialOrange900: "--sequential-orange-900",
  SequentialOrange950: "--sequential-orange-950",
  SequentialPurple25: "--sequential-purple-25",
  SequentialPurple50: "--sequential-purple-50",
  SequentialPurple100: "--sequential-purple-100",
  SequentialPurple200: "--sequential-purple-200",
  SequentialPurple300: "--sequential-purple-300",
  SequentialPurple400: "--sequential-purple-400",
  SequentialPurple500: "--sequential-purple-500",
  SequentialPurple600: "--sequential-purple-600",
  SequentialPurple700: "--sequential-purple-700",
  SequentialPurple800: "--sequential-purple-800",
  SequentialPurple900: "--sequential-purple-900",
  SequentialPurple950: "--sequential-purple-950",
  SequentialRed25: "--sequential-red-25",
  SequentialRed50: "--sequential-red-50",
  SequentialRed100: "--sequential-red-100",
  SequentialRed200: "--sequential-red-200",
  SequentialRed300: "--sequential-red-300",
  SequentialRed400: "--sequential-red-400",
  SequentialRed500: "--sequential-red-500",
  SequentialRed600: "--sequential-red-600",
  SequentialRed700: "--sequential-red-700",
  SequentialRed800: "--sequential-red-800",
  SequentialRed900: "--sequential-red-900",
  SequentialRed950: "--sequential-red-950",
  Categorical1colorColor1: "--categorical-1color-color1",
  Categorical1colorColor2: "--categorical-1color-color2",
  Categorical1colorColor3: "--categorical-1color-color3",
  Categorical1colorColor4: "--categorical-1color-color4",
  Categorical2colorsOption1Color1: "--categorical-2colors-option1-color1",
  Categorical2colorsOption1Color2: "--categorical-2colors-option1-color2",
  Categorical2colorsOption2Color1: "--categorical-2colors-option2-color1",
  Categorical2colorsOption2Color2: "--categorical-2colors-option2-color2",
  Categorical2colorsOption3Color1: "--categorical-2colors-option3-color1",
  Categorical2colorsOption3Color2: "--categorical-2colors-option3-color2",
  Categorical2colorsOption4Color1: "--categorical-2colors-option4-color1",
  Categorical2colorsOption4Color2: "--categorical-2colors-option4-color2",
  Categorical2colorsOption5Color1: "--categorical-2colors-option5-color1",
  Categorical2colorsOption5Color2: "--categorical-2colors-option5-color2",
  Categorical2colorsOption6Color1: "--categorical-2colors-option6-color1",
  Categorical2colorsOption6Color2: "--categorical-2colors-option6-color2",
  Categorical3colorsOption1Color1: "--categorical-3colors-option1-color1",
  Categorical3colorsOption1Color2: "--categorical-3colors-option1-color2",
  Categorical3colorsOption1Color3: "--categorical-3colors-option1-color3",
  Categorical3colorsOption2Color1: "--categorical-3colors-option2-color1",
  Categorical3colorsOption2Color2: "--categorical-3colors-option2-color2",
  Categorical3colorsOption2Color3: "--categorical-3colors-option2-color3",
  Categorical3colorsOption3Color1: "--categorical-3colors-option3-color1",
  Categorical3colorsOption3Color2: "--categorical-3colors-option3-color2",
  Categorical3colorsOption3Color3: "--categorical-3colors-option3-color3",
  Categorical3colorsOption4Color1: "--categorical-3colors-option4-color1",
  Categorical3colorsOption4Color2: "--categorical-3colors-option4-color2",
  Categorical3colorsOption4Color3: "--categorical-3colors-option4-color3",
  Categorical3colorsOption5Color1: "--categorical-3colors-option5-color1",
  Categorical3colorsOption5Color2: "--categorical-3colors-option5-color2",
  Categorical3colorsOption5Color3: "--categorical-3colors-option5-color3",
  Categorical3colorsOption6Color1: "--categorical-3colors-option6-color1",
  Categorical3colorsOption6Color2: "--categorical-3colors-option6-color2",
  Categorical3colorsOption6Color3: "--categorical-3colors-option6-color3",
  Categorical4colorsOption1Color1: "--categorical-4colors-option1-color1",
  Categorical4colorsOption1Color2: "--categorical-4colors-option1-color2",
  Categorical4colorsOption1Color3: "--categorical-4colors-option1-color3",
  Categorical4colorsOption1Color4: "--categorical-4colors-option1-color4",
  Categorical4colorsOption2Color1: "--categorical-4colors-option2-color1",
  Categorical4colorsOption2Color2: "--categorical-4colors-option2-color2",
  Categorical4colorsOption2Color3: "--categorical-4colors-option2-color3",
  Categorical4colorsOption2Color4: "--categorical-4colors-option2-color4",
  Categorical4colorsOption3Color1: "--categorical-4colors-option3-color1",
  Categorical4colorsOption3Color2: "--categorical-4colors-option3-color2",
  Categorical4colorsOption3Color3: "--categorical-4colors-option3-color3",
  Categorical4colorsOption3Color4: "--categorical-4colors-option3-color4",
  Categorical5colorsOption1Color1: "--categorical-5colors-option1-color1",
  Categorical5colorsOption1Color2: "--categorical-5colors-option1-color2",
  Categorical5colorsOption1Color3: "--categorical-5colors-option1-color3",
  Categorical5colorsOption1Color4: "--categorical-5colors-option1-color4",
  Categorical5colorsOption1Color5: "--categorical-5colors-option1-color5",
  Categorical5colorsOption2Color1: "--categorical-5colors-option2-color1",
  Categorical5colorsOption2Color2: "--categorical-5colors-option2-color2",
  Categorical5colorsOption2Color3: "--categorical-5colors-option2-color3",
  Categorical5colorsOption2Color4: "--categorical-5colors-option2-color4",
  Categorical5colorsOption2Color5: "--categorical-5colors-option2-color5",
  UifoundationSurfaceDefault: "--uifoundation-surface-default",
  UifoundationBorderGrid: "--uifoundation-border-grid",
  UifoundationBorderAxis: "--uifoundation-border-axis"
}, Jd = {
  Spacing0: "--spacing-0",
  Spacing05: "--spacing-05",
  Spacing1: "--spacing-1",
  Spacing2: "--spacing-2",
  Spacing3: "--spacing-3",
  Spacing4: "--spacing-4",
  Spacing5: "--spacing-5",
  Spacing6: "--spacing-6",
  Spacing7: "--spacing-7",
  Spacing8: "--spacing-8",
  Spacing9: "--spacing-9",
  Spacing10: "--spacing-10",
  Spacing11: "--spacing-11",
  Spacing12: "--spacing-12",
  Spacing14: "--spacing-14",
  Spacing16: "--spacing-16",
  Spacing18: "--spacing-18",
  Spacing20: "--spacing-20",
  Spacing24: "--spacing-24"
}, Qd = {
  Float: "--shadow-float",
  PopOver: "--shadow-pop-over",
  Modal: "--shadow-modal",
  Tooltip: "--shadow-tooltip",
  TooltipArrowBottom: "--shadow-tooltip-arrow-bottom",
  TooltipArrowTop: "--shadow-tooltip-arrow-top",
  TooltipArrowRight: "--shadow-tooltip-arrow-right",
  TooltipArrowLeft: "--shadow-tooltip-arrow-left",
  TooltipArrow: "--shadow-tooltip-arrow",
  Focus: "--shadow-focus",
  DividerBottom: "--shadow-divider-bottom",
  DividerTop: "--shadow-divider-top",
  DividerRight: "--shadow-divider-right",
  DividerLeft: "--shadow-divider-left",
  DividerBottomLeft: "--shadow-divider-bottom-left",
  DividerTopLeft: "--shadow-divider-top-left",
  DividerTopRight: "--shadow-divider-top-right",
  DividerBottomRight: "--shadow-divider-bottom-right",
  MessageBox: "--shadow-message-box",
  FixedRight: "--shadow-fixed-right",
  FixedLeft: "--shadow-fixed-left",
  FixedTop: "--shadow-fixed-top",
  FixedBottom: "--shadow-fixed-bottom",
  ShadowAiCopilotAnimationStart: "--shadow-ai-copilot-animation-start",
  ShadowAiCopilotAnimationMedium1: "--shadow-ai-copilot-animation-medium1",
  ShadowAiCopilotAnimationMedium2: "--shadow-ai-copilot-animation-medium2",
  ShadowAiCopilotAnimationMedium3: "--shadow-ai-copilot-animation-medium3",
  ShadowAiCopilotAnimationEnd: "--shadow-ai-copilot-animation-end",
  ShadowAiOtherFloat: "--shadow-ai-other-float",
  ShadowAiOtherActiveField: "--shadow-ai-other-active-field",
  ShadowTourAnimationEnd: "--shadow-tour-animation-end"
}, eu = {
  Radius0: "--radius-0",
  Radius1: "--radius-1",
  Radius2: "--radius-2",
  Radius3: "--radius-3",
  Radius4: "--radius-4",
  UiFoundationRadiusBar: "--uifoundation-radius-bar",
  0: "--radius-0",
  // deprecated
  1: "--radius-1",
  // deprecated
  2: "--radius-2",
  // deprecated
  3: "--radius-3",
  // deprecated
  4: "--radius-4"
  // deprecated
}, tu = {
  Fast1: "--transition-duration-fast-1",
  Fast2: "--transition-duration-fast-2",
  Moderate1: "--transition-duration-moderate-1"
}, au = {
  EaseIn: "--transition-timing-ease-in",
  EaseOut: "--transition-timing-ease-out"
}, ru = {
  Instant: "--delay-instant",
  Moderate: "--delay-moderate",
  Slow: "--delay-slow"
};
var Qt = /* @__PURE__ */ ((e) => (e.Dark = "lc-dark-theme", e.Light = "lc-light-theme", e))(Qt || {});
const _u = (e) => e === "dark" ? Qt.Dark : Qt.Light, Do = yo(void 0), ou = () => {
  const e = ko(Do);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}, lu = ({
  children: e,
  initialTheme: a = "light",
  customVariables: r = {}
}) => {
  const [_, o] = de(a), [l, i] = de(r);
  V(() => {
    document.body.classList.remove(Qt.Light, Qt.Dark), document.body.classList.add(`lc-${_}-theme`);
    for (const [d, s] of Object.entries(l))
      document.body.style.setProperty(d, s);
  }, [_, l]);
  const n = wa(
    () => ({
      theme: _,
      toggleTheme: () => o((d) => d === "light" ? "dark" : "light"),
      setTheme: o,
      setCustomVariables: (d) => {
        i(d);
      }
    }),
    [_, o, i]
  );
  return /* @__PURE__ */ t(Do.Provider, { value: n, children: e });
}, Oo = v.createContext(
  void 0
), A_ = () => {
  const e = v.useContext(Oo);
  if (!e)
    throw new Error("useAppFrame must be used within a AppFrameProvider");
  return e;
}, mi = ({
  children: e,
  isSideNavigationVisible: a = !0,
  isMobileViewVisible: r = !1
}) => {
  const [_, o] = v.useState(a), [l, i] = v.useState(r), n = v.useMemo(
    () => ({
      isSideNavigationVisible: _,
      toggleSideNavigationVisibility: () => o(!_),
      isMobileViewEnabled: l,
      setIsMobileViewEnabled: (d) => i(d)
    }),
    [
      _,
      o,
      l,
      i
    ]
  );
  return /* @__PURE__ */ t(Oo.Provider, { value: n, children: e });
}, iu = (e, a) => `color-mix(in srgb, var(${e}) ${a}, transparent)`, pi = "lc-Icon-module__icon___J5RH5", K_ = {
  icon: pi,
  "icon--primary": "lc-Icon-module__icon--primary___lclud",
  "icon--subtle": "lc-Icon-module__icon--subtle___d17Qj",
  "icon--inverted": "lc-Icon-module__icon--inverted___Cb4ml",
  "icon--inverted-subtle": "lc-Icon-module__icon--inverted-subtle___kw-gq",
  "icon--link": "lc-Icon-module__icon--link___TM17Q",
  "icon--success": "lc-Icon-module__icon--success___Jbdc3",
  "icon--warning": "lc-Icon-module__icon--warning___2xp2W",
  "icon--error": "lc-Icon-module__icon--error___95ah2",
  "icon--negative": "lc-Icon-module__icon--negative___Ds5e2",
  "icon--positive": "lc-Icon-module__icon--positive___Uy-GO",
  "icon--info": "lc-Icon-module__icon--info___sIO63",
  "icon--action-primary": "lc-Icon-module__icon--action-primary___iKKt4",
  "icon--action-negative": "lc-Icon-module__icon--action-negative___n9ONx",
  "icon--action-positive": "lc-Icon-module__icon--action-positive___Xq7UP",
  "icon--action-warning": "lc-Icon-module__icon--action-warning___UsFlk",
  "icon--action-neutral": "lc-Icon-module__icon--action-neutral___Hhno9",
  "icon--disabled--primary": "lc-Icon-module__icon--disabled--primary___M6mL2",
  "icon--disabled--subtle": "lc-Icon-module__icon--disabled--subtle___gs7xm",
  "icon--disabled--inverted": "lc-Icon-module__icon--disabled--inverted___SJMuj",
  "icon--disabled--inverted-subtle": "lc-Icon-module__icon--disabled--inverted-subtle___4YUA4",
  "icon--disabled--link": "lc-Icon-module__icon--disabled--link___sLus3",
  "icon--disabled--success": "lc-Icon-module__icon--disabled--success___XqRSR",
  "icon--disabled--warning": "lc-Icon-module__icon--disabled--warning___72dUP",
  "icon--disabled--error": "lc-Icon-module__icon--disabled--error___-0U0g",
  "icon--disabled--negative": "lc-Icon-module__icon--disabled--negative___V7paN",
  "icon--disabled--positive": "lc-Icon-module__icon--disabled--positive___X0-e0",
  "icon--disabled--info": "lc-Icon-module__icon--disabled--info___IlUe5",
  "icon--disabled--action-primary": "lc-Icon-module__icon--disabled--action-primary___4GYxP",
  "icon--disabled--action-negative": "lc-Icon-module__icon--disabled--action-negative___WP3Hi",
  "icon--disabled--action-positive": "lc-Icon-module__icon--disabled--action-positive___3Gz5e",
  "icon--disabled--action-warning": "lc-Icon-module__icon--disabled--action-warning___GHGY2",
  "icon--disabled--action-neutral": "lc-Icon-module__icon--disabled--action-neutral___a53XD",
  "icon--disabled--lock-black": "lc-Icon-module__icon--disabled--lock-black___JaNzw"
}, gi = {
  xsmall: {
    width: 12,
    height: 12
  },
  small: {
    width: 16,
    height: 16
  },
  medium: {
    width: 20,
    height: 20
  },
  large: {
    width: 24,
    height: 24
  },
  xlarge: {
    width: 32,
    height: 32
  },
  xxlarge: {
    width: 48,
    height: 48
  },
  xxxlarge: {
    width: 64,
    height: 64
  }
}, Y_ = "icon", R = (e) => {
  const c = e, {
    source: a,
    size: r = "medium",
    kind: _,
    disabled: o,
    className: l,
    customColor: i
  } = c, n = U(c, [
    "source",
    "size",
    "kind",
    "disabled",
    "className",
    "customColor"
  ]), d = v.createElement(a, y(y({}, gi[r]), i ? { color: i } : {})), s = u(
    l,
    K_[Y_],
    _ && K_[`${Y_}--${o ? "disabled--" : ""}${_}`]
  );
  return /* @__PURE__ */ t("span", B(y({}, n), { className: s, children: d }));
}, nt = {
  "heading-xl": "lc-Typography-module__heading-xl___jTpRq",
  "heading-lg": "lc-Typography-module__heading-lg___VGjgP",
  "heading-md": "lc-Typography-module__heading-md___U-DUC",
  "heading-sm": "lc-Typography-module__heading-sm___SgG32",
  "heading-xs": "lc-Typography-module__heading-xs___cKzMb",
  "heading-2xs": "lc-Typography-module__heading-2xs___K6Lmw",
  "heading-3xs": "lc-Typography-module__heading-3xs___roTs0",
  "heading-uppercase": "lc-Typography-module__heading-uppercase___DC8Ro",
  "heading-bold": "lc-Typography-module__heading-bold___5Ez7T",
  "paragraph-lg": "lc-Typography-module__paragraph-lg___KmMBe",
  "paragraph-md": "lc-Typography-module__paragraph-md___Ogs8k",
  "paragraph-sm": "lc-Typography-module__paragraph-sm___5KRhm",
  "paragraph-xs": "lc-Typography-module__paragraph-xs___TlVSn",
  "paragraph--semi-bold": "lc-Typography-module__paragraph--semi-bold___Ya1Sm",
  "paragraph--bold": "lc-Typography-module__paragraph--bold___HVepi",
  "paragraph--underline": "lc-Typography-module__paragraph--underline___M3l4C",
  "paragraph--strike": "lc-Typography-module__paragraph--strike___gmYoG",
  "paragraph--uppercase": "lc-Typography-module__paragraph--uppercase___8bXNL",
  "paragraph--no-margin": "lc-Typography-module__paragraph--no-margin___7wc0Y",
  "display-md": "lc-Typography-module__display-md___i1Zgu",
  "display-sm": "lc-Typography-module__display-sm___f46hM",
  "display-lg": "lc-Typography-module__display-lg___wAcSa",
  "display-max": "lc-Typography-module__display-max___W4YZ0",
  "display--bold": "lc-Typography-module__display--bold___tIiWp"
}, hi = {
  xl: "h1",
  lg: "h2",
  md: "h3",
  sm: "h4",
  xs: "h5",
  "2xs": "h6",
  // HTML only provides h1-h6 elements, so smaller heading sizes reuse h6
  "3xs": "h6"
}, he = (s) => {
  var c = s, {
    as: e,
    size: a = "md",
    children: r,
    className: _,
    uppercase: o,
    bold: l,
    customColor: i,
    textAlign: n
  } = c, d = U(c, [
    "as",
    "size",
    "children",
    "className",
    "uppercase",
    "bold",
    "customColor",
    "textAlign"
  ]);
  return v.createElement(
    e || hi[a],
    y({
      className: u(
        {
          [nt[`heading-${a}`]]: !0,
          [nt["heading-uppercase"]]: o,
          [nt["heading-bold"]]: l
        },
        _
      ),
      style: y(y({}, i && { color: i }), n && { textAlign: n })
    }, d),
    r
  );
}, D = (g) => {
  var w = g, {
    as: e = "p",
    size: a = "md",
    caps: r = !1,
    uppercase: _ = !1,
    bold: o = !1,
    semiBold: l = !1,
    underline: i = !1,
    strike: n = !1,
    children: d,
    className: s,
    customColor: c,
    textAlign: p,
    noMargin: m
  } = w, f = U(w, [
    "as",
    "size",
    "caps",
    "uppercase",
    "bold",
    "semiBold",
    "underline",
    "strike",
    "children",
    "className",
    "customColor",
    "textAlign",
    "noMargin"
  ]);
  const x = "paragraph";
  return v.createElement(
    e,
    y({
      className: u(
        {
          [nt[`${x}-${a}`]]: !0,
          [nt[`${x}--semi-bold`]]: l && !o,
          [nt[`${x}--bold`]]: o && !l,
          [nt[`${x}--strike`]]: n,
          [nt[`${x}--underline`]]: i,
          [nt[`${x}--uppercase`]]: _ || r,
          [nt[`${x}--no-margin`]]: m
        },
        s
      ),
      style: y(y({}, c && { color: c }), p && { textAlign: p })
    }, f),
    d
  );
}, X_ = (d) => {
  var s = d, {
    as: e = "div",
    size: a = "md",
    children: r,
    className: _,
    customColor: o,
    textAlign: l,
    bold: i = !0
  } = s, n = U(s, [
    "as",
    "size",
    "children",
    "className",
    "customColor",
    "textAlign",
    "bold"
  ]);
  return v.createElement(
    e,
    y({
      className: u(
        nt[`display-${a}`],
        {
          [nt["display--bold"]]: i
        },
        _
      ),
      style: y(y({}, o && { color: o }), l && { textAlign: l })
    }, n),
    r
  );
}, nu = [
  "xl",
  "lg",
  "md",
  "sm",
  "xs",
  "2xs",
  "3xs"
], Ea = {
  "accordion-animated-label": "lc-AccordionAnimatedLabel-module__accordion-animated-label___zYrr7",
  "accordion-animated-label__open": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open___l8gMd",
  "accordion-animated-label__close": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close___c5sxF",
  "accordion-animated-label__open--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open--visible___y16mk",
  "accordion-animated-label__close--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close--visible___JWsqj"
}, Ta = "accordion-animated-label", fi = ({
  open: e,
  closed: a,
  isOpen: r
}) => {
  const _ = v.useRef(null), o = v.useRef(null), [l, i] = v.useState(void 0), { isOpen: n, isMounted: d } = sa({
    isVisible: r,
    elementRef: _
  }), { isOpen: s, isMounted: c } = sa(
    {
      isVisible: !r,
      elementRef: o
    }
  );
  return v.useEffect(() => {
    const p = r ? _.current : o.current;
    if (p) {
      const m = p.getBoundingClientRect().height;
      i(m);
    }
  }, [r, d, c]), /* @__PURE__ */ h(
    "div",
    {
      className: Ea[Ta],
      style: { height: l ? `${l}px` : "auto" },
      children: [
        d && /* @__PURE__ */ t(
          "div",
          {
            ref: _,
            className: u(Ea[`${Ta}__open`], {
              [Ea[`${Ta}__open--visible`]]: n
            }),
            children: e
          }
        ),
        c && /* @__PURE__ */ t(
          "div",
          {
            ref: o,
            className: u(Ea[`${Ta}__close`], {
              [Ea[`${Ta}__close--visible`]]: s
            }),
            children: a
          }
        )
      ]
    }
  );
}, Z_ = {
  "accordion-multiline": "lc-AccordionMultilineElement-module__accordion-multiline___lXTFn",
  "accordion-multiline__inner": "lc-AccordionMultilineElement-module__accordion-multiline__inner___tu-HW"
}, j_ = "accordion-multiline", bi = ({ children: e, isExpanded: a }) => {
  const r = v.useRef(null), { isOpen: _, isMounted: o } = sa({
    isVisible: !a,
    elementRef: r
  }), { size: l, handleResizeRef: i } = Ao();
  return /* @__PURE__ */ t(
    "div",
    {
      className: Z_[`${j_}`],
      style: { maxHeight: _ ? l : 0 },
      ref: r,
      children: /* @__PURE__ */ t("div", { ref: i, children: o && /* @__PURE__ */ t("div", { className: Z_[`${j_}__inner`], children: e }) })
    }
  );
}, vi = (e) => e.open !== void 0 && e.closed !== void 0, yi = (e, a) => {
  if (vi(e)) {
    const r = {
      open: e.open,
      closed: e.closed,
      isOpen: a
    };
    return /* @__PURE__ */ t(fi, y({}, r));
  }
  return e;
}, ki = ({
  isControlled: e,
  isExpanded: a,
  setShouldBeVisible: r,
  onOpen: _,
  onClose: o
}) => {
  const l = (n) => {
    n ? o == null || o() : _ == null || _(), !e && r(!n);
  }, i = v.useCallback(
    (n) => {
      (!a && (n.key === "Enter" || n.key === " ") || a && n.key === "Escape") && l(a);
    },
    [a, l]
  );
  return {
    handleExpandChange: l,
    handleKeyDown: i
  };
}, wi = "lc-Accordion-module__accordion___wD27Q", Ci = "lc-Accordion-module__accordion__chevron___3-rGN", $i = "lc-Accordion-module__accordion__label___1MyYP", Ni = "lc-Accordion-module__accordion__content___vfjP2", Si = "lc-Accordion-module__accordion__content__inner___Z-9cB", xi = "lc-Accordion-module__accordion__footer___KHIrl", ye = {
  accordion: wi,
  "accordion--warning": "lc-Accordion-module__accordion--warning___PJg4j",
  "accordion--error": "lc-Accordion-module__accordion--error___rage8",
  "accordion--promo": "lc-Accordion-module__accordion--promo___KYLtP",
  "accordion--open": "lc-Accordion-module__accordion--open___q9p79",
  accordion__chevron: Ci,
  "accordion__chevron--open": "lc-Accordion-module__accordion__chevron--open___Yax5V",
  "accordion__chevron--promo": "lc-Accordion-module__accordion__chevron--promo___VXb92",
  accordion__label: $i,
  "accordion__label--promo": "lc-Accordion-module__accordion__label--promo___SDMpV",
  accordion__content: Ni,
  accordion__content__inner: Si,
  "accordion__content__inner--open": "lc-Accordion-module__accordion__content__inner--open___BhKjm",
  "accordion__content__inner--promo": "lc-Accordion-module__accordion__content__inner--promo___o4mw9",
  "accordion__content__inner--full-width": "lc-Accordion-module__accordion__content__inner--full-width___HpIN0",
  accordion__footer: xi,
  "accordion__footer--promo": "lc-Accordion-module__accordion__footer--promo___N1Ebg"
}, Mo = (g) => {
  var w = g, {
    className: e,
    mainClassName: a,
    children: r,
    label: _,
    multilineElement: o,
    openOnInit: l = !1,
    fullWidthContent: i,
    hideChevron: n,
    isOpen: d,
    isPromo: s,
    footer: c,
    onClose: p,
    onOpen: m
  } = w, f = U(w, [
    "className",
    "mainClassName",
    "children",
    "label",
    "multilineElement",
    "openOnInit",
    "fullWidthContent",
    "hideChevron",
    "isOpen",
    "isPromo",
    "footer",
    "onClose",
    "onOpen"
  ]);
  const x = d !== void 0, S = x ? d : l, E = v.useRef(null), {
    isOpen: N,
    isMounted: C,
    setShouldBeVisible: $
  } = sa({
    isVisible: S,
    elementRef: E
  }), { size: b, handleResizeRef: k } = Ao(), { handleExpandChange: I, handleKeyDown: T } = ki({
    isControlled: x,
    isExpanded: N,
    setShouldBeVisible: $,
    onOpen: m,
    onClose: p
  }), F = u(
    a,
    {
      [ye[`${ke}--open`]]: N
    },
    e
  ), A = (O) => {
    const G = O ? he : D, P = y({
      "aria-expanded": N,
      as: "div",
      className: u(ye[`${ke}__label`], {
        [ye[`${ke}__label--promo`]]: O
      }),
      onClick: () => I(N),
      bold: O ? void 0 : !0
    }, O ? { size: "xs" } : {});
    return /* @__PURE__ */ t(G, B(y({}, P), { children: yi(_, N) }));
  };
  return /* @__PURE__ */ h(
    "div",
    B(y({
      tabIndex: 0,
      "aria-expanded": N,
      className: F,
      onKeyDown: T
    }, f), {
      children: [
        !n && /* @__PURE__ */ t(
          R,
          {
            source: ta,
            className: u(ye[`${ke}__chevron`], {
              [ye[`${ke}__chevron--open`]]: N,
              [ye[`${ke}__chevron--promo`]]: s
            })
          }
        ),
        A(s),
        o && /* @__PURE__ */ t(bi, { isExpanded: N, children: o }),
        /* @__PURE__ */ t(
          "div",
          {
            className: ye[`${ke}__content`],
            style: { maxHeight: N ? b : 0 },
            ref: E,
            children: /* @__PURE__ */ t("div", { ref: k, children: C && /* @__PURE__ */ h(Z, { children: [
              /* @__PURE__ */ t(
                D,
                {
                  as: "div",
                  className: u(ye[`${ke}__content__inner`], {
                    [ye[`${ke}__content__inner--open`]]: N,
                    [ye[`${ke}__content__inner--promo`]]: s,
                    [ye[`${ke}__content__inner--full-width`]]: i
                  }),
                  children: r
                }
              ),
              c && /* @__PURE__ */ t(
                D,
                {
                  as: "div",
                  "aria-label": "Accordion footer",
                  role: "complementary",
                  className: u(ye[`${ke}__footer`], {
                    [ye[`${ke}__footer--promo`]]: s
                  }),
                  children: c
                }
              )
            ] }) })
          }
        )
      ]
    })
  );
}, ke = "accordion", cu = (r) => {
  var _ = r, { kind: e } = _, a = U(_, ["kind"]);
  const o = u(ye[ke], ye[`${ke}--${e}`]);
  return /* @__PURE__ */ t(Mo, y({ mainClassName: o }, a));
}, Ei = `${ke}--promo`, su = (e) => {
  const a = u(ye[ke], ye[Ei]);
  return /* @__PURE__ */ t(Mo, y({ mainClassName: a, isPromo: !0 }, e));
}, ue = {
  esc: "Escape",
  enter: "Enter",
  backspace: "Backspace",
  delete: "Delete",
  spacebar: " ",
  tab: "Tab",
  semicolon: ";",
  comma: ",",
  arrowUp: "ArrowUp",
  arrowDown: "ArrowDown"
}, Ct = {
  "action-menu": "lc-ActionMenu-module__action-menu___tmkcK",
  "action-menu__trigger-button": "lc-ActionMenu-module__action-menu__trigger-button___fTjxP",
  "action-menu__list": "lc-ActionMenu-module__action-menu__list___sEn6L",
  "action-menu__list__group-header": "lc-ActionMenu-module__action-menu__list__group-header___TWiz0",
  "action-menu__list__item": "lc-ActionMenu-module__action-menu__list__item___PhQbO",
  "action-menu__list__item--with-divider": "lc-ActionMenu-module__action-menu__list__item--with-divider___KF1dE",
  "action-menu__list__item--disabled": "lc-ActionMenu-module__action-menu__list__item--disabled___VfZx3",
  "action-menu__list__item--selected": "lc-ActionMenu-module__action-menu__list__item--selected___aT2Ab",
  "action-menu__list__item__icon": "lc-ActionMenu-module__action-menu__list__item__icon___f3k8k",
  "action-menu__list--with-footer": "lc-ActionMenu-module__action-menu__list--with-footer___21-ar",
  "action-menu__footer": "lc-ActionMenu-module__action-menu__footer___pb-RE"
}, $t = "action-menu", D_ = (w) => {
  var x = w, {
    className: e,
    triggerClassName: a,
    options: r,
    triggerRenderer: _,
    placement: o = "bottom-end",
    openedOnInit: l = !1,
    keepOpenOnClick: i,
    flipOptions: n,
    visible: d,
    onClose: s,
    onOpen: c,
    floatingStrategy: p,
    selectedOptions: m,
    footer: f
  } = x, g = U(x, [
    "className",
    "triggerClassName",
    "options",
    "triggerRenderer",
    "placement",
    "openedOnInit",
    "keepOpenOnClick",
    "flipOptions",
    "visible",
    "onClose",
    "onOpen",
    "floatingStrategy",
    "selectedOptions",
    "footer"
  ]);
  const S = d !== void 0, [E, N] = v.useState(l), [C, $] = v.useState(null), b = v.useRef(-1), k = Lr(), I = lr(), T = v.useRef(null), F = S ? d : E, A = () => {
    F ? (s == null || s(), !S && N(!1)) : (c == null || c(), !S && N(!0));
  }, { x: O, y: G, strategy: P, refs: L, context: M } = ir({
    nodeId: I,
    middleware: [
      nr(4),
      qr(n),
      xo({
        apply({ availableHeight: z }) {
          Zl(() => $(z));
        }
      })
    ],
    placement: o,
    open: F,
    strategy: p,
    onOpenChange: A,
    whileElementsMounted: cr
  }), q = sr(M), Y = dr(M, {
    enabled: F
  }), te = ur(M), { getReferenceProps: Ce, getFloatingProps: fe } = mr([
    q,
    Y,
    te
  ]), { styles: K } = zr(M, {
    initial: ({ side: z }) => y({
      opacity: 0
    }, z === "bottom" && {
      marginTop: -10
    } || z === "top" && {
      marginTop: 10
    } || z === "left" && {
      marginLeft: 10
    } || z === "right" && {
      marginLeft: -10
    })
  }), j = (z) => {
    var De, le;
    const oe = b.current;
    let me = oe + z;
    for (; (De = r[me]) != null && De.disabled || (le = r[me]) != null && le.groupHeader; )
      if (me += z, me === -1) {
        me = oe;
        break;
      }
    return me;
  }, ut = (z) => {
    var De, le;
    b.current = j(z);
    const oe = (De = T.current) == null ? void 0 : De.children, me = oe && ((le = oe[b.current]) == null ? void 0 : le.children[0]);
    return me == null ? void 0 : me.focus();
  }, wt = (z) => {
    z.key === ue.arrowUp && b.current > 0 && (z.preventDefault(), ut(-1)), z.key === ue.arrowDown && b.current + 1 < r.length && (z.preventDefault(), ut(1));
  };
  v.useEffect(() => {
    if (F)
      return document.addEventListener("keydown", wt), () => document.removeEventListener("keydown", wt);
    b.current = -1;
  }, [F, wt]);
  const aa = (z, oe) => {
    b.current = z, oe == null || oe(), !S && !i && (N(!1), s == null || s());
  }, Mt = (z, oe) => z.groupHeader ? /* @__PURE__ */ t(
    "li",
    {
      role: "none",
      className: Ct[`${$t}__list__group-header`],
      children: z.element
    },
    z.key
  ) : /* @__PURE__ */ t("li", { role: "none", children: /* @__PURE__ */ h(
    "button",
    {
      "data-testid": z.key,
      tabIndex: -1,
      disabled: z.disabled,
      onClick: () => aa(oe, z.onClick),
      role: "menuitem",
      className: u(Ct[`${$t}__list__item`], {
        [Ct[`${$t}__list__item--disabled`]]: z.disabled,
        [Ct[`${$t}__list__item--with-divider`]]: z.withDivider,
        [Ct[`${$t}__list__item--selected`]]: m == null ? void 0 : m.includes(z.key)
      }),
      children: [
        z.element,
        (m == null ? void 0 : m.includes(z.key)) && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${z.key}-selected-icon`,
            className: Ct[`${$t}__list__item__icon`],
            children: /* @__PURE__ */ t(R, { source: Na, kind: "action-primary" })
          }
        )
      ]
    },
    z.key
  ) }, z.key), Pt = /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ t(
      "div",
      B(y({
        "aria-label": "Toggle menu",
        "data-testid": "action-menu-trigger-button",
        ref: L.setReference
      }, Ce()), {
        className: a,
        children: _
      })
    ),
    /* @__PURE__ */ t(Sa, { id: I, children: F && /* @__PURE__ */ h(
      "div",
      B(y({
        ref: L.setFloating,
        className: Ct[$t],
        style: y(y({
          position: P,
          top: G != null ? G : "",
          left: O != null ? O : ""
        }, !!C && { maxHeight: C }), K)
      }, fe()), {
        children: [
          r.length > 0 && /* @__PURE__ */ t(
            "ul",
            B(y({}, g), {
              className: u(
                Ct[`${$t}__list`],
                {
                  [Ct[`${$t}__list--with-footer`]]: f
                },
                e
              ),
              role: "menu",
              ref: T,
              children: r.map(Mt)
            })
          ),
          f && /* @__PURE__ */ t(
            D,
            {
              size: "sm",
              as: "div",
              className: Ct[`${$t}__footer`],
              children: f
            }
          )
        ]
      })
    ) })
  ] });
  return k === null ? /* @__PURE__ */ t(Hr, { children: Pt }) : Pt;
}, Ti = "lc-Loader-module__loader___Ukoov", Bi = "lc-Loader-module__loader__spinner___cp5N7", Ii = "lc-Loader-module__rotate___p-j1x", Ai = "lc-Loader-module__loader__label___CF5-C", Ba = {
  loader: Ti,
  loader__spinner: Bi,
  "loader__spinner--small": "lc-Loader-module__loader__spinner--small___9XXkz",
  "loader__spinner--medium": "lc-Loader-module__loader__spinner--medium___oTzt2",
  "loader__spinner--large": "lc-Loader-module__loader__spinner--large___vDCTc",
  "loader__spinner-circle": "lc-Loader-module__loader__spinner-circle___LyuTm",
  rotate: Ii,
  loader__label: Ai
}, Po = "loader", J_ = `${Po}__spinner`, O_ = (i) => {
  var n = i, {
    primaryColor: e,
    secondaryColor: a,
    label: r,
    className: _,
    size: o = "medium"
  } = n, l = U(n, [
    "primaryColor",
    "secondaryColor",
    "label",
    "className",
    "size"
  ]);
  return /* @__PURE__ */ h("div", B(y({ className: u(Ba[Po], _) }, l), { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(Ba[J_], Ba[`${J_}--${o}`]),
        children: /* @__PURE__ */ t(
          "div",
          {
            role: "status",
            className: Ba["loader__spinner-circle"],
            style: {
              /* stylelint-disable */
              borderColor: a,
              borderTopColor: e
            }
          }
        )
      }
    ),
    r && /* @__PURE__ */ t(D, { as: "div", size: "md", className: Ba.loader__label, children: r })
  ] }));
}, Di = (e) => {
  if (e === "primary" || e === "destructive")
    return {
      primaryColor: "var(--action-primary-default)",
      secondaryColor: "var(--border-invert-primary)"
    };
  if (e === "link-inverted")
    return {
      primaryColor: "var(--content-invert-primary)",
      secondaryColor: "var(--surface-invert-secondary)"
    };
}, Q_ = (e, a, r) => {
  a(), r == null || r(e);
}, Oi = (e, a, r) => {
  a(), r == null || r(e);
}, Mi = (e, a) => {
  const r = e == null ? void 0 : e.offsetWidth;
  r && a(r);
}, Pi = "lc-Button-module__btn___daEdK", Fi = "lc-Button-module__btn__loader___L9GCi", Ri = "lc-Button-module__btn__icon___-CG5y", Gi = "lc-Button-module__btn__content___rMx0W", $e = {
  btn: Pi,
  "btn--disabled": "lc-Button-module__btn--disabled___ATZwt",
  "btn--full-width": "lc-Button-module__btn--full-width___ViUNm",
  "btn--xcompact": "lc-Button-module__btn--xcompact___0AZjf",
  "btn--with-left-icon": "lc-Button-module__btn--with-left-icon___32jlN",
  "btn--with-right-icon": "lc-Button-module__btn--with-right-icon___MnSZq",
  "btn--compact": "lc-Button-module__btn--compact___230yl",
  "btn--medium": "lc-Button-module__btn--medium___7lzYn",
  "btn--large": "lc-Button-module__btn--large___D38zo",
  "btn--basic": "lc-Button-module__btn--basic___r7FM2",
  "btn--primary": "lc-Button-module__btn--primary___RKxUy",
  "btn--secondary": "lc-Button-module__btn--secondary___-lgbN",
  "btn--destructive": "lc-Button-module__btn--destructive___frCNL",
  "btn--destructive-outline": "lc-Button-module__btn--destructive-outline___3Q-D2",
  "btn--text": "lc-Button-module__btn--text___lb44N",
  "btn--link": "lc-Button-module__btn--link___Q-xHu",
  "btn--link-light": "lc-Button-module__btn--link-light___s-d01",
  "btn--link-inverted": "lc-Button-module__btn--link-inverted___xOUjH",
  "btn--plain": "lc-Button-module__btn--plain___BOFMA",
  "btn--float": "lc-Button-module__btn--float___3O7kc",
  "btn--dotted": "lc-Button-module__btn--dotted___kFW2N",
  "btn--high-contrast": "lc-Button-module__btn--high-contrast___IZkuG",
  "btn--loading": "lc-Button-module__btn--loading___kGPe4",
  btn__loader: Fi,
  btn__icon: Ri,
  "btn__icon--left": "lc-Button-module__btn__icon--left___Xke3Q",
  "btn__icon--right": "lc-Button-module__btn__icon--right___c-N-B",
  "btn__icon--small": "lc-Button-module__btn__icon--small___2gmZG",
  "btn--icon-only": "lc-Button-module__btn--icon-only___7J-XP",
  "btn--icon-only--bg": "lc-Button-module__btn--icon-only--bg___Kn-y-",
  "btn--plain-lock-black": "lc-Button-module__btn--plain-lock-black___EsXu7",
  "btn--text-lock-black": "lc-Button-module__btn--text-lock-black___r4V6e",
  "btn--animated-label": "lc-Button-module__btn--animated-label___8uZTa",
  btn__content: Gi,
  "btn--animated-label--expanded": "lc-Button-module__btn--animated-label--expanded___dTfmD"
}, Ne = "btn", H = v.forwardRef(
  (x, w) => {
    var S = x, {
      loading: e = !1,
      disabled: a = !1,
      type: r = "button",
      fullWidth: _ = !1,
      kind: o = "secondary",
      size: l = "medium",
      icon: i = null,
      iconPosition: n = "left",
      loaderLabel: d,
      className: s,
      children: c,
      href: p,
      onClick: m,
      animatedLabel: f
    } = S, g = U(S, [
      "loading",
      "disabled",
      "type",
      "fullWidth",
      "kind",
      "size",
      "icon",
      "iconPosition",
      "loaderLabel",
      "className",
      "children",
      "href",
      "onClick",
      "animatedLabel"
    ]);
    const [E, N] = v.useState(0), [C, $] = v.useState(!1), b = e || a, k = !c && i, I = f && c && i, T = ["text", "link", "link-light"].includes(o), F = p ? "a" : "button", A = u(
      $e[Ne],
      $e[`${Ne}--${o}`],
      $e[`${Ne}--${l}`],
      {
        [$e[`${Ne}--loading`]]: e,
        [$e[`${Ne}--full-width`]]: _,
        [$e[`${Ne}--with-${n}-icon`]]: i && !k && !T,
        [$e[`${Ne}--icon-only`]]: k,
        [$e[`${Ne}--icon-only--bg`]]: k && T,
        [$e[`${Ne}--disabled`]]: b,
        [$e[`${Ne}--animated-label`]]: I,
        [$e[`${Ne}--animated-label--expanded`]]: I && C
      },
      s
    );
    return /* @__PURE__ */ h(
      F,
      B(y(y(y({
        ref: w,
        className: A,
        "aria-disabled": b,
        type: r,
        disabled: b
      }, !b && { href: p, onClick: m }), g), I && {
        onMouseEnter: (O) => Q_(
          O,
          () => $(!0),
          g == null ? void 0 : g.onMouseEnter
        ),
        onMouseLeave: (O) => Q_(
          O,
          () => $(!1),
          g == null ? void 0 : g.onMouseLeave
        ),
        onBlur: (O) => Oi(
          O,
          () => $(!1),
          g == null ? void 0 : g.onBlur
        ),
        onKeyUp: (O) => {
          var G;
          (O.key === "Enter" || O.key === " ") && $(!0), O.key === "Escape" && $(!1), (G = g == null ? void 0 : g.onKeyUp) == null || G.call(g, O);
        }
      }), {
        children: [
          e && /* @__PURE__ */ t(
            O_,
            y({
              "data-testid": "button-loader",
              size: "small",
              label: d,
              className: $e[`${Ne}__loader`]
            }, Di(o))
          ),
          i && v.cloneElement(i, {
            className: u(
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              i.props.className,
              $e[`${Ne}__icon`],
              $e[`${Ne}__icon--${n}`],
              {
                [$e[`${Ne}__icon--small`]]: l === "xcompact"
              }
            ),
            disabled: a,
            size: l === "xcompact" ? "small" : "medium"
          }),
          /* @__PURE__ */ t(
            "div",
            {
              className: $e[`${Ne}__content`],
              style: I ? { maxWidth: C ? E : 0 } : void 0,
              children: I ? /* @__PURE__ */ t("span", { ref: (O) => Mi(O, N), children: c }) : c
            }
          )
        ]
      })
    );
  }
), Ia = {
  "list-item": "lc-ListItem-module__list-item___22kWE",
  "list-item__left-node": "lc-ListItem-module__list-item__left-node___EIetr",
  "list-item__right-node": "lc-ListItem-module__list-item__right-node___An9i9",
  "list-item__label": "lc-ListItem-module__list-item__label___E8L87",
  "list-item--warning": "lc-ListItem-module__list-item--warning___-yfsq"
}, Aa = "list-item", rr = ({
  leftNode: e,
  rightNode: a,
  children: r,
  kind: _
}) => /* @__PURE__ */ h(
  "div",
  {
    className: u(Ia[Aa], {
      [Ia[`${Aa}--warning`]]: _ === "warning"
    }),
    children: [
      e && /* @__PURE__ */ t("div", { className: Ia[`${Aa}__left-node`], children: e }),
      /* @__PURE__ */ t(D, { as: "div", className: Ia[`${Aa}__label`], children: r }),
      a && /* @__PURE__ */ t("div", { className: Ia[`${Aa}__right-node`], children: a })
    ]
  }
), du = (e) => (V(() => {
  console.warn("`ActionMenuItem` is deprecated. Use `ListItem` instead.");
}, []), /* @__PURE__ */ t(rr, y({}, e)));
function Fo(e) {
  switch (e) {
    case "invert":
      return "inverted";
    case "important":
      return "lock-black";
    default:
      return "primary";
  }
}
function Ui(e, a, r, _) {
  if (r)
    return {
      top: e ? r + e : r
    };
  if (_)
    return {
      left: a ? _ + a : _
    };
}
const Li = (e) => {
  switch (e) {
    case "invert":
      return {
        stroke: "var(--tooltip-background-invert)",
        fill: "var(--tooltip-background-invert)"
      };
    case "important":
      return {
        stroke: "var(--surface-accent-emphasis-high-warning)",
        fill: "var(--surface-accent-emphasis-high-warning)"
      };
    default:
      return {
        stroke: "var(--tooltip-border-for-svg)",
        fill: "var(--tooltip-background-basic)"
      };
  }
}, qi = "lc-Tooltip-module__tooltip___LjRUX", zi = "lc-Tooltip-module__tooltip__content___cxaIe", Hi = "lc-Tooltip-module__tooltip__arrow___vLFFP", Vi = "lc-Tooltip-module__tooltip__interactive___WTll9", X = {
  tooltip: qi,
  tooltip__content: zi,
  "tooltip--invert": "lc-Tooltip-module__tooltip--invert___J4i3t",
  tooltip__arrow: Hi,
  "tooltip--important": "lc-Tooltip-module__tooltip--important___7KDXC",
  tooltip__interactive: Vi,
  "tooltip__user-guide-step": "lc-Tooltip-module__tooltip__user-guide-step___zwAvq",
  "tooltip--full-space": "lc-Tooltip-module__tooltip--full-space___YXy-C",
  "tooltip-header": "lc-Tooltip-module__tooltip-header___gnWkw",
  "tooltip-header--info": "lc-Tooltip-module__tooltip-header--info___VLXJo",
  "tooltip-media-container": "lc-Tooltip-module__tooltip-media-container___82zyJ",
  "tooltip-media": "lc-Tooltip-module__tooltip-media___F81U-",
  "tooltip-text--info": "lc-Tooltip-module__tooltip-text--info___eFPj0",
  "tooltip-close": "lc-Tooltip-module__tooltip-close___3t8it",
  "tooltip-step": "lc-Tooltip-module__tooltip-step___WnQFV",
  "tooltip-footer": "lc-Tooltip-module__tooltip-footer___Ila6T",
  "tooltip-footer--interactive": "lc-Tooltip-module__tooltip-footer--interactive___8WwVX",
  "tooltip-footer--user-guide-step": "lc-Tooltip-module__tooltip-footer--user-guide-step___hIsO4",
  "guide-tooltip": "lc-Tooltip-module__guide-tooltip___lBG0P",
  "guide-tooltip--slide": "lc-Tooltip-module__guide-tooltip--slide___XuCdK",
  "guide-tooltip__overlay": "lc-Tooltip-module__guide-tooltip__overlay___BAueg",
  "guide-tooltip__overlay--slide": "lc-Tooltip-module__guide-tooltip__overlay--slide___uYqoN",
  "guide-tooltip__overlay--visible": "lc-Tooltip-module__guide-tooltip__overlay--visible___Tk1Yr",
  "reports-tooltip": "lc-Tooltip-module__reports-tooltip___g6vxb",
  "reports-tooltip__heading": "lc-Tooltip-module__reports-tooltip__heading___TxORk",
  "reports-tooltip__heading__title": "lc-Tooltip-module__reports-tooltip__heading__title___0foO-",
  "reports-tooltip__heading__description": "lc-Tooltip-module__reports-tooltip__heading__description___E6Gb3",
  "reports-tooltip__content": "lc-Tooltip-module__reports-tooltip__content___yfOcf"
}, fr = "tooltip", ea = ({
  children: e,
  className: a,
  triggerClassName: r,
  triggerRenderer: _,
  theme: o,
  kind: l,
  placement: i = "bottom",
  isVisible: n,
  fullSpaceContent: d,
  onClose: s,
  onOpen: c,
  withFadeAnimation: p = !0,
  transitionDuration: m = 200,
  hoverOnDuration: f,
  hoverOffDuration: g,
  transitionDelay: w = 0,
  hoverOnDelay: x,
  hoverOffDelay: S,
  triggerOnClick: E = !1,
  triggerOnHover: N = !0,
  offsetMainAxis: C = 8,
  offsetCrossAxis: $ = 0,
  referenceElement: b,
  activationThreshold: k = 0,
  useDismissHookProps: I,
  useClickHookProps: T,
  hoverOutDelayTimeout: F = 100,
  arrowOffsetY: A,
  arrowOffsetX: O,
  closeOnTriggerBlur: G = !1,
  floatingStrategy: P,
  portal: L,
  portalProps: M,
  hideWhenReferenceHidden: q = !1
}) => {
  const Y = n !== void 0, [te, Ce] = v.useState(!1), fe = v.useRef(null), K = Y ? n : te, j = l || o, ut = Lr(), wt = lr(), aa = u(
    X[fr],
    a,
    j && X[`${fr}--${j}`],
    d && X[`${fr}--full-space`]
  ), Mt = typeof _ == "function", Pt = (be) => {
    be !== K && (be ? c == null || c() : s == null || s(), !Y && Ce(be));
  }, z = (be) => p ? be != null ? be : m : 0, oe = (be) => be != null ? be : w, {
    floatingStyles: me,
    refs: De,
    context: le,
    middlewareData: { arrow: { x: da, y: pe } = {}, hide: He }
  } = ir({
    nodeId: wt,
    middleware: [
      nr({ mainAxis: C, crossAxis: $ }),
      B_(),
      qr(),
      Ul({ element: fe, padding: 8 }),
      q ? Ll() : void 0
    ],
    placement: i,
    open: K,
    strategy: P,
    onOpenChange: Pt,
    whileElementsMounted: cr
  }), Ft = ql(le, {
    move: !1,
    restMs: k,
    delay: {
      open: oe(x),
      close: oe(S || F)
    },
    enabled: N,
    handleClose: G ? null : zl()
  }), ua = Hl(le), ma = dr(le, I), Kr = ur(le, { role: "tooltip" }), Yr = sr(le, y({
    enabled: E
  }, T)), { isMounted: Xr, styles: Zr } = zr(le, {
    duration: {
      open: z(f),
      close: z(g)
    }
  }), { status: jr } = Vl(le), { getReferenceProps: Jr, getFloatingProps: Qr } = mr([
    Ft,
    ua,
    ma,
    Kr,
    Yr
  ]);
  v.useEffect(() => {
    b && De.setReference(b);
  }, [De.setReference, b]);
  const pa = /* @__PURE__ */ t(Sa, { id: wt, children: Xr && /* @__PURE__ */ h(
    "div",
    B(y({
      ref: De.setFloating,
      style: B(y(y({}, me), Zr), {
        visibility: He != null && He.referenceHidden ? "hidden" : "visible"
      }),
      className: aa
    }, Qr()), {
      "data-status": jr,
      children: [
        /* @__PURE__ */ t(D, { as: "div", className: X[`${fr}__content`], children: e }),
        /* @__PURE__ */ t(
          Wl,
          y({
            ref: fe,
            context: le,
            strokeWidth: 1,
            width: 10,
            height: 5,
            style: y({}, Ui(
              A,
              O,
              pe,
              da
            ))
          }, Li(j))
        )
      ]
    })
  ) }), e_ = () => ut === null ? /* @__PURE__ */ t(Hr, { children: L ? /* @__PURE__ */ t($a, B(y({}, M), { children: pa })) : pa }) : L ? /* @__PURE__ */ t($a, B(y({}, M), { children: pa })) : pa;
  return /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ t(
      "div",
      B(y({
        "data-testid": "tooltip-trigger",
        ref: De.setReference
      }, Jr()), {
        className: r,
        children: Mt ? _() : _
      })
    ),
    e_()
  ] });
}, uu = ({ text: e }) => /* @__PURE__ */ t("div", { children: e }), Da = "tooltip", mu = ({
  className: e,
  header: a,
  text: r,
  closeWithX: _,
  theme: o,
  handleCloseAction: l
}) => /* @__PURE__ */ h("div", { className: e, children: [
  (_ || l) && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      "aria-label": "Close tooltip",
      className: X[`${Da}-close`],
      onClick: l,
      children: /* @__PURE__ */ t(R, { source: dt, kind: o ? Fo(o) : "primary" })
    }
  ),
  a && /* @__PURE__ */ t(
    he,
    {
      as: "div",
      size: "xs",
      className: u(X[`${Da}-header`], {
        [X[`${Da}-header--info`]]: _
      }),
      children: a
    }
  ),
  /* @__PURE__ */ t(
    D,
    {
      as: "div",
      className: u({
        [X[`${Da}-text`]]: _,
        [X[`${Da}-text--info`]]: _
      }),
      children: r
    }
  )
] }), Nt = "tooltip", Wi = ({
  header: e,
  text: a,
  image: r,
  video: _,
  closeWithX: o,
  theme: l,
  handleCloseAction: i,
  primaryButton: n,
  secondaryButton: d
}) => {
  const s = (m) => m === "invert" ? "secondary" : m === "important" ? "plain-lock-black" : "high-contrast", c = (m) => m === "invert" ? "link-inverted" : m === "important" ? "text-lock-black" : "text", p = (m, f = !0) => {
    if (!m) return null;
    if (v.isValidElement(m))
      return m;
    const g = m, w = f ? g.kind || s(l) : g.kind || c(l);
    return /* @__PURE__ */ t(
      H,
      B(y({}, g), {
        kind: w,
        onClick: g.handleClick,
        children: g.label
      })
    );
  };
  return /* @__PURE__ */ h("div", { className: X[`${Nt}__interactive`], children: [
    (o || i) && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": "Close tooltip",
        className: X[`${Nt}-close`],
        onClick: i,
        children: /* @__PURE__ */ t(R, { source: dt, kind: l ? Fo(l) : "primary" })
      }
    ),
    r && /* @__PURE__ */ t("div", { className: X[`${Nt}-media-container`], children: /* @__PURE__ */ t(
      "img",
      {
        className: X[`${Nt}-media`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    _ && /* @__PURE__ */ t("div", { className: X[`${Nt}-media-container`], children: /* @__PURE__ */ t(
      "video",
      {
        className: X[`${Nt}-media`],
        autoPlay: !0,
        loop: !0,
        muted: !0,
        playsInline: !0,
        controls: !1,
        children: /* @__PURE__ */ t("source", { src: _ })
      }
    ) }),
    e && /* @__PURE__ */ t(he, { as: "div", size: "xs", className: X[`${Nt}-header`], children: e }),
    /* @__PURE__ */ t("div", { className: X[`${Nt}-text`], children: a }),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(
          X[`${Nt}-footer`],
          X[`${Nt}-footer--interactive`]
        ),
        children: [
          p(n, !0),
          p(d, !1)
        ]
      }
    )
  ] });
}, Oa = "reports-tooltip", pu = ({
  title: e,
  description: a,
  children: r
}) => /* @__PURE__ */ h("div", { className: X[Oa], children: [
  /* @__PURE__ */ h("div", { className: X[`${Oa}__heading`], children: [
    /* @__PURE__ */ t(D, { as: "div", className: X[`${Oa}__heading__title`], children: e }),
    /* @__PURE__ */ t(
      D,
      {
        as: "div",
        size: "xs",
        className: X[`${Oa}__heading__description`],
        children: a
      }
    )
  ] }),
  /* @__PURE__ */ t("div", { className: X[`${Oa}__content`], children: /* @__PURE__ */ t(D, { as: "div", children: r }) })
] }), _e = {
  "action-bar": "lc-ActionBar-module__action-bar___yfLdO",
  "action-bar__items": "lc-ActionBar-module__action-bar__items___E8fX6",
  "action-bar__items--scroll": "lc-ActionBar-module__action-bar__items--scroll___izP27",
  "action-bar__items__button-wrapper": "lc-ActionBar-module__action-bar__items__button-wrapper___sgdUc",
  "action-bar__items__button-wrapper--active": "lc-ActionBar-module__action-bar__items__button-wrapper--active___TZteM",
  "action-bar__items__button-wrapper--hidden": "lc-ActionBar-module__action-bar__items__button-wrapper--hidden___43H6t",
  "action-bar__items__button-wrapper--vertical": "lc-ActionBar-module__action-bar__items__button-wrapper--vertical___8Aq0c",
  "action-bar__items__button-wrapper__button": "lc-ActionBar-module__action-bar__items__button-wrapper__button___r5jpx",
  "action-bar__items__button-wrapper__button--with-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-divider___bTyao",
  "action-bar__items__button-wrapper__button--with-vertical-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-vertical-divider___DkEFm",
  "action-bar__items__tooltip": "lc-ActionBar-module__action-bar__items__tooltip___BxN2p",
  "action-bar__menu-wrapper": "lc-ActionBar-module__action-bar__menu-wrapper___y26Bl",
  "action-bar__menu-wrapper--active": "lc-ActionBar-module__action-bar__menu-wrapper--active___E4iCs",
  "action-bar__menu-wrapper--vertical": "lc-ActionBar-module__action-bar__menu-wrapper--vertical___wU4tc",
  "action-bar__menu-wrapper__button": "lc-ActionBar-module__action-bar__menu-wrapper__button___0Nluq",
  "action-bar__menu-wrapper__button--active": "lc-ActionBar-module__action-bar__menu-wrapper__button--active___-NlsX",
  "action-bar__menu-wrapper__button__with-item": "lc-ActionBar-module__action-bar__menu-wrapper__button__with-item___Nvb-H",
  "fade-in": "lc-ActionBar-module__fade-in___NlmMy",
  "action-bar__menu-wrapper__button__icon": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon___dFIfe",
  "action-bar__menu-wrapper__button__icon--open": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon--open___shQMz",
  "action-bar__menu-wrapper__trigger-vertical": "lc-ActionBar-module__action-bar__menu-wrapper__trigger-vertical___yaJyY",
  "action-bar--vertical": "lc-ActionBar-module__action-bar--vertical___9uO-q",
  "action-bar__items--with-menu": "lc-ActionBar-module__action-bar__items--with-menu___OfqL0",
  "action-bar__items__button": "lc-ActionBar-module__action-bar__items__button___N1Qtp",
  "action-bar__items__button--active": "lc-ActionBar-module__action-bar__items__button--active___adIVs"
}, Ro = "action-bar__items", ga = `${Ro}__button-wrapper`, Ki = ({
  option: e,
  isActive: a,
  vertical: r
}) => {
  const _ = u(_e[ga], {
    [_e[`${ga}--active`]]: a,
    [_e[`${ga}--vertical`]]: r
  }), o = /* @__PURE__ */ t(
    H,
    {
      id: e.key,
      title: e != null && e.showTooltip ? void 0 : e.label,
      kind: "plain",
      onClick: e.onClick,
      icon: e.element,
      className: u(_e[`${ga}__button`], {
        [_e[`${ga}__button--with-vertical-divider`]]: r && e.withDivider,
        [_e[`${ga}__button--with-divider`]]: !r && e.withDivider
      })
    },
    e.key
  );
  return e.showTooltip ? /* @__PURE__ */ t(
    "div",
    {
      "data-testid": e.key,
      className: _,
      children: /* @__PURE__ */ t(
        ea,
        {
          kind: "invert",
          placement: r ? "left" : "bottom",
          triggerClassName: _e[`${Ro}__tooltip`],
          triggerRenderer: () => o,
          floatingStrategy: "fixed",
          useClickHookProps: {
            ignoreMouse: !0
          },
          hoverOnDelay: 800,
          hoverOffDelay: 0,
          children: /* @__PURE__ */ t("div", { children: e.label })
        }
      )
    },
    e.key
  ) : /* @__PURE__ */ t("div", { "data-testid": e.key, className: _, children: o });
}, br = "action-bar", Rt = "action-bar__menu-wrapper", Yi = 44, gu = ({
  className: e,
  id: a = "action-bar-area",
  type: r = "menu",
  options: _,
  activeOptionKey: o,
  vertical: l,
  menuFooter: i
}) => {
  const [n, d] = v.useState(
    _.length
  ), [s, c] = v.useState([]), [p, m] = v.useState(!1), f = r === "scroll", g = u(
    _e[br],
    e,
    l && _e[`${br}--vertical`]
  ), w = !f && s.length !== 0;
  v.useEffect(() => {
    f || (_.length > n ? c(_.slice(n, _.length)) : c([]));
  }, [_, n]), v.useEffect(() => {
    const E = !!window.ResizeObserver;
    if (!f && E) {
      const N = new ResizeObserver((C) => {
        const { width: $, height: b } = C[0].contentRect, k = l ? b : $, I = s.length > 0 ? 60 : 0, T = Math.floor(
          (k - I) / Yi
        );
        T >= 0 && T !== n && d(T);
      });
      return N.observe(document.querySelector(`#${a}`)), () => N.disconnect();
    }
  }, [s, f, n]);
  const x = v.useCallback(() => s.reduce(
    (E, N) => {
      if (!N.hideInMenu) {
        const C = {
          key: N.key,
          element: /* @__PURE__ */ t(rr, { leftNode: N.element, children: N.label }),
          withDivider: N.withDivider,
          onClick: N.onClick
        };
        E.push(C);
      }
      return E;
    },
    []
  ), [s]), S = s.find((E) => E.key === o);
  return /* @__PURE__ */ h("div", { id: a, className: g, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(_e[`${br}__items`], {
          [_e[`${br}__items--scroll`]]: f
        }),
        children: _.slice(0, n).map((E) => /* @__PURE__ */ t(
          Ki,
          {
            option: E,
            isActive: E.key === o,
            vertical: l
          }
        ))
      }
    ),
    w && /* @__PURE__ */ t(
      "div",
      {
        className: u(
          _e[Rt],
          S && _e[`${Rt}--active`],
          l && _e[`${Rt}--vertical`]
        ),
        children: /* @__PURE__ */ t(
          D_,
          {
            selectedOptions: o ? [o] : [],
            onOpen: () => m(!0),
            onClose: () => m(!1),
            floatingStrategy: "fixed",
            placement: l ? "left-start" : "bottom-end",
            options: x(),
            triggerClassName: u(
              l && _e[`${Rt}__trigger-vertical`]
            ),
            triggerRenderer: /* @__PURE__ */ t(
              H,
              {
                id: `${a}-menu-button`,
                className: u(
                  _e[`${Rt}__button`],
                  S && _e[`${Rt}__button--active`]
                ),
                kind: "plain",
                icon: /* @__PURE__ */ t(
                  R,
                  {
                    source: ta,
                    kind: "primary",
                    className: u(
                      _e[`${Rt}__button__icon`],
                      p && _e[`${Rt}__button__icon--open`]
                    )
                  }
                ),
                iconPosition: "right",
                children: S && /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(
                      _e[`${Rt}__button__with-item`]
                    ),
                    children: S.element
                  }
                )
              }
            ),
            footer: i
          }
        )
      }
    )
  ] });
}, Xi = "lc-ActionCard-module__loading___biGIO", Gt = {
  "visually-hidden": "lc-ActionCard-module__visually-hidden___hE6De",
  "main-wrapper": "lc-ActionCard-module__main-wrapper___-LUjH",
  "action-card--loading": "lc-ActionCard-module__action-card--loading___Ql9-s",
  "action-card": "lc-ActionCard-module__action-card___gPaoW",
  "action-card--loading--animated": "lc-ActionCard-module__action-card--loading--animated___lpz9i",
  loading: Xi,
  "action-card__column": "lc-ActionCard-module__action-card__column___KgMRx",
  "action-card__column--first": "lc-ActionCard-module__action-card__column--first___BWQwi",
  "action-card__column--second": "lc-ActionCard-module__action-card__column--second___-X-gO"
}, Ut = "action-card", hu = ({
  className: e,
  children: a,
  secondColumn: r,
  firstColumnClassName: _,
  secondColumnClassName: o,
  onClick: l,
  isLoading: i = !1,
  isLoadingAnimated: n = !1
}) => {
  const d = u(Gt[Ut], e), s = u(Gt["main-wrapper"], {
    [Gt[`${Ut}--loading`]]: i,
    [Gt[`${Ut}--loading--animated`]]: n
  }), c = (m) => {
    i || m.currentTarget === document.activeElement && (l == null || l());
  }, p = (m) => {
    i || m.currentTarget === document.activeElement && (m.key === "Enter" || m.key === " " || m.key === "Spacebar" || m.key === "Space") && (m.preventDefault(), l == null || l());
  };
  return /* @__PURE__ */ h("div", { className: s, children: [
    /* @__PURE__ */ t("div", { "aria-live": "polite", className: Gt["visually-hidden"], children: i ? "Loading content" : null }),
    /* @__PURE__ */ t(
      "div",
      {
        role: i ? "presentation" : "button",
        "aria-label": "Action Card",
        "aria-busy": i,
        tabIndex: i ? -1 : 0,
        className: d,
        onClick: c,
        onKeyDown: p,
        children: !i && /* @__PURE__ */ h(Z, { children: [
          /* @__PURE__ */ t(
            "div",
            {
              "data-testid": `${Ut}-first-column`,
              className: u(
                Gt[`${Ut}__column`],
                Gt[`${Ut}__column--first`],
                _
              ),
              children: a
            }
          ),
          r && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": `${Ut}-second-column`,
              className: u(
                Gt[`${Ut}__column`],
                Gt[`${Ut}__column--second`],
                o
              ),
              children: r
            }
          )
        ] })
      }
    )
  ] });
}, Zi = 8, ji = 100, S_ = ({
  text: e,
  typingAnimation: a = !0,
  typingDelay: r = ji,
  typingSpeed: _ = Zi,
  onTypingEnd: o
}) => {
  const [l, i] = de(""), n = Xt(0);
  return V(() => {
    if (!e) return;
    if (!a && o)
      return o();
    const s = setTimeout(() => {
      const c = setInterval(() => {
        const p = n.current;
        p < e.length ? (i((m) => m + e[p]), n.current = p + 1) : (clearInterval(c), o == null || o());
      }, _);
    }, r);
    return () => {
      clearTimeout(s);
    };
  }, [e, a]), /* @__PURE__ */ t(Z, { children: a ? l : e });
}, Ji = "lc-Alert-module__alert___zP4AL", Qi = "lc-Alert-module__alert__icon___1SDHT", en = "lc-Alert-module__alert__content___wwP8E", tn = "lc-Alert-module__alert__content__wrapper___gw9Mg", an = "lc-Alert-module__alert__content__wrapper__text___2x5d-", rn = "lc-Alert-module__alert__content__wrapper__cta___ocxGq", _n = "lc-Alert-module__alert__content__wrapper__cta__link___ZqOjp", Je = {
  alert: Ji,
  alert__icon: Qi,
  alert__content: en,
  alert__content__wrapper: tn,
  alert__content__wrapper__text: an,
  alert__content__wrapper__cta: rn,
  alert__content__wrapper__cta__link: _n,
  "alert__close-icon": "lc-Alert-module__alert__close-icon___jbDQJ",
  "alert--small": "lc-Alert-module__alert--small___GsHEV",
  "alert--medium": "lc-Alert-module__alert--medium___5PGR3",
  "alert--large": "lc-Alert-module__alert--large___068A5",
  "alert--info": "lc-Alert-module__alert--info___GLCTZ",
  "alert--warning": "lc-Alert-module__alert--warning___y0-zK",
  "alert--success": "lc-Alert-module__alert--success___RXWVi",
  "alert--error": "lc-Alert-module__alert--error___EK-vJ"
}, on = {
  info: {
    source: Mr,
    kind: "link"
  },
  warning: {
    source: Co,
    kind: "warning"
  },
  success: {
    source: T_,
    kind: "success"
  },
  error: {
    source: $o,
    kind: "error"
  }
}, Qe = "alert", fu = (n) => {
  var d = n, {
    children: e,
    className: a,
    primaryButton: r,
    secondaryButton: _,
    kind: o = "info",
    onClose: l
  } = d, i = U(d, [
    "children",
    "className",
    "primaryButton",
    "secondaryButton",
    "kind",
    "onClose"
  ]);
  const s = v.useRef(null), [c, p] = v.useState(null), m = u(
    Je[Qe],
    Je[`${Qe}--${o}`],
    c === "large" && Je[`${Qe}--large`],
    c === "medium" && Je[`${Qe}--medium`],
    c === "small" && Je[`${Qe}--small`],
    a
  );
  return v.useEffect(() => {
    const f = () => s.current && s.current.offsetWidth <= 400 ? p("small") : s.current && s.current.offsetWidth > 400 && s.current.offsetWidth <= 800 ? p("medium") : p("large"), g = wo(() => {
      f();
    }, 500);
    return window.addEventListener("resize", g), f(), () => window.removeEventListener("resize", g);
  }), /* @__PURE__ */ h("div", B(y({ ref: s, className: m }, i), { children: [
    /* @__PURE__ */ h("div", { className: Je[`${Qe}__content`], children: [
      /* @__PURE__ */ h("div", { className: Je[`${Qe}__content__wrapper`], children: [
        /* @__PURE__ */ t(
          R,
          B(y({}, on[o]), {
            size: "large",
            className: Je[`${Qe}__icon`]
          })
        ),
        /* @__PURE__ */ t(
          D,
          {
            as: "div",
            className: Je[`${Qe}__content__wrapper__text`],
            children: e
          }
        )
      ] }),
      (r || _) && /* @__PURE__ */ h("div", { className: Je[`${Qe}__content__wrapper__cta`], children: [
        r && /* @__PURE__ */ t(
          H,
          B(y({
            kind: "high-contrast",
            onClick: r.handleClick
          }, r), {
            children: r.label
          })
        ),
        _ && /* @__PURE__ */ t(
          H,
          B(y({
            className: u(
              Je[`${Qe}__content__wrapper__cta__link`],
              _.className
            ),
            kind: "text",
            onClick: _.handleClick
          }, _), {
            children: _.label
          })
        )
      ] })
    ] }),
    l && /* @__PURE__ */ t(
      H,
      {
        "aria-label": "Close alert",
        className: Je[`${Qe}__close-icon`],
        size: "compact",
        kind: "plain",
        icon: /* @__PURE__ */ t(R, { source: dt }),
        onClick: l
      }
    )
  ] }));
}, ln = 705, nn = 751, et = {
  "app-frame": "lc-AppFrame-module__app-frame___LeOAC",
  "app-frame__page-content-container": "lc-AppFrame-module__app-frame__page-content-container___XhCPO",
  "app-frame__page-content-container--mobile": "lc-AppFrame-module__app-frame__page-content-container--mobile___2HnOq",
  "app-frame__page-content-container__top-bar": "lc-AppFrame-module__app-frame__page-content-container__top-bar___cl5Ek",
  "app-frame__page-content-container__top-bar--visible": "lc-AppFrame-module__app-frame__page-content-container__top-bar--visible___ZfcRZ",
  "app-frame__page-content-container__content-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper___V0yIo",
  "app-frame__page-content-container__content-wrapper--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper--mobile___iUDnN",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper___eAkwB",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open___-rAxE",
  "app-frame__page-content-container__content-wrapper__content": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content___zHmoo",
  "app-frame__page-content-container__content-wrapper__content--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content--mobile___HKy-9",
  "app-frame__page-content-container__content-wrapper__mobile-top-bar": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__mobile-top-bar___JeGo3"
}, Go = "app-frame", mt = `${Go}__page-content-container`, cn = (e) => {
  const {
    children: a,
    className: r,
    navigation: _,
    mobileNavigation: o,
    sideNavigation: l,
    topBar: i,
    topBarClassName: n,
    sideNavigationContainerClassName: d,
    contentClassName: s
  } = e, c = u(et[Go], r), {
    isSideNavigationVisible: p,
    setIsMobileViewEnabled: m,
    isMobileViewEnabled: f
  } = A_(), g = v.useRef(null), { isOpen: w, isMounted: x } = sa({
    isVisible: p,
    elementRef: g
  }), { isMobile: S, handleResizeRef: E } = ni({
    mobileBreakpoint: ln
  });
  return v.useEffect(() => {
    m(S);
  }, [S]), /* @__PURE__ */ h("div", { className: c, ref: E, children: [
    !f && _,
    /* @__PURE__ */ h(
      "div",
      {
        className: u(et[mt], {
          [et[`${mt}--mobile`]]: f
        }),
        children: [
          !f && /* @__PURE__ */ t(
            "div",
            {
              className: u(
                et[`${mt}__top-bar`],
                {
                  [et[`${mt}__top-bar--visible`]]: i
                },
                n
              ),
              children: i
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: u(et[`${mt}__content-wrapper`], {
                [et[`${mt}__content-wrapper--mobile`]]: f
              }),
              children: [
                !f && l && /* @__PURE__ */ t(
                  "div",
                  {
                    ref: g,
                    className: u(
                      et[`${mt}__content-wrapper__nav-bar-wrapper`],
                      "lc-dark-theme",
                      d,
                      {
                        [et[`${mt}__content-wrapper__nav-bar-wrapper--open`]]: w
                      }
                    ),
                    children: x && l
                  }
                ),
                f && /* @__PURE__ */ t(
                  "div",
                  {
                    className: et[`${mt}__content-wrapper__mobile-top-bar`],
                    children: i
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(
                      et[`${mt}__content-wrapper__content`],
                      s,
                      {
                        [et[`${mt}__content-wrapper__content--mobile`]]: f
                      }
                    ),
                    children: a
                  }
                ),
                f && o
              ]
            }
          )
        ]
      }
    )
  ] });
}, bu = (e) => {
  const _ = e, { isSideNavigationVisible: a } = _, r = U(_, ["isSideNavigationVisible"]);
  return /* @__PURE__ */ t(mi, { isSideNavigationVisible: a, children: /* @__PURE__ */ t(cn, y({}, r)) });
}, ha = {
  "side-navigation": "lc-SideNavigation-module__side-navigation___FuFGb",
  "side-navigation__header": "lc-SideNavigation-module__side-navigation__header___du0Jr",
  "side-navigation__header__title": "lc-SideNavigation-module__side-navigation__header__title___2dGWf",
  "side-navigation__footer": "lc-SideNavigation-module__side-navigation__footer___9LLon",
  "side-navigation__nav-wrapper": "lc-SideNavigation-module__side-navigation__nav-wrapper___8Opuh",
  "side-navigation__nav-wrapper--no-gaps": "lc-SideNavigation-module__side-navigation__nav-wrapper--no-gaps___1ApnT"
}, fa = "side-navigation", vu = ({
  children: e,
  className: a,
  title: r,
  customHeader: _,
  customFooter: o,
  noGaps: l,
  rightNode: i
}) => {
  const n = _ || /* @__PURE__ */ h("div", { className: ha[`${fa}__header`], children: [
    /* @__PURE__ */ t(he, { size: "sm", className: ha[`${fa}__header__title`], children: r }),
    i
  ] });
  return /* @__PURE__ */ h(
    "div",
    {
      "data-testid": "side-navigation",
      className: u(ha[fa], a),
      children: [
        n,
        /* @__PURE__ */ t(
          "div",
          {
            className: u(ha[`${fa}__nav-wrapper`], {
              [ha[`${fa}__nav-wrapper--no-gaps`]]: l
            }),
            children: e
          }
        ),
        o && /* @__PURE__ */ t("div", { className: ha[`${fa}__footer`], children: o })
      ]
    }
  );
};
function _r() {
}
const sn = "side-navigation-item-test-id", dn = "side-navigation-active-item-test-id", un = "side-navigation-parent-icon", tt = {
  "side-navigation-item": "lc-SideNavigationItem-module__side-navigation-item___QCTSQ",
  "side-navigation-item__anchor": "lc-SideNavigationItem-module__side-navigation-item__anchor___PI--g",
  "side-navigation-item__custom-label": "lc-SideNavigationItem-module__side-navigation-item__custom-label___ATpTF",
  "side-navigation-item__anchor--main-entry": "lc-SideNavigationItem-module__side-navigation-item__anchor--main-entry___h9Lwx",
  "side-navigation-item__anchor--active": "lc-SideNavigationItem-module__side-navigation-item__anchor--active___iXojJ",
  "side-navigation-item__anchor--icon-hidden": "lc-SideNavigationItem-module__side-navigation-item__anchor--icon-hidden___KlK37",
  "side-navigation-item__left-node": "lc-SideNavigationItem-module__side-navigation-item__left-node___otK1S",
  "side-navigation-item__left-node--active": "lc-SideNavigationItem-module__side-navigation-item__left-node--active___5PNWM",
  "side-navigation-item__right-node": "lc-SideNavigationItem-module__side-navigation-item__right-node___MOwqj",
  "side-navigation-item__label": "lc-SideNavigationItem-module__side-navigation-item__label___dpMyX",
  "side-navigation-item__label--active": "lc-SideNavigationItem-module__side-navigation-item__label--active___4vImp",
  "side-navigation-item__custom-label--active": "lc-SideNavigationItem-module__side-navigation-item__custom-label--active___UWDu9"
}, at = "side-navigation-item", mn = (m) => {
  var f = m, {
    leftNode: e,
    shouldKeepIconSpace: a = !0,
    url: r,
    label: _,
    className: o,
    rightNode: l,
    onClick: i,
    isActive: n,
    isMainEntry: d,
    onItemHover: s,
    isIconHidden: c
  } = f, p = U(f, [
    "leftNode",
    "shouldKeepIconSpace",
    "url",
    "label",
    "className",
    "rightNode",
    "onClick",
    "isActive",
    "isMainEntry",
    "onItemHover",
    "isIconHidden"
  ]);
  const g = typeof _ == "string", w = (S) => {
    S.preventDefault(), i == null || i();
  }, x = (S) => {
    S.key === "Enter" && (S.preventDefault(), i == null || i());
  };
  return /* @__PURE__ */ t(
    "li",
    B(y({
      className: u([tt[at], o]),
      "data-testid": n ? dn : sn,
      "data-active": n
    }, p), {
      children: /* @__PURE__ */ h(
        "a",
        {
          tabIndex: 0,
          className: u(tt[`${at}__anchor`], {
            [tt[`${at}__anchor--active`]]: n,
            [tt[`${at}__anchor--main-entry`]]: d,
            [tt[`${at}__anchor--icon-hidden`]]: c
          }),
          href: r,
          onClick: w,
          onKeyDown: x,
          onMouseEnter: s || _r,
          onFocus: s || _r,
          children: [
            a && /* @__PURE__ */ t(
              "span",
              {
                className: u(tt[`${at}__left-node`], {
                  [tt[`${at}__left-node--active`]]: n || d
                }),
                "data-testid": un,
                children: e
              }
            ),
            g ? /* @__PURE__ */ t(
              D,
              {
                bold: n || d,
                className: u(tt[`${at}__label`], {
                  [tt[`${at}__label--active`]]: n || d
                }),
                children: _
              }
            ) : /* @__PURE__ */ t(
              "span",
              {
                className: u(tt[`${at}__custom-label`], {
                  [tt[`${at}__custom-label--active`]]: n || d
                }),
                children: _
              }
            ),
            l && /* @__PURE__ */ t("span", { className: tt[`${at}__right-node`], children: l })
          ]
        }
      )
    })
  );
}, pn = "side-navigation-link-label-test-id", St = {
  "side-navigation-group": "lc-SideNavigationGroup-module__side-navigation-group___Cgruk",
  "side-navigation-group__chevron": "lc-SideNavigationGroup-module__side-navigation-group__chevron___4wv4s",
  "side-navigation-group__chevron--active": "lc-SideNavigationGroup-module__side-navigation-group__chevron--active___v7QK7",
  "side-navigation-group__label": "lc-SideNavigationGroup-module__side-navigation-group__label___pDDzF",
  "side-navigation-group__simple-label-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__simple-label-wrapper___PJwbR",
  "side-navigation-group__simple-label": "lc-SideNavigationGroup-module__side-navigation-group__simple-label___-KO5t",
  "side-navigation-group__right-node": "lc-SideNavigationGroup-module__side-navigation-group__right-node___I90bd",
  "side-navigation-group__list-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper___moivM",
  "side-navigation-group__list-wrapper--expanded": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper--expanded___cwPUQ",
  "side-navigation-group__list": "lc-SideNavigationGroup-module__side-navigation-group__list___Srb-J"
}, xt = "side-navigation-group", gn = 34, yu = ({
  label: e,
  rightNode: a,
  className: r,
  labelClassName: _,
  labelWrapperClassName: o,
  listWrapperClassName: l,
  children: i,
  isCollapsible: n,
  isLinkLabel: d,
  isActive: s,
  isOpen: c,
  isMounted: p,
  setShouldBeVisible: m,
  onItemHover: f,
  onClick: g,
  listWrapperRef: w,
  shouldOpenOnInit: x = !1
}) => {
  const [S, E] = v.useState(!1), [N, C] = v.useState(0), $ = v.useRef(!1), b = v.useRef(null), k = w != null ? w : b, { isOpen: I, isMounted: T, setShouldBeVisible: F } = sa({
    isVisible: !n || x,
    elementRef: k
  }), A = c != null ? c : I, O = p != null ? p : T, G = m != null ? m : F, P = typeof a == "function" ? a(A) : a, L = typeof e == "function" ? e(A) : e, M = () => G(!0), q = () => {
    n && G((te) => !te);
  }, Y = () => g ? g({ toggle: q }) : q();
  return v.useEffect(() => {
    if (!i || !n)
      return;
    const te = v.Children.toArray(
      i
    ), Ce = !!(te != null && te.some(
      (K) => {
        var j;
        return (j = K.props) == null ? void 0 : j.isActive;
      }
    ));
    E(Ce);
    const fe = ((te == null ? void 0 : te.length) || 0) * gn;
    C(fe);
  }, [i]), v.useEffect(() => {
    !$.current && S && M(), $.current = S;
  }, [S, $.current, x]), /* @__PURE__ */ h("div", { "data-testid": "side-navigation-group", className: St[xt], children: [
    n || d ? /* @__PURE__ */ t(
      mn,
      {
        leftNode: /* @__PURE__ */ t(
          "div",
          {
            className: u(St[`${xt}__chevron`], {
              [St[`${xt}__chevron--active`]]: A
            }),
            children: n ? /* @__PURE__ */ t(R, { source: Ur, size: "small" }) : null
          }
        ),
        label: /* @__PURE__ */ t(
          D,
          {
            className: u(St[`${xt}__label`], _),
            bold: !0,
            children: L
          }
        ),
        isActive: s,
        isMainEntry: !0,
        onClick: Y,
        onItemHover: f,
        rightNode: P,
        className: o,
        "data-testid": d ? pn : void 0
      }
    ) : /* @__PURE__ */ h(
      "span",
      {
        className: u(
          St[`${xt}__simple-label-wrapper`],
          o
        ),
        children: [
          /* @__PURE__ */ t(
            D,
            {
              bold: !0,
              className: u(St[`${xt}__simple-label`], _),
              onMouseEnter: f || _r,
              children: L
            }
          ),
          P && /* @__PURE__ */ t("span", { className: St[`${xt}__right-node`], children: P })
        ]
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        ref: k,
        className: u([
          St[`${xt}__list-wrapper`],
          {
            [St[`${xt}__list-wrapper--expanded`]]: A
          },
          l
        ]),
        style: n ? { maxHeight: A ? N : 0 } : void 0,
        children: O && /* @__PURE__ */ t("ul", { className: u(St[`${xt}__list`], r), children: i })
      }
    )
  ] });
}, eo = {
  "navigation-group": "lc-NavigationGroup-module__navigation-group___61JTX",
  "navigation-group--scrollable": "lc-NavigationGroup-module__navigation-group--scrollable___BL8-e"
}, to = "navigation-group", ku = (o) => {
  var l = o, {
    children: e,
    className: a,
    scrollable: r
  } = l, _ = U(l, [
    "children",
    "className",
    "scrollable"
  ]);
  return /* @__PURE__ */ t(
    "ul",
    B(y({
      className: u(
        eo[to],
        {
          [eo[`${to}--scrollable`]]: r
        },
        a
      )
    }, _), {
      children: e
    })
  );
};
function hn(e, a) {
  return e > a ? `${a}+` : `${e}`;
}
const fn = "lc-Badge-module__badge___ZbEBU", bn = "lc-Badge-module__badge__dot___MSVVf", vr = {
  badge: fn,
  badge__dot: bn,
  "badge--large": "lc-Badge-module__badge--large___P4qtE",
  "badge--medium": "lc-Badge-module__badge--medium___5HFVb",
  "badge--compact": "lc-Badge-module__badge--compact___AUaWg",
  "badge--primary": "lc-Badge-module__badge--primary___wOrp-",
  "badge--secondary": "lc-Badge-module__badge--secondary___mAh3w",
  "badge--tertiary": "lc-Badge-module__badge--tertiary___rFqKw"
}, yr = "badge", Pr = (n) => {
  var d = n, {
    className: e,
    count: a = 0,
    max: r = 99,
    kind: _ = "primary",
    size: o = "medium",
    type: l = "counter"
  } = d, i = U(d, [
    "className",
    "count",
    "max",
    "kind",
    "size",
    "type"
  ]);
  const s = u(
    e,
    vr[yr],
    vr[`${yr}--${_}`],
    vr[`${yr}--${o}`]
  ), c = {
    counter: hn(a, r),
    alert: "!",
    dot: /* @__PURE__ */ t("span", { "data-testid": "badge-dot", className: vr[`${yr}__dot`] })
  }[l];
  return /* @__PURE__ */ t("span", B(y({ className: s }, i), { children: c }));
}, Wt = {
  "navigation-item": "lc-NavigationItem-module__navigation-item___KVL3Y",
  "navigation-item--disabled": "lc-NavigationItem-module__navigation-item--disabled___VY8pA",
  "navigation-item__badge": "lc-NavigationItem-module__navigation-item__badge___6RiK5",
  "navigation-item__button": "lc-NavigationItem-module__navigation-item__button___g-pAI",
  "navigation-item__button--disabled": "lc-NavigationItem-module__navigation-item__button--disabled___POYlQ",
  "navigation-item__button--active": "lc-NavigationItem-module__navigation-item__button--active___zsO2E",
  "navigation-item__button--opacity": "lc-NavigationItem-module__navigation-item__button--opacity___buZjS",
  "navigation-item__button--mobile": "lc-NavigationItem-module__navigation-item__button--mobile___GqQwP"
}, Kt = "navigation-item", vn = (e, a) => typeof e == "number" ? /* @__PURE__ */ t(
  Pr,
  {
    "data-testid": `${a}-badge-count`,
    className: Wt[`${Kt}__badge`],
    size: "compact",
    count: e
  }
) : /* @__PURE__ */ t(
  Pr,
  {
    "data-testid": `${a}-badge`,
    className: Wt[`${Kt}__badge`],
    size: "compact",
    type: e
  }
), wu = (p) => {
  var m = p, {
    id: e,
    label: a,
    icon: r,
    url: _,
    disableOpacity: o,
    disabled: l = !1,
    badge: i,
    isActive: n,
    onClick: d,
    className: s
  } = m, c = U(m, [
    "id",
    "label",
    "icon",
    "url",
    "disableOpacity",
    "disabled",
    "badge",
    "isActive",
    "onClick",
    "className"
  ]);
  const { isMobileViewEnabled: f } = A_();
  return /* @__PURE__ */ t(
    "li",
    {
      id: e,
      className: u(
        Wt[Kt],
        {
          [Wt[`${Kt}--disabled`]]: l
        },
        s
      ),
      children: /* @__PURE__ */ t(
        ea,
        {
          floatingStrategy: "fixed",
          placement: "right",
          kind: "invert",
          isVisible: f || !a || l ? !1 : void 0,
          offsetMainAxis: 12,
          hoverOnDelay: 400,
          useClickHookProps: { ignoreMouse: !0 },
          useDismissHookProps: {
            referencePress: !0,
            referencePressEvent: "click"
          },
          triggerRenderer: /* @__PURE__ */ h(Z, { children: [
            /* @__PURE__ */ h(
              "a",
              B(y({
                tabIndex: l ? -1 : 0,
                "aria-label": a,
                className: u(
                  Wt[`${Kt}__button`],
                  {
                    [Wt[`${Kt}__button--active`]]: n,
                    [Wt[`${Kt}__button--opacity`]]: o,
                    [Wt[`${Kt}__button--disabled`]]: l,
                    [Wt[`${Kt}__button--mobile`]]: f
                  },
                  "lc-dark-theme"
                ),
                onClick: (g) => !l && d(g, e),
                href: _
              }, c), {
                children: [
                  r,
                  f && a
                ]
              })
            ),
            !!i && vn(i, e)
          ] }),
          children: a
        }
      )
    },
    e
  );
}, yn = "lc-Navigation-module__navigation___oNBOL", kn = {
  navigation: yn
}, wn = "navigation", Cu = (_) => {
  var o = _, {
    children: e,
    className: a
  } = o, r = U(o, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ t("nav", B(y({ className: u(kn[wn], a) }, r), { children: e }));
}, yt = {
  "navigation-top-bar": "lc-NavigationTopBar-module__navigation-top-bar___WJzyv",
  "navigation-top-bar__title": "lc-NavigationTopBar-module__navigation-top-bar__title___ROYDp",
  "navigation-top-bar__alerts-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alerts-wrapper___wkJlE",
  "navigation-top-bar__alert": "lc-NavigationTopBar-module__navigation-top-bar__alert___x2xOO",
  "navigation-top-bar__alert--open": "lc-NavigationTopBar-module__navigation-top-bar__alert--open___ESpyQ",
  "navigation-top-bar__alert__wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper___rOnri",
  "navigation-top-bar__alert__wrapper--open": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper--open___v-NG3",
  "navigation-top-bar__alert--info": "lc-NavigationTopBar-module__navigation-top-bar__alert--info___kfakN",
  "navigation-top-bar__alert--success": "lc-NavigationTopBar-module__navigation-top-bar__alert--success___s3tbr",
  "navigation-top-bar__alert--warning": "lc-NavigationTopBar-module__navigation-top-bar__alert--warning___giSMt",
  "navigation-top-bar__alert--error": "lc-NavigationTopBar-module__navigation-top-bar__alert--error___N4jFl",
  "navigation-top-bar__alert__children-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__children-wrapper___cfSYX",
  "navigation-top-bar__alert__close-button": "lc-NavigationTopBar-module__navigation-top-bar__alert__close-button___odqcf",
  "navigation-top-bar__alert__cta-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__cta-wrapper___0QtM0"
}, Fr = "navigation-top-bar", Zt = `${Fr}__alert`, Uo = ({
  children: e,
  className: a,
  additionalNodes: r,
  id: _
}) => {
  const { isMobileViewEnabled: o } = A_();
  return /* @__PURE__ */ h("div", { className: u(yt[Fr], a), id: _, children: [
    /* @__PURE__ */ t("div", { className: yt[`${Fr}__alerts-wrapper`], children: e }),
    !o && r
  ] });
}, Cn = ({
  children: e,
  className: a,
  "data-testid": r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(yt[`${Fr}__title`], a),
    "data-testid": r,
    children: e
  }
), $n = ({
  className: e,
  kind: a = "info",
  closeButton: r,
  children: _,
  primaryCta: o,
  secondaryCta: l,
  isVisible: i = !0,
  id: n
}) => {
  const [d, s] = v.useState(!1), c = v.useRef(null), { isMounted: p, isOpen: m } = sa({
    isVisible: i,
    elementRef: c,
    includeSleepWakeScenario: !0
  }), f = v.useCallback(
    (C) => ar(
      C,
      ($) => s($.width < nn)
    ),
    []
  ), g = a === "warning" ? "link-inverted" : "text", w = a === "warning" ? "secondary" : "high-contrast", x = o == null ? void 0 : o.kind, S = l == null ? void 0 : l.kind, E = o || l ? /* @__PURE__ */ h("div", { className: yt[`${Zt}__cta-wrapper`], children: [
    o && /* @__PURE__ */ t(
      H,
      B(y({
        size: "compact"
      }, o), {
        kind: d ? g : x || w,
        children: o.label
      })
    ),
    l && /* @__PURE__ */ t(
      H,
      B(y({
        size: "compact"
      }, l), {
        kind: d ? g : S || w,
        children: l.label
      })
    )
  ] }) : null, N = /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ h("div", { className: yt[`${Zt}__children-wrapper`], children: [
      _,
      E
    ] }),
    r && /* @__PURE__ */ t(
      "button",
      B(y({
        className: yt[`${Zt}__close-button`]
      }, r), {
        children: /* @__PURE__ */ t(R, { source: dt })
      })
    )
  ] });
  return /* @__PURE__ */ t(Z, { children: p && /* @__PURE__ */ t("div", { ref: f, children: /* @__PURE__ */ t(
    "div",
    {
      className: u(
        yt[`${Zt}__wrapper`],
        {
          [yt[`${Zt}__wrapper--open`]]: m
        },
        "lc-dark-theme"
        // Alerts are forced into dark mode to maintain consistency of the colors
      ),
      ref: c,
      role: "status",
      children: /* @__PURE__ */ t(
        "div",
        {
          id: n,
          "data-testid": "navigation-top-bar-alert",
          className: u(
            yt[Zt],
            yt[`${Zt}--${a}`],
            {
              [yt[`${Zt}--open`]]: m
            },
            e
          ),
          children: N
        }
      )
    }
  ) }) });
};
Uo.Alert = $n;
Uo.Title = Cn;
function Rr(e, a, r, _) {
  return e === 1 ? a : r;
}
const kr = {
  "expiration-counter": "lc-ExpirationCounter-module__expiration-counter___ro9nL",
  "expiration-counter__button": "lc-ExpirationCounter-module__expiration-counter__button___Xv5Nx",
  "expiration-counter__button__number": "lc-ExpirationCounter-module__expiration-counter__button__number___9hZV4",
  "expiration-counter__button__label": "lc-ExpirationCounter-module__expiration-counter__button__label___nJAOv"
}, wr = "expiration-counter", $u = (i) => {
  var n = i, {
    id: e,
    daysLeft: a,
    url: r,
    onClick: _,
    className: o
  } = n, l = U(n, [
    "id",
    "daysLeft",
    "url",
    "onClick",
    "className"
  ]);
  return /* @__PURE__ */ t("li", { className: u(kr[wr], o), children: /* @__PURE__ */ h(
    "a",
    B(y({
      id: e,
      tabIndex: 0,
      href: r,
      onClick: (d) => _(d, e),
      className: kr[`${wr}__button`]
    }, l), {
      children: [
        /* @__PURE__ */ t("span", { className: kr[`${wr}__button__number`], children: a }),
        /* @__PURE__ */ t("span", { className: kr[`${wr}__button__label`], children: Rr(a, "day", "days") })
      ]
    })
  ) }, e);
}, Nn = {
  "mobile-navigation": "lc-MobileNavigation-module__mobile-navigation___a--p5"
}, Sn = "mobile-navigation", Nu = (_) => {
  var o = _, {
    children: e,
    className: a
  } = o, r = U(o, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ t("nav", B(y({ className: u(Nn[Sn], a) }, r), { children: e }));
}, Lo = yo({
  readOnly: !1,
  isEmpty: !1,
  setIsEmpty: () => {
  }
}), xn = ({ children: e, readOnly: a = !1, defaultIsEmpty: r = !1 }) => {
  const [_, o] = de(r);
  return /* @__PURE__ */ t(
    Lo.Provider,
    {
      value: {
        readOnly: a,
        isEmpty: _,
        setIsEmpty: o
      },
      children: e
    }
  );
}, Ot = () => ko(Lo), xa = ({
  value: e,
  noDataFallbackText: a = "No data"
}) => {
  const { setIsEmpty: r } = Ot();
  return V(() => {
    r(!e);
  }, [e, r]), /* @__PURE__ */ t(
    D,
    {
      noMargin: !0,
      semiBold: !!e,
      customColor: e ? void 0 : "var(--content-basic-secondary)",
      role: "textbox",
      "aria-readonly": "true",
      children: e || a
    }
  );
}, En = "lc-Input-module__input___505b7", ct = {
  input: En,
  "input--promo": "lc-Input-module__input--promo___5hf0s",
  "input--focused": "lc-Input-module__input--focused___rmg2U",
  "input--disabled": "lc-Input-module__input--disabled___QA4ie",
  "input--crop": "lc-Input-module__input--crop___63BIX",
  "input--error": "lc-Input-module__input--error___d2Aqj",
  "input--xsmall": "lc-Input-module__input--xsmall___6hLud",
  "input--compact": "lc-Input-module__input--compact___9Sw7d",
  "input--medium": "lc-Input-module__input--medium___gb5Z2",
  "input--large": "lc-Input-module__input--large___hfmAH",
  "input__icon--disabled": "lc-Input-module__input__icon--disabled___uTYsP",
  "input__icon--left": "lc-Input-module__input__icon--left___IBzj8",
  "input__icon--right": "lc-Input-module__input__icon--right___lw1xQ",
  "input__visibility-button": "lc-Input-module__input__visibility-button___lmD5H"
}, st = "input", ao = (e, a) => v.cloneElement(e.source, {
  "data-testid": `input-icon-${e.place}`,
  className: u(
    ct[`${st}__icon`],
    ct[`${st}__icon--${e.place}`],
    {
      [ct[`${st}__icon--disabled`]]: a
    }
  )
}), qo = v.forwardRef(
  (c, s) => {
    var p = c, {
      error: e = !1,
      disabled: a,
      icon: r = null,
      className: _,
      mainClassName: o,
      isPromo: l = !1,
      cropOnBlur: i = !0,
      noDataFallbackText: n = "No data"
    } = p, d = U(p, [
      "error",
      "disabled",
      "icon",
      "className",
      "mainClassName",
      "isPromo",
      "cropOnBlur",
      "noDataFallbackText"
    ]);
    var O;
    const m = v.useRef(null), { readOnly: f } = Ot(), g = f || d.readOnly;
    v.useImperativeHandle(s, () => m.current, []);
    const [w, x] = v.useState(!1), [S, E] = v.useState(!1), { type: N, onFocus: C, onBlur: $ } = d, b = u(
      o,
      {
        [ct[`${st}--disabled`]]: a,
        [ct[`${st}--focused`]]: w,
        [ct[`${st}--error`]]: e,
        [ct[`${st}--crop`]]: i
      },
      _
    ), k = a ? "var(--content-basic-disabled)" : "var(--content-basic-primary)", I = S ? ul : ml, T = r && r.place === "left", F = r && N !== "password" && r.place === "right", A = () => {
      var G;
      (G = m.current) == null || G.focus();
    };
    return g ? /* @__PURE__ */ t(
      xa,
      {
        value: (O = d.value) == null ? void 0 : O.toString(),
        noDataFallbackText: n
      }
    ) : /* @__PURE__ */ h(
      D,
      {
        as: "div",
        size: l ? "lg" : "md",
        className: b,
        "aria-disabled": a,
        "tab-index": "0",
        onClick: A,
        children: [
          T && ao(r, a),
          /* @__PURE__ */ t(
            "input",
            B(y({}, d), {
              ref: m,
              onFocus: (G) => {
                x(!0), C == null || C(G);
              },
              onBlur: (G) => {
                x(!1), $ == null || $(G);
              },
              disabled: a,
              type: N && !S ? N : "text"
            })
          ),
          F && ao(r, a),
          N === "password" && /* @__PURE__ */ t(
            H,
            {
              disabled: a,
              kind: "text",
              size: "compact",
              icon: /* @__PURE__ */ t(R, { customColor: k, source: I }),
              onClick: () => E((G) => !G),
              className: ct[`${st}__visibility-button`]
            }
          )
        ]
      }
    );
  }
), Tn = v.forwardRef(
  (_, r) => {
    var o = _, { inputSize: e = "medium" } = o, a = U(o, ["inputSize"]);
    const l = u(
      ct[st],
      ct[`${st}--${e}`]
    );
    return /* @__PURE__ */ t(qo, B(y({ mainClassName: l }, a), { ref: r }));
  }
), Bn = `${st}--promo`, Su = v.forwardRef(
  (e, a) => {
    const r = u(ct[st], ct[Bn]);
    return /* @__PURE__ */ t(
      qo,
      B(y({
        mainClassName: r,
        isPromo: !0
      }, e), {
        ref: a
      })
    );
  }
), In = 2, zo = 200, Ho = 400;
[
  ...[...Array(100)].map((e, a) => ({
    key: `option${a + 8}`,
    name: `Option #${a + 8}`,
    disabled: a % 4 === 0
  }))
];
const Ca = "select-all", An = (e, a) => {
  const r = [];
  return e.forEach((_, o) => {
    a(_) && r.push(o);
  }), r;
}, x_ = (e) => e.filter(
  ({ key: a, disabled: r, groupHeader: _ }) => !(a === Ca || r || _)
), ro = ({ key: e }) => e, Dn = (e, a) => e.includes(a) ? e.filter((r) => r !== a) : [...e, a], _o = Array.from(
  { length: 10 },
  (e, a) => `--surface-avatar-${a + 1}`
);
function On(e) {
  if (!e)
    return;
  const a = e.split("").reduce((r, _) => r + _.charCodeAt(0), 0);
  return `var(${_o[a % _o.length]})`;
}
function Mn(e = "", a = 2) {
  const r = e.trim().split(/\s+/), _ = r.map((l) => [...l][0]);
  if (a < 1) return "";
  if (r.length <= a)
    return _.join("").toUpperCase();
  const o = [_[0]];
  for (let l = r.length - a + 1; l < r.length; l++)
    o.push(_[l]);
  return o.join("").toUpperCase();
}
function Pn(e) {
  let a = e;
  if (e.startsWith("var(--") && e.endsWith(")")) {
    const r = e.slice(4, -1);
    a = window.getComputedStyle(document.documentElement).getPropertyValue(r).trim();
  }
  return a && I_(a, "#FFFFFF") > 3 ? "var(--color-white)" : "var(--color-black)";
}
const Fn = "lc-Avatar-module__avatar___5-kP8", Rn = "lc-Avatar-module__avatar__status___HNURz", Gn = "lc-Avatar-module__avatar__rim___2AzYM", Un = "lc-Avatar-module__avatar__image___OeTCV", Ve = {
  avatar: Fn,
  avatar__status: Rn,
  "avatar__status--available": "lc-Avatar-module__avatar__status--available___e8YYH",
  "avatar__status--unavailable": "lc-Avatar-module__avatar__status--unavailable___EZN8K",
  "avatar__status--unknown": "lc-Avatar-module__avatar__status--unknown___ig3u2",
  "avatar__status--xxxsmall": "lc-Avatar-module__avatar__status--xxxsmall___ywnfb",
  "avatar__status--circle": "lc-Avatar-module__avatar__status--circle___hluXh",
  "avatar__status--xxsmall": "lc-Avatar-module__avatar__status--xxsmall___1cyef",
  "avatar__status--xsmall": "lc-Avatar-module__avatar__status--xsmall___oamOI",
  "avatar__status--small": "lc-Avatar-module__avatar__status--small___mXtgJ",
  "avatar__status--medium": "lc-Avatar-module__avatar__status--medium___itZ--",
  "avatar__status--large": "lc-Avatar-module__avatar__status--large___xhFK7",
  "avatar__status--xlarge": "lc-Avatar-module__avatar__status--xlarge___Tt--f",
  "avatar__status--xxlarge": "lc-Avatar-module__avatar__status--xxlarge___nlhY4",
  "avatar__status--xxxlarge": "lc-Avatar-module__avatar__status--xxxlarge___jOQH-",
  "avatar__status--rounded-square": "lc-Avatar-module__avatar__status--rounded-square___vbnS3",
  avatar__rim: Gn,
  "avatar__rim--xxxsmall": "lc-Avatar-module__avatar__rim--xxxsmall___i9Sfv",
  "avatar__rim--xxsmall": "lc-Avatar-module__avatar__rim--xxsmall___oTxsG",
  "avatar__rim--xsmall": "lc-Avatar-module__avatar__rim--xsmall___EP67J",
  "avatar__rim--small": "lc-Avatar-module__avatar__rim--small___GO4DE",
  "avatar__rim--medium": "lc-Avatar-module__avatar__rim--medium___PwmzG",
  "avatar__rim--large": "lc-Avatar-module__avatar__rim--large___uvcTs",
  "avatar__rim--xlarge": "lc-Avatar-module__avatar__rim--xlarge___bjiXr",
  "avatar__rim--xxlarge": "lc-Avatar-module__avatar__rim--xxlarge___YjUzl",
  "avatar__rim--xxxlarge": "lc-Avatar-module__avatar__rim--xxxlarge___KvgAh",
  avatar__image: Un,
  "avatar__icon--xxxsmall": "lc-Avatar-module__avatar__icon--xxxsmall___wMbtg",
  "avatar__icon--xxsmall": "lc-Avatar-module__avatar__icon--xxsmall___x736T",
  "avatar__icon--xsmall": "lc-Avatar-module__avatar__icon--xsmall___FEY-4",
  "avatar__icon--small": "lc-Avatar-module__avatar__icon--small___2YWc9",
  "avatar__icon--medium": "lc-Avatar-module__avatar__icon--medium___zNzZn",
  "avatar__icon--large": "lc-Avatar-module__avatar__icon--large___xKot9",
  "avatar__icon--xlarge": "lc-Avatar-module__avatar__icon--xlarge___SaIEW",
  "avatar__icon--xxlarge": "lc-Avatar-module__avatar__icon--xxlarge___nKxnM",
  "avatar__icon--xxxlarge": "lc-Avatar-module__avatar__icon--xxxlarge___2MVJa",
  "avatar--circle": "lc-Avatar-module__avatar--circle___Ys84D",
  "avatar--rounded-square": "lc-Avatar-module__avatar--rounded-square___awk7U",
  "avatar--xxxsmall": "lc-Avatar-module__avatar--xxxsmall___S5mVR",
  "avatar--xxsmall": "lc-Avatar-module__avatar--xxsmall___i7spO",
  "avatar--xsmall": "lc-Avatar-module__avatar--xsmall___WWgCM",
  "avatar--small": "lc-Avatar-module__avatar--small___KH6pw",
  "avatar--medium": "lc-Avatar-module__avatar--medium___un4U9",
  "avatar--large": "lc-Avatar-module__avatar--large___C8hm4",
  "avatar--xlarge": "lc-Avatar-module__avatar--xlarge___hjIy5",
  "avatar--xxlarge": "lc-Avatar-module__avatar--xxlarge___AjkHw",
  "avatar--xxxlarge": "lc-Avatar-module__avatar--xxxlarge___4Hhp9"
}, Se = "avatar", M_ = (m) => {
  var f = m, {
    alt: e,
    className: a,
    color: r,
    shape: _ = "circle",
    size: o = "medium",
    src: l,
    status: i,
    text: n,
    type: d,
    withRim: s = !1,
    style: c
  } = f, p = U(f, [
    "alt",
    "className",
    "color",
    "shape",
    "size",
    "src",
    "status",
    "text",
    "type",
    "withRim",
    "style"
  ]);
  const g = d === "image" && !l, [w, x] = v.useState(g), S = d === "image" && !!l && !w, E = d === "text", N = ["xxxsmall", "xxsmall", "xsmall"].includes(o) ? 1 : 2, C = Mn(n, N), $ = ["xxxsmall", "xxsmall", "xsmall", "small"].includes(o), b = r || On(n), k = b ? Pn(b) : void 0, I = E ? { backgroundColor: b } : {}, T = u(y({
    [Ve[Se]]: !0,
    [Ve[`${Se}--${_}`]]: !0,
    [Ve[`${Se}--${o}`]]: !0,
    [Ve[`${Se}--with-rim`]]: s
  }, a ? { [`${a}`]: a } : {})), F = u(
    Ve[`${Se}__status`],
    Ve[`${Se}__status--${_}`],
    Ve[`${Se}__status--${o}`],
    ...i ? [Ve[`${Se}__status--${i}`]] : []
  ), A = u(
    Ve[`${Se}__icon`],
    Ve[`${Se}__icon--${o}`]
  ), O = u(
    Ve[`${Se}__rim`],
    Ve[`${Se}__rim--${o}`]
  ), G = (L) => $ ? "2xs" : ["medium"].includes(L) ? "xs" : ["large", "xlarge"].includes(L) ? "sm" : ["xxlarge"].includes(L) ? "lg" : "xl", P = v.useCallback(() => x(!0), []);
  return v.useEffect(() => {
    x(g);
  }, [g]), /* @__PURE__ */ h(
    "div",
    B(y({
      className: T,
      style: y(y({}, I), c)
    }, p), {
      children: [
        s && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${Se}__rim`,
            className: O
          }
        ),
        i && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${Se}__status`,
            className: F
          }
        ),
        S && /* @__PURE__ */ t(
          "img",
          {
            className: Ve[`${Se}__image`],
            src: l,
            alt: e,
            onError: P
          }
        ),
        E && /* @__PURE__ */ t(
          he,
          {
            as: "span",
            size: G(o),
            style: { color: k },
            bold: $,
            uppercase: $,
            children: C
          }
        ),
        w && /* @__PURE__ */ t(
          R,
          {
            "data-testid": `${Se}__icon`,
            className: A,
            source: pl
          }
        )
      ]
    })
  );
}, Ln = {
  "field-description": "lc-FieldDescription-module__field-description___x5rXY"
}, qn = "field-description", Vr = (_) => {
  var o = _, { children: e, className: a = "" } = o, r = U(o, ["children", "className"]);
  const l = u(Ln[qn], a);
  return /* @__PURE__ */ t(D, B(y({ as: "span", size: "sm" }, r), { className: l, children: e }));
}, zn = "lc-Checkbox-module__checkbox___D0D4S", Hn = "lc-Checkbox-module__checkbox__label___I472A", Vn = "lc-Checkbox-module__checkbox__text___Ex7K1", Wn = "lc-Checkbox-module__checkbox__input___3krUF", Kn = "lc-Checkbox-module__checkbox__checkmark___eZIG1", Yn = "lc-Checkbox-module__checkbox__helper___hwxAV", Xn = "lc-Checkbox-module__checkbox__square___yjtrH", Lt = {
  checkbox: zn,
  checkbox__label: Hn,
  checkbox__text: Vn,
  checkbox__input: Wn,
  checkbox__checkmark: Kn,
  "checkbox--read-only": "lc-Checkbox-module__checkbox--read-only___zeYW7",
  checkbox__helper: Yn,
  "checkbox--selected": "lc-Checkbox-module__checkbox--selected___pU3Xh",
  checkbox__square: Xn,
  "checkbox--disabled": "lc-Checkbox-module__checkbox--disabled___kRNDo"
}, qt = "checkbox", Wr = v.forwardRef(
  (d, n) => {
    var s = d, {
      checked: e,
      indeterminate: a = !1,
      disabled: r,
      children: _,
      description: o,
      className: l
    } = s, i = U(s, [
      "checked",
      "indeterminate",
      "disabled",
      "children",
      "description",
      "className"
    ]);
    const { readOnly: c } = Ot(), p = c || i.readOnly;
    return /* @__PURE__ */ h(
      "div",
      {
        className: u(Lt[qt], l, {
          [Lt[`${qt}--selected`]]: e,
          [Lt[`${qt}--disabled`]]: r,
          [Lt[`${qt}--indeterminate`]]: a,
          [Lt[`${qt}--read-only`]]: p
        }),
        children: [
          /* @__PURE__ */ h("label", { className: Lt[`${qt}__label`], children: [
            /* @__PURE__ */ t(
              "input",
              B(y({}, i), {
                ref: (m) => {
                  m && (m.indeterminate = a, typeof n == "function" ? n(m) : n && (n.current = m));
                },
                checked: e,
                disabled: r,
                className: Lt[`${qt}__input`],
                type: "checkbox"
              })
            ),
            _ && /* @__PURE__ */ t(D, { as: "div", size: "md", className: Lt[`${qt}__text`], children: _ })
          ] }),
          o && /* @__PURE__ */ t(Vr, { className: Lt[`${qt}__helper`], children: o })
        ]
      }
    );
  }
), Oe = {
  "item-wrapper": "lc-PickerListItem-module__item-wrapper___xIByl",
  "item-wrapper__first": "lc-PickerListItem-module__item-wrapper__first___qcOML",
  "item-wrapper__last": "lc-PickerListItem-module__item-wrapper__last___Ac2Y-",
  "picker-list__item": "lc-PickerListItem-module__picker-list__item___Pvh-4",
  "picker-list__item--select-all": "lc-PickerListItem-module__picker-list__item--select-all___P0GzV",
  "picker-list__item__header": "lc-PickerListItem-module__picker-list__item__header___Besp-",
  "picker-list__item__custom": "lc-PickerListItem-module__picker-list__item__custom___UbY70",
  "picker-list__item__checkbox": "lc-PickerListItem-module__picker-list__item__checkbox___d5uLj",
  "picker-list__item__avatar": "lc-PickerListItem-module__picker-list__item__avatar___9AS0i",
  "picker-list__item__icon": "lc-PickerListItem-module__picker-list__item__icon___x6wiv",
  "picker-list__item__label-container": "lc-PickerListItem-module__picker-list__item__label-container___emTD1",
  "picker-list__item__label": "lc-PickerListItem-module__picker-list__item__label___kAkZc",
  "picker-list__item__main-label": "lc-PickerListItem-module__picker-list__item__main-label___8CJdc",
  "picker-list__item__secondary-label": "lc-PickerListItem-module__picker-list__item__secondary-label___i-DOd"
}, pt = "picker-list__item", Zn = ({
  index: e,
  isActive: a,
  isSelected: r,
  listElementsRef: _,
  onSelect: o,
  getItemProps: l,
  item: i,
  numberOfItems: n
}) => {
  const d = (c) => {
    var m, f;
    if ((m = c == null ? void 0 : c.customElement) != null && m.listItemBody)
      return /* @__PURE__ */ t("div", { className: Oe[`${pt}__custom`], children: c.customElement.listItemBody });
    const p = (g) => {
      var w;
      return ((w = g.avatar) == null ? void 0 : w.type) || (g.avatarSrc ? "image" : "text");
    };
    return /* @__PURE__ */ h(Z, { children: [
      c.showCheckbox && /* @__PURE__ */ t(
        Wr,
        {
          className: Oe[`${pt}__checkbox`],
          checked: r
        }
      ),
      c.icon && /* @__PURE__ */ t(
        R,
        {
          className: Oe[`${pt}__icon`],
          kind: "link",
          source: c.icon
        }
      ),
      (c.avatar || c.avatarSrc) && /* @__PURE__ */ t(
        M_,
        {
          className: Oe[`${pt}__avatar`],
          src: ((f = c.avatar) == null ? void 0 : f.src) || c.avatarSrc,
          type: p(c),
          text: c.name,
          alt: c.name,
          size: "xxsmall"
        }
      ),
      /* @__PURE__ */ h("div", { className: Oe[`${pt}__label-container`], children: [
        /* @__PURE__ */ t(
          D,
          {
            as: "span",
            className: u([Oe[`${pt}__label`]], {
              [Oe[`${pt}__main-label`]]: c.secondaryText
            }),
            "aria-disabled": c.disabled,
            children: c.name
          }
        ),
        c.secondaryText && /* @__PURE__ */ t("span", { className: Oe[`${pt}__secondary-label`], children: c.secondaryText })
      ] })
    ] });
  };
  if (i.groupHeader)
    return /* @__PURE__ */ t(
      "div",
      B(y({
        id: `item-${e}`,
        role: "group",
        className: Oe[`${pt}__header`]
      }, l()), {
        children: /* @__PURE__ */ t(he, { size: "2xs", uppercase: !0, bold: !0, as: "div", children: i.name })
      }),
      i.key
    );
  const s = (c) => {
    !i.disabled && o(c);
  };
  return /* @__PURE__ */ t(
    "div",
    B(y({
      id: i.key,
      tabIndex: a ? 0 : -1,
      ref: (c) => {
        c && (_.current[e] = c);
      },
      role: "option",
      "aria-setsize": n,
      "aria-posinset": e + 1
    }, l({
      onClick: () => s(i.key)
    })), {
      className: u(Oe["item-wrapper"], {
        [Oe["item-wrapper__first"]]: e === 0 && !i.groupHeader,
        [Oe["item-wrapper__last"]]: e === n - 1 && !i.groupHeader
      }),
      children: /* @__PURE__ */ h(
        "div",
        {
          "aria-selected": r,
          "aria-disabled": i.disabled,
          "aria-current": a && !i.disabled,
          className: u(Oe[pt], {
            [Oe[`${pt}--select-all`]]: i.key === Ca
          }),
          children: [
            d(i),
            r && !i.showCheckbox && /* @__PURE__ */ t(
              R,
              {
                kind: "link",
                source: Na,
                customColor: "var(--content-basic-info)"
              }
            )
          ]
        }
      )
    }),
    i.key
  );
}, jn = "lc-PickerList-module__listbox___GgFk0", Ma = {
  listbox: jn,
  "no-results": "lc-PickerList-module__no-results___JSeou",
  "listbox-wrapper": "lc-PickerList-module__listbox-wrapper___1mIgW",
  "no-results-text": "lc-PickerList-module__no-results-text___r-f51"
}, Vo = ({
  context: e,
  setFloating: a,
  floatingStyles: r,
  maxHeight: _,
  options: o,
  activeIndex: l,
  selectedKeys: i,
  listElementsRef: n,
  isPositioned: d,
  searchDisabled: s,
  onItemRemove: c,
  setPointer: p,
  onSelect: m,
  getFloatingProps: f,
  getItemProps: g,
  emptyStateText: w = "No results found",
  hideWhenEmpty: x = !1,
  pickerType: S = "single",
  listClassName: E,
  virtuosoProps: N
}) => {
  const [C, $] = v.useState(0), b = Xt(null), k = o.length, I = v.useCallback(
    (A) => {
      A !== C && (A < _ ? $(A + (k - 1) * In) : $(_));
    },
    [k]
  );
  if (V(() => {
    var A;
    s && d && l !== null && ((A = b.current) == null || A.focus());
  }, [s, d, l]), V(() => {
    n.current = new Array(o.length);
  }, [o.length]), o.length === 0)
    return x ? null : /* @__PURE__ */ t(C_, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
      "div",
      {
        className: u(Ma.listbox, Ma["no-results"]),
        ref: a,
        tabIndex: -1,
        style: r,
        children: /* @__PURE__ */ t("div", { className: Ma["no-results-text"], children: w })
      }
    ) });
  const T = (A) => i.includes(A) || A === Ca && i.length === x_(o).length, F = () => {
    S === "multi" && c(i[i.length - 1]);
  };
  return /* @__PURE__ */ t(C_, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
    "div",
    {
      "data-testid": "picker-list",
      ref: a,
      tabIndex: -1,
      className: u(Ma.listbox, E),
      style: B(y({}, r), {
        maxHeight: _
      }),
      children: /* @__PURE__ */ t(
        "div",
        B(y({
          ref: b,
          tabIndex: 0,
          "aria-multiselectable": S === "multi",
          className: Ma["listbox-wrapper"]
        }, f({
          onKeyDown(A) {
            p(!1), A.key === "Enter" && l !== null && m(o[l].key), (A.key === "Backspace" || A.key === "Delete") && F(), A.key === " " && A.preventDefault();
          },
          onKeyUp(A) {
            A.key === " " && l !== null && m(o[l].key);
          },
          onPointerMove() {
            p(!0);
          }
        })), {
          children: /* @__PURE__ */ t(
            Jl,
            B(y({
              totalListHeightChanged: I,
              style: { height: `${C}px`, maxHeight: _ },
              totalCount: o.length,
              data: o,
              increaseViewportBy: 200
            }, N), {
              itemContent: (A, O) => /* @__PURE__ */ t(
                Zn,
                {
                  index: A,
                  getItemProps: g,
                  listElementsRef: n,
                  isActive: l === A,
                  isSelected: T(O.key),
                  onSelect: m,
                  item: O,
                  numberOfItems: k
                }
              )
            })
          )
        })
      )
    }
  ) });
}, Me = {
  "picker-trigger": "lc-PickerTrigger-module__picker-trigger___nSDgb",
  "picker-trigger--multi-select": "lc-PickerTrigger-module__picker-trigger--multi-select___XCt1K",
  "picker-trigger--multi-select--with-items": "lc-PickerTrigger-module__picker-trigger--multi-select--with-items___0VU14",
  "picker-trigger__content": "lc-PickerTrigger-module__picker-trigger__content___tAfyM",
  "picker-trigger__content--compact": "lc-PickerTrigger-module__picker-trigger__content--compact___iudK8",
  "picker-trigger__content--medium": "lc-PickerTrigger-module__picker-trigger__content--medium___1TZtT",
  "picker-trigger__content--large": "lc-PickerTrigger-module__picker-trigger__content--large___VUVXl",
  "picker-trigger__content--with-items": "lc-PickerTrigger-module__picker-trigger__content--with-items___6R0wr",
  "picker-trigger__controls": "lc-PickerTrigger-module__picker-trigger__controls___W7nRe",
  "picker-trigger__controls--compact": "lc-PickerTrigger-module__picker-trigger__controls--compact___y9w3B",
  "picker-trigger__controls--medium": "lc-PickerTrigger-module__picker-trigger__controls--medium___FYWxm",
  "picker-trigger__controls--large": "lc-PickerTrigger-module__picker-trigger__controls--large___jHbAJ",
  "picker-trigger__clear-icon": "lc-PickerTrigger-module__picker-trigger__clear-icon___Jgz6U",
  "picker-trigger__chevron-icon": "lc-PickerTrigger-module__picker-trigger__chevron-icon___Itnmh",
  "picker-trigger--disabled": "lc-PickerTrigger-module__picker-trigger--disabled___PKfb-",
  "picker-trigger--focused": "lc-PickerTrigger-module__picker-trigger--focused___xbQpR",
  "picker-trigger--error": "lc-PickerTrigger-module__picker-trigger--error___As8hf"
}, xe = "picker-trigger", Jn = ({
  setReference: e,
  getReferenceProps: a,
  testId: r,
  size: _ = "medium",
  isMultiSelect: o,
  isItemSelected: l,
  hideClearButton: i,
  isDisabled: n,
  isRequired: d,
  isOpen: s,
  isError: c,
  onClear: p,
  children: m,
  setTriggerFocus: f,
  onToggle: g
}) => {
  const w = u(
    Me[xe],
    Me[`${xe}--${_}`],
    o && Me[`${xe}--multi-select`],
    o && l && Me[`${xe}--multi-select--with-items`],
    n && Me[`${xe}--disabled`],
    s && Me[`${xe}--focused`],
    c && Me[`${xe}--error`]
  ), x = !i && l && !n && !d, S = (N) => {
    N.stopPropagation(), p();
  }, E = (N) => {
    !n && !(s && N.target.tagName === "BUTTON") && g();
  };
  return v.useEffect(() => {
    s || f(!1);
  }, [s]), /* @__PURE__ */ h(
    "button",
    B(y({
      tabIndex: n ? -1 : 0,
      "aria-disabled": n,
      disabled: n,
      className: w,
      "data-testid": r,
      ref: e,
      type: "button"
    }, a()), {
      onFocus: () => f(!0),
      onBlur: () => f(!1),
      onClick: E,
      children: [
        /* @__PURE__ */ t(
          D,
          {
            as: "div",
            className: u(
              Me[`${xe}__content`],
              Me[`${xe}__content--${_}`],
              o && l && Me[`${xe}__content--with-items`]
            ),
            children: m
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: u(
              Me[`${xe}__controls`],
              Me[`${xe}__controls--${_}`]
            ),
            children: [
              x && /* @__PURE__ */ t(
                "div",
                {
                  "data-testid": `${xe}__clear-icon`,
                  className: Me[`${xe}__clear-icon`],
                  onClick: S,
                  children: /* @__PURE__ */ t(R, { kind: "primary", size: "small", source: dt })
                }
              ),
              /* @__PURE__ */ t(
                R,
                {
                  "data-testid": `${xe}__chevron-icon`,
                  className: Me[`${xe}__chevron-icon`],
                  source: s ? or : ta,
                  size: "medium",
                  disabled: n
                }
              )
            ]
          }
        )
      ]
    })
  );
}, Qn = "lc-Tag-module__tag___0Cfjz", ec = "lc-Tag-module__tag__remove___dYHt9", tc = "lc-Tag-module__tag__node___3hHHq", ac = "lc-Tag-module__tag__content___w-HK1", We = {
  tag: Qn,
  "tag__content-wrapper": "lc-Tag-module__tag__content-wrapper___QrjSg",
  "tag--success": "lc-Tag-module__tag--success___Jr03z",
  tag__remove: ec,
  "tag--error": "lc-Tag-module__tag--error___zAr59",
  "tag--warning": "lc-Tag-module__tag--warning___6FwV2",
  "tag--info": "lc-Tag-module__tag--info___Zk-om",
  "tag--purple": "lc-Tag-module__tag--purple___8cY3y",
  "tag--black": "lc-Tag-module__tag--black___hGskP",
  "tag--outline": "lc-Tag-module__tag--outline___d-iCv",
  "tag--gray": "lc-Tag-module__tag--gray___EKXt6",
  "tag--gradient01": "lc-Tag-module__tag--gradient01___MStHW",
  "tag--gradient02": "lc-Tag-module__tag--gradient02___9tDwp",
  "tag--gradient03": "lc-Tag-module__tag--gradient03___-Sy8M",
  "tag--gradient04": "lc-Tag-module__tag--gradient04___WA5o6",
  "tag--gradient05": "lc-Tag-module__tag--gradient05___RUXqI",
  "tag--gradient06": "lc-Tag-module__tag--gradient06___FucnK",
  "tag--gradient07": "lc-Tag-module__tag--gradient07___d4-hS",
  "tag--gradient08": "lc-Tag-module__tag--gradient08___cSb8n",
  "tag--gradient09": "lc-Tag-module__tag--gradient09___rqbii",
  "tag--gradient10": "lc-Tag-module__tag--gradient10___5GHLp",
  "tag--gradient11": "lc-Tag-module__tag--gradient11___c6LfC",
  "tag--medium": "lc-Tag-module__tag--medium___lxV77",
  "tag--small": "lc-Tag-module__tag--small___plGiu",
  "tag--icon-only": "lc-Tag-module__tag--icon-only___WYMzu",
  "tag--large": "lc-Tag-module__tag--large___IUzeG",
  "tag--xlarge": "lc-Tag-module__tag--xlarge___2i2T7",
  "tag--text-white": "lc-Tag-module__tag--text-white___Gc3-T",
  "tag--text-black": "lc-Tag-module__tag--text-black___0UD4h",
  "tag--dismissible-on-hover": "lc-Tag-module__tag--dismissible-on-hover___Id-yT",
  "tag__remove--hover": "lc-Tag-module__tag__remove--hover___tILiT",
  tag__node: tc,
  tag__content: ac
}, Ke = "tag", rc = (e) => e ? I_(e, "#FFFFFF") > 4.5 ? "text-white" : "text-black" : "", Wo = (g) => {
  var w = g, {
    className: e = "",
    children: a,
    dismissibleOnHover: r = !1,
    disabled: _ = !1,
    size: o = "medium",
    kind: l = "default",
    onRemove: i,
    outline: n = !1,
    leftNode: d,
    rightNode: s,
    customColor: c,
    iconOnly: p = !1,
    value: m
  } = w, f = U(w, [
    "className",
    "children",
    "dismissibleOnHover",
    "disabled",
    "size",
    "kind",
    "onRemove",
    "outline",
    "leftNode",
    "rightNode",
    "customColor",
    "iconOnly",
    "value"
  ]);
  const x = r || i && p, S = u(
    We[Ke],
    e,
    We[`${Ke}--${o}`],
    We[`${Ke}--${l}`],
    {
      [We[`${Ke}--outline`]]: n,
      [We[`${Ke}--${rc(c)}`]]: !!c,
      [We[`${Ke}--icon-only`]]: p,
      [We[`${Ke}--dismissible-on-hover`]]: x
    }
  ), E = o === "small" ? "small" : "medium", N = o === "small" ? "sm" : "md", C = () => c ? n ? {
    style: {
      backgroundColor: "transparent",
      color: c,
      borderColor: c
    }
  } : { style: { backgroundColor: c } } : {}, $ = () => {
    if (c)
      return n ? c : I_(c, "#FFFFFF") > 4.5 ? "#FFFFFF" : "#000000";
  };
  return /* @__PURE__ */ h(
    D,
    B(y(y({
      className: S
    }, f), C()), {
      as: "div",
      size: N,
      children: [
        /* @__PURE__ */ h("div", { className: We[`${Ke}__content-wrapper`], children: [
          d && !p && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-left-node",
              className: We[`${Ke}__node`],
              style: { color: $() },
              children: d
            }
          ),
          /* @__PURE__ */ t("div", { className: We[`${Ke}__content`], children: m || a }),
          s && !p && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-right-node",
              className: We[`${Ke}__node`],
              style: { color: $() },
              children: s
            }
          )
        ] }),
        i && !_ && /* @__PURE__ */ t(
          "span",
          {
            tabIndex: -1,
            title: "Remove",
            onClick: i,
            role: "button",
            "aria-label": "Remove tag",
            className: u(We[`${Ke}__remove`], {
              [We[`${Ke}__remove--hover`]]: x
            }),
            children: /* @__PURE__ */ t(
              R,
              {
                "data-dismiss-icon": !0,
                source: dt,
                size: E,
                customColor: $()
              }
            )
          }
        )
      ]
    })
  );
}, Pe = {
  "picker-trigger-body": "lc-PickerTriggerBody-module__picker-trigger-body___598fZ",
  "picker-trigger-body--single": "lc-PickerTriggerBody-module__picker-trigger-body--single___irxmq",
  "picker-trigger-body__item-container": "lc-PickerTriggerBody-module__picker-trigger-body__item-container___AnGk3",
  "picker-trigger-body__item": "lc-PickerTriggerBody-module__picker-trigger-body__item___k1S-g",
  "picker-trigger-body__item__content": "lc-PickerTriggerBody-module__picker-trigger-body__item__content___SKkl7",
  "picker-trigger-body__item__avatar": "lc-PickerTriggerBody-module__picker-trigger-body__item__avatar___gW6Qa",
  "picker-trigger-body__item__icon": "lc-PickerTriggerBody-module__picker-trigger-body__item__icon___TQrP2",
  "picker-trigger-body__placeholder": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder___IdI0e",
  "picker-trigger-body__placeholder--disabled": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder--disabled___24BT1",
  "picker-trigger-body__input": "lc-PickerTriggerBody-module__picker-trigger-body__input___O7ypn",
  "picker-trigger-body__input--compact": "lc-PickerTriggerBody-module__picker-trigger-body__input--compact___0ml2Q",
  "picker-trigger-body__input--medium": "lc-PickerTriggerBody-module__picker-trigger-body__input--medium___Hstke",
  "picker-trigger-body__input--large": "lc-PickerTriggerBody-module__picker-trigger-body__input--large___jQE7Q",
  "picker-trigger-body__tag": "lc-PickerTriggerBody-module__picker-trigger-body__tag___usvP3",
  "picker-trigger-body__tag--compact": "lc-PickerTriggerBody-module__picker-trigger-body__tag--compact___o4dKd",
  "picker-trigger-body__tag--medium": "lc-PickerTriggerBody-module__picker-trigger-body__tag--medium___uU1CL",
  "picker-trigger-body__tag--large": "lc-PickerTriggerBody-module__picker-trigger-body__tag--large___IBtox"
}, Fe = "picker-trigger-body", _c = ({
  isOpen: e,
  isSearchDisabled: a,
  isDisabled: r,
  placeholder: _,
  selectedItems: o,
  type: l,
  clearSearchAfterSelection: i,
  size: n = "medium",
  onItemRemove: d,
  onSelect: s,
  onFilter: c,
  onClear: p,
  searchPhrase: m,
  virtualItemRef: f,
  isTriggerFocused: g,
  inputRef: w,
  inputProps: x
}) => {
  const S = e && !a;
  v.useEffect(() => {
    i && w != null && w.current && w.current.focus();
  }, [o, i]);
  const E = (k) => {
    k.key === "Backspace" && o && o.length > 0 && (k.preventDefault(), l === "multi" ? d(o[o.length - 1].key) : p()), k.key === "Delete" && (k.preventDefault(), p());
  };
  v.useEffect(() => (!e && g ? document.addEventListener("keydown", E) : document.removeEventListener("keydown", E), () => document.removeEventListener("keydown", E)), [e, o, g]);
  const N = (k) => {
    var I;
    return l === "single" && e && !a ? null : (I = k == null ? void 0 : k.customElement) != null && I.selectedItemBody ? /* @__PURE__ */ t("div", { className: Pe[`${Fe}__item`], children: k.customElement.selectedItemBody }) : /* @__PURE__ */ h("div", { className: Pe[`${Fe}__item`], children: [
      k.icon && /* @__PURE__ */ t(
        R,
        {
          source: k.icon,
          className: Pe[`${Fe}__item__icon`]
        }
      ),
      k.avatarSrc && /* @__PURE__ */ t(
        "img",
        {
          src: k.avatarSrc,
          alt: "",
          className: Pe[`${Fe}__item__avatar`]
        }
      ),
      /* @__PURE__ */ t("div", { className: Pe[`${Fe}__item__content`], children: k.name })
    ] });
  }, C = (k) => c(k.target.value), $ = (k) => {
    var I, T;
    (I = f.current) != null && I.id && k.key === "Enter" && s((T = f.current) == null ? void 0 : T.id), l === "multi" && (k.key === "Backspace" || k.key === "Delete") && !m && o && (o == null ? void 0 : o.length) > 0 && d(o[o.length - 1].key);
  }, b = () => /* @__PURE__ */ t(
    "input",
    B(y({}, x), {
      ref: w,
      className: u(
        Pe[`${Fe}__input`],
        Pe[`${Fe}__input--${n}`]
      ),
      placeholder: _,
      onChange: C,
      onKeyDown: $,
      autoFocus: !0,
      value: m
    })
  );
  return !o || o.length === 0 ? S ? b() : /* @__PURE__ */ t(
    "div",
    {
      className: u({
        [Pe[`${Fe}__placeholder`]]: !0,
        [Pe[`${Fe}__placeholder--disabled`]]: r
      }),
      children: _
    }
  ) : /* @__PURE__ */ h(
    "div",
    {
      className: u(Pe[Fe], {
        [Pe[`${Fe}--single`]]: l === "single"
      }),
      children: [
        /* @__PURE__ */ t("div", { className: Pe[`${Fe}__item-container`], children: l === "single" ? N(o[0]) : o.map((k) => /* @__PURE__ */ t(
          Wo,
          B(y({
            className: u(
              Pe[`${Fe}__tag`],
              Pe[`${Fe}__tag--${n}`]
            ),
            disabled: r,
            onRemove: (I) => {
              I.stopPropagation(), d(k.key);
            }
          }, k.selectedTagOptions), {
            children: N(k)
          }),
          k.key
        )) }),
        S && b()
      ]
    }
  );
}, oc = 10, Ko = ({
  disabled: e,
  items: a,
  placement: r,
  minListHeight: _,
  maxListHeight: o,
  floatingStrategy: l,
  useDismissHookProps: i,
  useClickHookProps: n,
  isOpen: d,
  onVisibilityChange: s,
  searchPhrase: c
}) => {
  const p = lr(), [m, f] = v.useState(!1), [g, w] = v.useState(null), [x, S] = v.useState(o), E = v.useRef([]), N = v.useRef(null);
  v.useEffect(() => {
    N.current = null, w(null);
  }, [c]);
  const { refs: C, floatingStyles: $, context: b, isPositioned: k } = ir({
    nodeId: p,
    open: d,
    strategy: l,
    onOpenChange: s,
    whileElementsMounted: cr,
    placement: r,
    middleware: [
      nr(4),
      qr({ padding: 10 }),
      B_(),
      xo({
        apply({ availableHeight: L, rects: M, elements: q }) {
          Xl.flushSync(() => {
            S(
              Math.max(
                Math.min(o, Number(L)),
                _
              )
            );
          }), Object.assign(q.floating.style, {
            width: `${M.reference.width}px`
          });
        },
        padding: oc
      })
    ]
  }), I = sr(b, y({
    enabled: !e,
    keyboardHandlers: !1,
    toggle: !1
  }, n)), T = ur(b, { role: "listbox" }), F = dr(b, i), A = Kl(b, {
    enabled: a.length > 0 && !e,
    listRef: E,
    activeIndex: g,
    onNavigate: w,
    virtual: !0,
    virtualItemRef: N,
    disabledIndices: An(
      a,
      (L) => !!L.disabled || !!L.groupHeader
    )
  }), { getReferenceProps: O, getFloatingProps: G, getItemProps: P } = mr(
    [I, F, T, A]
  );
  return !d && m && f(!1), {
    getReferenceProps: O,
    getFloatingProps: G,
    getItemProps: P,
    setReference: C.setReference,
    floatingStyles: $,
    isPositioned: k,
    context: b,
    nodeId: p,
    setFloating: C.setFloating,
    activeIndex: g,
    listElementsRef: E,
    virtualItemRef: N,
    maxHeight: x,
    pointer: m,
    setPointer: f
  };
}, Yo = ({
  selected: e,
  options: a,
  type: r,
  selectAllOptionText: _,
  onSelect: o,
  setOpen: l,
  clearSearchAfterSelection: i,
  inputRef: n
}) => {
  const [d, s] = v.useState(
    () => (e == null ? void 0 : e.map(ro)) || []
  ), c = e !== void 0, p = c ? (e == null ? void 0 : e.map(ro)) || [] : d, [m, f] = v.useState(""), g = (C) => f(C), w = (C) => {
    r === "single" ? N(C) : (s(p.filter(($) => $ !== C)), o((e == null ? void 0 : e.filter(({ key: $ }) => $ !== C)) || null));
  }, x = () => {
    !c && s([]), o(null), f(""), l(!1);
  }, S = () => {
    g(""), n.current && (n.current.value = "");
  }, E = v.useMemo(() => {
    const C = r === "multi" && _;
    let $ = a;
    return m && ($ = $.filter((b) => {
      var F;
      if (b.groupHeader)
        return !0;
      const k = m.toLowerCase(), I = b.name.toLowerCase(), T = (F = b.secondaryText) == null ? void 0 : F.toLowerCase();
      return I.includes(k) || (T == null ? void 0 : T.includes(k));
    }).filter(
      (b, k, I) => {
        var T;
        return !(b.groupHeader && ((T = I[k + 1]) != null && T.groupHeader || k === I.length - 1));
      }
    )), C && $.length > 1 && ($ = [
      {
        key: Ca,
        name: _
      },
      ...$
    ]), $;
  }, [m, a, r, _]), N = (C) => {
    const $ = a.find((b) => b.key === C);
    (!$ || $.disabled) && C !== Ca || (r === "single" ? (s(() => ($ && o([$]), [C])), l(!1), i && S()) : C === Ca ? p.length === x_(a).length ? s(() => (o(null), [])) : s(() => {
      const b = x_(a);
      return o(b), b.map(({ key: k }) => k);
    }) : (c ? p.includes(C) ? (o(
      (e == null ? void 0 : e.filter(({ key: b }) => b !== C)) || null
    ), s((b) => b.filter((k) => k !== C))) : (o([...e || [], $]), s((b) => [...b, C])) : s((b) => {
      const k = Dn(b, C);
      return o(a.filter(({ key: I }) => k.includes(I))), k;
    }), i && S()));
  };
  return {
    selectedKeys: p,
    items: E,
    searchPhrase: m,
    handleSelect: N,
    handleOnFilter: g,
    handleItemRemove: w,
    handleClear: x
  };
}, lc = {
  "picker-wrapper": "lc-Picker-module__picker-wrapper___uaLHq"
}, xu = (M) => {
  var q = M, {
    id: e,
    className: a,
    listClassName: r,
    minListHeight: _ = zo,
    maxListHeight: o = Ho,
    disabled: l,
    error: i,
    options: n,
    selected: d,
    size: s = "medium",
    placeholder: c = "Select option",
    isRequired: p,
    noSearchResultText: m = "No results found",
    selectAllOptionText: f,
    type: g = "single",
    searchDisabled: w = !1,
    hideClearButton: x,
    isVisible: S,
    onOpen: E,
    onClose: N,
    openedOnInit: C = !1,
    clearSearchAfterSelection: $ = !0,
    onSelect: b,
    placement: k,
    floatingStrategy: I,
    root: T,
    useDismissHookProps: F,
    useClickHookProps: A,
    virtuosoProps: O,
    inputProps: G,
    noDataFallbackText: P = "No data"
  } = q, L = U(q, [
    "id",
    "className",
    "listClassName",
    "minListHeight",
    "maxListHeight",
    "disabled",
    "error",
    "options",
    "selected",
    "size",
    "placeholder",
    "isRequired",
    "noSearchResultText",
    "selectAllOptionText",
    "type",
    "searchDisabled",
    "hideClearButton",
    "isVisible",
    "onOpen",
    "onClose",
    "openedOnInit",
    "clearSearchAfterSelection",
    "onSelect",
    "placement",
    "floatingStrategy",
    "root",
    "useDismissHookProps",
    "useClickHookProps",
    "virtuosoProps",
    "inputProps",
    "noDataFallbackText"
  ]);
  const [Y, te] = v.useState(C), [Ce, fe] = v.useState(!1), K = S !== void 0, j = K ? S : Y, ut = v.useRef(null), { readOnly: wt } = Ot(), aa = wt || (G == null ? void 0 : G.readOnly), Mt = (be, G_) => {
    be ? !j && (E == null || E(G_)) : j && (N == null || N(G_)), !K && te(be);
  }, {
    selectedKeys: Pt,
    items: z,
    searchPhrase: oe,
    handleSelect: me,
    handleOnFilter: De,
    handleItemRemove: le,
    handleClear: da
  } = Yo({
    selected: d,
    options: n,
    type: g,
    selectAllOptionText: f,
    onSelect: b,
    setOpen: Mt,
    clearSearchAfterSelection: $,
    inputRef: ut
  }), {
    context: pe,
    nodeId: He,
    getReferenceProps: Ft,
    setReference: ua,
    getFloatingProps: ma,
    getItemProps: Kr,
    setFloating: Yr,
    floatingStyles: Xr,
    listElementsRef: Zr,
    virtualItemRef: jr,
    activeIndex: Jr,
    maxHeight: Qr,
    setPointer: pa,
    isPositioned: e_
  } = Ko({
    openedOnInit: C,
    disabled: l,
    items: z,
    placement: k,
    minListHeight: _,
    maxListHeight: o,
    floatingStrategy: I,
    useClickHookProps: A,
    useDismissHookProps: F,
    isOpen: j,
    onVisibilityChange: Mt,
    searchPhrase: oe
  });
  return aa ? /* @__PURE__ */ t(
    xa,
    {
      value: d == null ? void 0 : d.map((be) => be.groupHeader ? null : be.name).filter(Boolean).join(", "),
      noDataFallbackText: P
    }
  ) : /* @__PURE__ */ h("div", { id: e, className: u(lc["picker-wrapper"], a), children: [
    /* @__PURE__ */ t(
      Jn,
      {
        getReferenceProps: Ft,
        setReference: ua,
        testId: L["data-testid"],
        isItemSelected: Pt.length > 0,
        isOpen: j,
        onClear: da,
        hideClearButton: x,
        isDisabled: l,
        isError: i,
        isRequired: p,
        isMultiSelect: g === "multi",
        size: s,
        setTriggerFocus: fe,
        onToggle: () => Mt(!j),
        children: /* @__PURE__ */ t(
          _c,
          {
            isOpen: j,
            isSearchDisabled: w,
            isDisabled: l,
            placeholder: c,
            selectedItems: d,
            type: g,
            size: s,
            clearSearchAfterSelection: $,
            inputRef: ut,
            onItemRemove: le,
            onSelect: me,
            onFilter: De,
            onClear: da,
            searchPhrase: oe,
            virtualItemRef: jr,
            isTriggerFocused: Ce,
            inputProps: G
          }
        )
      }
    ),
    /* @__PURE__ */ t(Sa, { id: He, children: j && /* @__PURE__ */ t($a, { root: T, children: /* @__PURE__ */ t(
      Vo,
      {
        pickerType: g,
        options: z,
        listClassName: r,
        context: pe,
        setFloating: Yr,
        floatingStyles: Xr,
        maxHeight: Qr,
        activeIndex: Jr,
        selectedKeys: Pt,
        listElementsRef: Zr,
        searchDisabled: w,
        isPositioned: e_,
        onItemRemove: le,
        setPointer: pa,
        onSelect: me,
        getFloatingProps: ma,
        getItemProps: Kr,
        emptyStateText: m,
        virtuosoProps: O
      }
    ) }) })
  ] });
}, ic = (e) => e !== void 0 && typeof e[0] == "string", nc = (e) => e.map((a) => ({ name: a, key: a })), cc = (e) => e.map((o) => {
  var l = o, { customElement: a, name: r } = l, _ = U(l, ["customElement", "name"]);
  return y(y({
    name: r,
    key: r
  }, a && {
    customElement: {
      listItemBody: a,
      selectedItemBody: /* @__PURE__ */ t(Z, {})
    }
  }), _);
}), sc = (e, a, r, _) => {
  const o = e.length === 1 && e[0].name === _, l = a ? e.slice(0, 1) : e;
  return r && o ? [] : l;
}, Eu = v.forwardRef(
  (g, f) => {
    var w = g, {
      disabled: e,
      minListHeight: a = zo,
      maxListHeight: r = Ho,
      autocompleteOpenOnInit: _ = !1,
      placement: o,
      options: l,
      readOnly: i,
      floatingStrategy: n,
      single: d,
      alwaysShowAllOptions: s,
      hideIfExactMatch: c = !0,
      noDataFallbackText: p = "No data"
    } = w, m = U(w, [
      "disabled",
      "minListHeight",
      "maxListHeight",
      "autocompleteOpenOnInit",
      "placement",
      "options",
      "readOnly",
      "floatingStrategy",
      "single",
      "alwaysShowAllOptions",
      "hideIfExactMatch",
      "noDataFallbackText"
    ]);
    const x = v.useRef(null), { readOnly: S } = Ot(), E = S || i;
    v.useImperativeHandle(f, () => x.current, []);
    const [N, C] = v.useState(""), b = m.value !== void 0 ? m.value : N, [k, I] = v.useState(
      _
    ), T = (pe) => {
      I(pe);
    }, F = (pe) => {
      q(pe);
    }, A = (pe) => {
      var He, Ft;
      (He = m.onChange) == null || He.call(m, pe), C(pe.target.value), s || F(pe.target.value), (Ft = x.current) == null || Ft.focus();
    }, O = (pe) => {
      var Ft, ua, ma;
      const He = pe.key === "Enter";
      (Ft = me.current) != null && Ft.id && He && (G([{ key: (ua = me.current) == null ? void 0 : ua.id }]), pe.preventDefault()), He || T(!0), (ma = m.onKeyDown) == null || ma.call(m, pe);
    }, G = (pe) => {
      if (pe) {
        const He = pe[0].key;
        A({
          target: { value: He }
        }), setTimeout(() => {
          T(!1);
        }, 0);
      }
    }, P = v.useMemo(() => l ? ic(l) ? nc(l) : cc(l) : [], [l]), { items: L, searchPhrase: M, handleOnFilter: q, handleSelect: Y, selectedKeys: te } = Yo({
      selected: [],
      options: P,
      type: "single",
      onSelect: G,
      setOpen: I,
      clearSearchAfterSelection: !0,
      inputRef: x
    }), Ce = sc(
      L,
      d || !1,
      c || !1,
      (b == null ? void 0 : b.toString()) || ""
    ), {
      nodeId: fe,
      context: K,
      setFloating: j,
      getReferenceProps: ut,
      getItemProps: wt,
      getFloatingProps: aa,
      floatingStyles: Mt,
      maxHeight: Pt,
      setPointer: z,
      setReference: oe,
      virtualItemRef: me,
      listElementsRef: De,
      activeIndex: le,
      isPositioned: da
    } = Ko({
      openedOnInit: _,
      disabled: e || i,
      items: L,
      searchPhrase: s ? "" : M,
      isOpen: k,
      onVisibilityChange: T,
      minListHeight: a,
      maxListHeight: r,
      placement: o,
      floatingStrategy: n
    });
    return E ? /* @__PURE__ */ t(
      xa,
      {
        value: b == null ? void 0 : b.toString(),
        noDataFallbackText: p
      }
    ) : /* @__PURE__ */ h("div", B(y({ ref: oe }, ut()), { children: [
      /* @__PURE__ */ t(
        Tn,
        B(y({}, m), {
          ref: x,
          onChange: A,
          onKeyDown: O,
          value: b,
          disabled: e,
          readOnly: i,
          type: "text"
        })
      ),
      /* @__PURE__ */ t(Sa, { id: fe, children: k && /* @__PURE__ */ t($a, { children: /* @__PURE__ */ t(
        Vo,
        {
          context: K,
          options: Ce,
          setFloating: j,
          getFloatingProps: aa,
          floatingStyles: Mt,
          maxHeight: Pt,
          listElementsRef: De,
          activeIndex: le,
          selectedKeys: te,
          setPointer: z,
          hideWhenEmpty: !0,
          getItemProps: wt,
          onSelect: Y,
          isPositioned: da,
          searchDisabled: !1,
          onItemRemove: _r
        }
      ) }) })
    ] }));
  }
), dc = "lc-SegmentedControl-module__btn___pG309", Cr = {
  "segmented-control": "lc-SegmentedControl-module__segmented-control___v3EXg",
  btn: dc,
  "btn--active": "lc-SegmentedControl-module__btn--active___n93GT",
  "btn--compact": "lc-SegmentedControl-module__btn--compact___grlBl",
  "btn--medium": "lc-SegmentedControl-module__btn--medium___YGzgQ",
  "btn--large": "lc-SegmentedControl-module__btn--large___DCJ-p"
}, uc = "segmented-control", Tu = ({
  size: e = "medium",
  buttons: a,
  className: r,
  initialId: _,
  currentId: o,
  fullWidth: l = !1,
  onButtonClick: i = _r
}) => {
  const n = u(Cr[uc], r), [d, s] = v.useState(() => _), c = typeof o == "string";
  v.useEffect(() => {
    c && s(o);
  }, [o]);
  const p = (f, g) => {
    c || s(f), i(f, g);
  }, m = a.map(({ id: f, label: g, loading: w, disabled: x, icon: S }) => {
    const E = f === d, N = E ? Cr["btn--active"] : "";
    return /* @__PURE__ */ t(
      H,
      {
        fullWidth: l,
        loading: E ? !1 : w,
        disabled: x,
        "aria-pressed": E,
        kind: "secondary",
        icon: S,
        className: u(Cr.btn, Cr[`btn--${e}`], N),
        onClick: ($) => {
          p(f, $);
        },
        children: g
      },
      f
    );
  });
  return /* @__PURE__ */ t("div", { role: "group", className: n, children: m });
}, mc = "lc-Card-module__card___LzN-3", pc = "lc-Card-module__card__header___SRONR", gc = "lc-Card-module__card__header__image___93pD4", hc = "lc-Card-module__card__header__heading___jK55U", fc = "lc-Card-module__card__header__heading__title___5090w", bc = "lc-Card-module__card__header__heading__description___iVYoq", vc = "lc-Card-module__card__content___9G1YM", yc = "lc-Card-module__card__actions___gp-xf", kc = "lc-Card-module__card__actions__line___C6TI0", wc = "lc-Card-module__card__actions__buttons___XJlFJ", Ye = {
  card: mc,
  card__header: pc,
  card__header__image: gc,
  card__header__heading: hc,
  card__header__heading__title: fc,
  card__header__heading__description: bc,
  "card__header__no-image": "lc-Card-module__card__header__no-image___2gPx6",
  card__content: vc,
  "card__expanded-content": "lc-Card-module__card__expanded-content___WBjEn",
  card__actions: yc,
  card__actions__line: kc,
  card__actions__buttons: wc,
  "card__actions__buttons-expander": "lc-Card-module__card__actions__buttons-expander___I--MQ"
}, tr = "card", Gr = `${tr}__header`, r_ = `${Gr}__heading`, $r = `${tr}__actions`, Cc = `${Gr}__no-image`, Bu = (s) => {
  var c = s, {
    alt: e,
    buttonsOptions: a = [],
    children: r,
    className: _,
    description: o,
    expandableContent: l,
    src: i,
    title: n
  } = c, d = U(c, [
    "alt",
    "buttonsOptions",
    "children",
    "className",
    "description",
    "expandableContent",
    "src",
    "title"
  ]);
  const [p, m] = v.useState(!1), f = p ? or : ta, g = p ? "Hide" : "Show more", w = (a == null ? void 0 : a.length) > 0, x = !!l, S = w || x, E = n, N = i, C = N ? "" : Ye[Cc];
  return /* @__PURE__ */ h("div", B(y({ className: u(Ye[tr], _) }, d), { children: [
    E && /* @__PURE__ */ h("div", { className: u(Ye[Gr], C), children: [
      N && /* @__PURE__ */ t(
        "img",
        {
          alt: e,
          className: Ye[`${Gr}__image`],
          src: i
        }
      ),
      /* @__PURE__ */ h("div", { className: Ye[r_], children: [
        /* @__PURE__ */ t(he, { size: "xs", className: Ye[`${r_}__title`], children: n }),
        o && /* @__PURE__ */ t(
          D,
          {
            size: "sm",
            className: Ye[`${r_}__description`],
            children: o
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t(D, { as: "div", size: "md", className: Ye[`${tr}__content`], children: r }),
    p && /* @__PURE__ */ t(
      D,
      {
        as: "div",
        size: "md",
        className: Ye[`${tr}__expanded-content`],
        children: l
      }
    ),
    S && /* @__PURE__ */ h("div", { className: Ye[$r], children: [
      /* @__PURE__ */ t("div", { className: Ye[`${$r}__line`] }),
      /* @__PURE__ */ h("div", { className: Ye[`${$r}__buttons`], children: [
        w && a.map(
          ({ kind: $, onClick: b, children: k }, I) => /* @__PURE__ */ t(
            H,
            {
              size: "compact",
              kind: $,
              onClick: b,
              children: k
            },
            I
          )
        ),
        x && /* @__PURE__ */ t(
          H,
          {
            className: Ye[`${$r}__buttons-expander`],
            kind: "link",
            iconPosition: "right",
            icon: /* @__PURE__ */ t(R, { source: f }),
            onClick: () => m(!p),
            children: g
          }
        )
      ] })
    ] })
  ] }));
}, __ = {
  "date-picker-custom-navigation": "lc-DatePickerCustomNavigation-module__date-picker-custom-navigation___B7uEJ"
}, o_ = "date-picker-custom-navigation", $c = ({ currentMonth: e, setMonth: a, startMonth: r, endMonth: _, numberOfMonths: o }) => {
  const l = r && er(e, r), i = _ && er(e, _), n = () => {
    const p = new Date(e);
    p.setMonth(e.getMonth() - 1), a(p);
  }, d = () => {
    const p = new Date(e);
    p.setMonth(e.getMonth() + 1), a(p);
  }, s = () => {
    if (!r) {
      const f = ia(e, 12);
      return a(f);
    }
    const p = Math.abs(q_(e, r)), m = ia(
      e,
      !Number.isNaN(p) && p > 12 ? 12 : p
    );
    return a(m);
  }, c = () => {
    if (!_) {
      const f = z_(e, 12);
      return a(f);
    }
    const p = Math.abs(q_(_, e)), m = z_(
      e,
      !Number.isNaN(p) && p > 12 ? 12 : p
    );
    return o === 2 && er(m, _) ? a(ia(m, 1)) : a(m);
  };
  return /* @__PURE__ */ h("div", { className: __[o_], children: [
    /* @__PURE__ */ h("div", { className: __[`${o_}__nav-wrapper`], children: [
      /* @__PURE__ */ t(
        H,
        {
          "data-testid": "date-picker-prev-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(R, { source: gl }),
          onClick: s,
          disabled: l
        }
      ),
      /* @__PURE__ */ t(
        H,
        {
          "data-testid": "date-picker-prev-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(R, { source: hl }),
          onClick: n,
          disabled: l
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: __[`${o_}__nav-wrapper`], children: [
      /* @__PURE__ */ t(
        H,
        {
          "data-testid": "date-picker-next-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(R, { source: Ur }),
          onClick: d,
          disabled: i
        }
      ),
      /* @__PURE__ */ t(
        H,
        {
          "data-testid": "date-picker-next-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(R, { source: fl }),
          onClick: c,
          disabled: i
        }
      )
    ] })
  ] });
}, Xo = (e, a) => {
  const { from: r, to: _ } = a;
  return !(_ && !$_(e, _) && N_(e, _) || r && !$_(e, r) && !N_(e, r));
}, Zo = (e, a, r) => a ? e && !er(e, a) || r && er(a, r) ? ia(a, 1) : a : ia(r || /* @__PURE__ */ new Date(), 1), Ja = (e, a) => {
  const r = a == null ? void 0 : a.find((_) => _.id === e);
  return r || void 0;
}, oo = (e, a) => !!(!e || e && a), Nc = (e) => {
  const a = {};
  if (!e.initialSelectedItemKey)
    return a;
  const r = Ja(
    e.initialSelectedItemKey,
    e.options
  );
  return r ? (a.selectedItem = e.initialSelectedItemKey, r.isManual && (e.initialFromDate && (a.from = e.initialFromDate), e.initialToDate && (a.to = e.initialToDate, a.temporaryTo = e.initialToDate)), a) : {};
}, Le = {
  "date-picker": "lc-DatePicker-module__date-picker___MOZFY",
  "date-picker__wrapper": "lc-DatePicker-module__date-picker__wrapper___aOFS3",
  "date-picker__weekday": "lc-DatePicker-module__date-picker__weekday___bdNjp",
  "date-picker__day": "lc-DatePicker-module__date-picker__day___L1YZn",
  "date-picker__day-button": "lc-DatePicker-module__date-picker__day-button___vy3Hd",
  "date-picker__today": "lc-DatePicker-module__date-picker__today___w404B",
  "date-picker__selected": "lc-DatePicker-module__date-picker__selected___FEDMB",
  "date-picker__month-caption": "lc-DatePicker-module__date-picker__month-caption___lMrSe",
  "date-picker__range-start": "lc-DatePicker-module__date-picker__range-start___-VnVk",
  "date-picker__range-middle": "lc-DatePicker-module__date-picker__range-middle___Xvj7k",
  "date-picker__range-end": "lc-DatePicker-module__date-picker__range-end___ux1xQ",
  "date-picker__disabled": "lc-DatePicker-module__date-picker__disabled___A8sSm"
}, Xe = "date-picker", Sc = (d) => {
  var s = d, {
    month: e,
    weekStartsOn: a = 1,
    fromMonth: r,
    startMonth: _,
    toMonth: o,
    endMonth: l,
    onMonthChange: i
  } = s, n = U(s, [
    "month",
    "weekStartsOn",
    "fromMonth",
    "startMonth",
    "toMonth",
    "endMonth",
    "onMonthChange"
  ]);
  const [c, p] = v.useState(e || /* @__PURE__ */ new Date());
  v.useEffect(() => {
    e && e !== c && p(e);
  }, [e, c]), v.useEffect(() => {
    o && e !== c && (Xo(c, { from: r, to: o }) || p(o));
  }, [e, c, o, r]);
  const m = v.useCallback(
    (f) => {
      if (i) {
        i(f);
        return;
      }
      p(f);
    },
    [e, i]
  );
  return /* @__PURE__ */ t("div", { className: Le[`${Xe}`], children: /* @__PURE__ */ t(
    Ql,
    y({
      classNames: {
        weekday: u(
          Le[`${Xe}__wrapper`],
          Le[`${Xe}__weekday`]
        ),
        day: u(Le[`${Xe}__wrapper`], Le[`${Xe}__day`]),
        day_button: u(Le[`${Xe}__day-button`]),
        today: u(Le[`${Xe}__today`]),
        selected: u(Le[`${Xe}__selected`]),
        month_caption: u(Le[`${Xe}__month-caption`]),
        range_start: u(Le[`${Xe}__range-start`]),
        range_middle: u(Le[`${Xe}__range-middle`]),
        range_end: u(Le[`${Xe}__range-end`]),
        disabled: u(Le[`${Xe}__disabled`])
      },
      onMonthChange: m,
      month: c,
      components: {
        CaptionLabel: ({ children: f }) => /* @__PURE__ */ t(D, { as: "span", bold: !0, children: f }),
        Nav: () => /* @__PURE__ */ t(
          $c,
          {
            currentMonth: c,
            setMonth: m,
            startMonth: _ || r,
            endMonth: l || o
          }
        )
      },
      startMonth: _ || r,
      endMonth: l || o,
      weekStartsOn: a
    }, n)
  ) });
};
var W = /* @__PURE__ */ ((e) => (e.NEW_SELECTED_ITEM = "NEW_SELECTED_ITEM", e.NEW_TEMPORARY_FROM_VALUE = "NEW_TEMPORARY_FROM_VALUE", e.NEW_TEMPORARY_TO_VALUE = "NEW_TEMPORARY_TO_VALUE", e.CLEAR = "CLEAR", e.SET_FROM = "SET_FROM", e.SET_TO = "SET_TO", e.SELECT_FIRST_DAY = "SELECT_FIRST_DAY", e.SELECT_SECOND_DAY_AS_FROM = "SELECT_SECOND_DAY_AS_FROM", e.SELECT_SECOND_DAY_AS_TO = "SELECT_SECOND_DAY_AS_TO", e.CURRENT_MONTH_CHANGE = "CURRENT_MONTH_CHANGE", e.SET_CUSTOM_TEMP_RANGE = "SET_CUSTOM_TEMP_RANGE", e))(W || {});
const xc = (e) => {
  const a = Zo(
    e.initialFromDate,
    e.initialToDate,
    e.toMonth
  ), _ = y(y({}, {
    selectedItem: null,
    from: void 0,
    to: void 0,
    temporaryTo: void 0,
    currentMonth: a,
    customTempFrom: void 0,
    customTempTo: void 0
  }), Nc(e));
  function o(l, i) {
    switch (i.type) {
      case W.NEW_SELECTED_ITEM:
        return {
          selectedItem: i.payload.selectedItem,
          from: void 0,
          to: void 0,
          temporaryTo: void 0,
          currentMonth: a
        };
      case W.NEW_TEMPORARY_FROM_VALUE:
        return B(y({}, l), {
          temporaryFrom: i.payload.date
        });
      case W.NEW_TEMPORARY_TO_VALUE:
        return B(y({}, l), {
          temporaryTo: i.payload.date
        });
      case W.SELECT_FIRST_DAY:
        return B(y({}, l), {
          from: i.payload.date,
          to: void 0,
          temporaryFrom: void 0,
          temporaryTo: void 0,
          customTempFrom: void 0,
          customTempTo: void 0
        });
      case W.SELECT_SECOND_DAY_AS_FROM:
        return B(y({}, l), {
          from: i.payload.date,
          to: l.from,
          temporaryTo: l.from
        });
      case W.SELECT_SECOND_DAY_AS_TO:
        return B(y({}, l), {
          to: i.payload.date,
          temporaryTo: i.payload.date
        });
      case W.CURRENT_MONTH_CHANGE:
        return B(y({}, l), {
          currentMonth: i.payload.date
        });
      case W.SET_FROM:
        return B(y({}, l), {
          from: i.payload.date
        });
      case W.SET_TO:
        return B(y({}, l), {
          to: i.payload.date
        });
      case W.SET_CUSTOM_TEMP_RANGE:
        return B(y({}, l), {
          customTempFrom: i.payload.customTempFrom,
          customTempTo: i.payload.customTempTo
        });
      default:
        return l;
    }
  }
  return sl(o, _);
}, jo = ({
  options: e,
  initialSelectedItemKey: a,
  initialFromDate: r,
  initialToDate: _,
  customTempFromDate: o,
  customTempToDate: l,
  toMonth: i,
  today: n,
  onChange: d,
  onRangeSelect: s,
  onSelect: c,
  onCustomTempDateRangeChange: p,
  children: m
}) => {
  const f = Xt(
    a || null
  ), [g, w] = xc({
    initialFromDate: r,
    initialToDate: _,
    toMonth: i,
    options: e,
    initialSelectedItemKey: a,
    customTempFromDate: o,
    customTempToDate: l,
    children: m,
    onChange: d,
    onRangeSelect: s
  });
  V(() => {
    w({
      type: W.SET_CUSTOM_TEMP_RANGE,
      payload: {
        customTempFrom: o,
        customTempTo: l
      }
    });
  }, [o, l]), V(() => {
    w({
      type: W.SET_FROM,
      payload: { date: r }
    });
  }, [r]), V(() => {
    w({
      type: W.SET_TO,
      payload: { date: _ }
    });
  }, [_]), V(() => {
    const b = Zo(
      r,
      _,
      i
    );
    w({
      type: W.CURRENT_MONTH_CHANGE,
      payload: { date: b }
    });
  }, [i, r, _]), V(() => {
    const { from: b, selectedItem: k, to: I } = g;
    if (!(b && I))
      return;
    const T = Ja(k, e);
    T && (d == null || d(B(y({}, T), {
      value: {
        from: b,
        to: I
      }
    })));
  }, [g.from, g.to, g.selectedItem, e, d]), V(() => {
    const { from: b, to: k } = g;
    !(b && k) || !s || s == null || s({
      from: b,
      to: k
    });
  }, [g.from, g.to, s]), V(() => {
    const { selectedItem: b } = g;
    if (b === f.current || !e)
      return;
    if (!b) {
      d == null || d(null);
      return;
    }
    if (!Ja(b, e))
      return;
    const I = e.reduce(
      (T, F) => B(y({}, T), { [F.id]: F }),
      {}
    );
    d == null || d(I[b]);
  }, [d, g.selectedItem, e]), V(() => {
    p == null || p({
      from: g.temporaryFrom,
      to: g.temporaryTo
    });
  }, [g.temporaryFrom, g.temporaryTo]);
  const x = kt(() => {
    const { from: b, to: k } = g;
    b && k && c && c({
      from: b,
      to: k
    });
  }, [c]), S = kt(
    (b) => {
      const { from: k, to: I } = g, T = i ? Eo(i, b) >= 0 : !0;
      k && !oo(k, I) && T && (ei(b, k) ? (w({
        type: W.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: b }
      }), w({
        type: W.NEW_TEMPORARY_TO_VALUE,
        payload: { date: k }
      })) : (w({
        type: W.NEW_TEMPORARY_TO_VALUE,
        payload: { date: b }
      }), w({
        type: W.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: k }
      })));
    },
    [i, g.from, g.to]
  ), E = kt(
    (b) => {
      const { from: k, to: I } = g;
      Xo(b, { to: i }) && (oo(k, I) ? (w({
        type: W.SELECT_FIRST_DAY,
        payload: { date: b }
      }), w({
        type: W.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: b }
      }), w({
        type: W.NEW_TEMPORARY_TO_VALUE,
        payload: { date: b }
      })) : k && $_(b, k) || k && N_(b, k) ? w({
        type: W.SELECT_SECOND_DAY_AS_TO,
        payload: { date: b }
      }) : w({
        type: W.SELECT_SECOND_DAY_AS_FROM,
        payload: { date: b }
      }));
    },
    [i, g.from, g.to]
  ), N = kt(
    (b) => {
      if (b === null) {
        w({
          type: W.NEW_SELECTED_ITEM,
          payload: { selectedItem: null }
        });
        return;
      }
      Ja(b, e) && w({
        type: W.NEW_SELECTED_ITEM,
        payload: { selectedItem: b }
      });
    },
    [e]
  ), C = kt((b) => {
    w({
      type: W.CURRENT_MONTH_CHANGE,
      payload: { date: b }
    });
  }, []);
  return m((() => {
    const {
      currentMonth: b,
      from: k,
      selectedItem: I,
      temporaryFrom: T,
      temporaryTo: F,
      to: A,
      customTempFrom: O,
      customTempTo: G
    } = g, P = wa(() => Ja(I, e), [e, I]), L = wa(() => ({ from: T || k, to: F }), [k, T, F]), M = wa(() => {
      if (!(!O || !G))
        return { from: O, to: G };
    }, [O, G]), q = wa(() => i ? { after: i } : void 0, [i]);
    return {
      select: {
        onItemSelect: N,
        selected: I || ""
      },
      inputs: {
        fromDate: k,
        toDate: A
      },
      datepicker: {
        mode: "range",
        month: b,
        numberOfMonths: 2,
        onDayClick: E,
        selected: M || L,
        endMonth: i,
        disabled: q,
        today: n,
        onDayMouseEnter: S,
        onMonthChange: C,
        onSelect: x
      },
      selectedOption: P
    };
  })());
};
jo.defaultProps = {
  options: [
    {
      id: "default",
      label: "Default option",
      isManual: !0,
      value: {
        from: void 0,
        to: void 0
      }
    }
  ]
};
const Iu = (e) => {
  const l = e, { className: a, children: r } = l, _ = U(l, ["className", "children"]), o = u(
    a,
    Le["date-picker--range__calendars-wrapper"]
  );
  return /* @__PURE__ */ t("div", B(y({}, _), { className: o, children: r }));
}, J = {
  "details-card": "lc-DetailsCard-module__details-card___v-Avc",
  "details-card__button--fading": "lc-DetailsCard-module__details-card__button--fading___LlMMo",
  "details-card--with-divider": "lc-DetailsCard-module__details-card--with-divider___AhDnH",
  "details-card__label-wrapper": "lc-DetailsCard-module__details-card__label-wrapper___r70F3",
  "details-card__label-wrapper--hide": "lc-DetailsCard-module__details-card__label-wrapper--hide___Nz6ap",
  "details-card__label-wrapper--fading": "lc-DetailsCard-module__details-card__label-wrapper--fading___gPYF3",
  "details-card__label": "lc-DetailsCard-module__details-card__label___4cvW8",
  "details-card__label--with-margin": "lc-DetailsCard-module__details-card__label--with-margin___3bSuV",
  "details-card__label__left-node": "lc-DetailsCard-module__details-card__label__left-node___Vpq-P",
  "details-card__label__right-node": "lc-DetailsCard-module__details-card__label__right-node___640HC",
  "details-card__label__content": "lc-DetailsCard-module__details-card__label__content___iMTpo",
  "details-card__button": "lc-DetailsCard-module__details-card__button___x6Yex",
  "details-card__button--closed": "lc-DetailsCard-module__details-card__button--closed___4sjdi",
  "details-card__button__icon": "lc-DetailsCard-module__details-card__button__icon___clN8y",
  "details-card__button__icon--open": "lc-DetailsCard-module__details-card__button__icon--open___IU-Rk",
  "details-card__content-wrapper": "lc-DetailsCard-module__details-card__content-wrapper___6U9cE",
  "details-card__content-wrapper--open": "lc-DetailsCard-module__details-card__content-wrapper--open___n-ZsY",
  "details-card__content": "lc-DetailsCard-module__details-card__content___aJux3",
  "details-card__content--spacing": "lc-DetailsCard-module__details-card__content--spacing___F17pU",
  "details-card__content--full-space": "lc-DetailsCard-module__details-card__content--full-space___8CLFw"
}, Q = "details-card", Ec = ["input", "button", "select", "textarea", "a"], Au = ({
  children: e,
  className: a,
  leftNode: r,
  rightNode: _,
  label: o,
  withDivider: l,
  fullSpaceContent: i,
  openOnInit: n = !1,
  hideLabelOnOpen: d,
  onClick: s
}) => {
  const [c, p] = v.useState(n), [m, f] = v.useState(0), g = v.useRef(null), w = u(
    J[Q],
    l && J[`${Q}--with-divider`],
    a
  ), x = d && c, S = typeof o == "string", E = (C) => {
    p(($) => !$), C.currentTarget.blur(), s == null || s(C);
  }, N = (C) => {
    const b = C.target.tagName.toLowerCase();
    Ec.includes(b) || (p((k) => !k), s == null || s(C));
  };
  return v.useEffect(() => {
    const C = !!window.IntersectionObserver;
    if (g.current && C) {
      const $ = new ResizeObserver(() => {
        g.current && m !== g.current.offsetHeight && f(g.current.offsetHeight);
      });
      return $.observe(g.current), () => $.disconnect();
    }
  }, [g]), /* @__PURE__ */ h("div", { className: w, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(
          J[`${Q}__label-wrapper`],
          d && J[`${Q}__label-wrapper--fading`],
          x && J[`${Q}__label-wrapper--hide`],
          c && J[`${Q}__label-wrapper--open`]
        ),
        "aria-expanded": c,
        "aria-hidden": x,
        "data-testid": "details-card-label",
        onClick: N,
        children: /* @__PURE__ */ h(
          "div",
          {
            className: u(
              J[`${Q}__label`],
              d && J[`${Q}__label--with-margin`]
            ),
            children: [
              r && /* @__PURE__ */ t("div", { className: J[`${Q}__label__left-node`], children: r }),
              S ? /* @__PURE__ */ t(
                he,
                {
                  size: "xs",
                  className: J[`${Q}__label__content`],
                  children: o
                }
              ) : /* @__PURE__ */ t("div", { className: J[`${Q}__label__content`], children: o }),
              _ && /* @__PURE__ */ t("div", { className: J[`${Q}__label__right-node`], children: _ })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ t(
      H,
      {
        kind: c && d ? "float" : "text",
        icon: /* @__PURE__ */ t(
          R,
          {
            source: Ur,
            className: u(
              J[`${Q}__button__icon`],
              c && J[`${Q}__button__icon--open`]
            )
          }
        ),
        className: u(
          J[`${Q}__button`],
          !c && J[`${Q}__button--closed`],
          c && J[`${Q}__button--open`],
          d && J[`${Q}__button--fading`]
        ),
        onClick: E,
        "aria-expanded": c
      }
    ),
    /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
      "div",
      {
        className: u(
          J[`${Q}__content-wrapper`],
          c && J[`${Q}__content-wrapper--open`]
        ),
        style: {
          maxHeight: c ? m : 0
        },
        children: /* @__PURE__ */ t(
          "div",
          {
            ref: g,
            className: u(
              J[`${Q}__content`],
              i && J[`${Q}__content--full-space`],
              d && J[`${Q}__content--spacing`]
            ),
            children: e
          }
        )
      }
    ) })
  ] });
}, l_ = {
  "details-card-info": "lc-DetailsCardInfo-module__details-card-info___22mOK",
  "details-card-info__label": "lc-DetailsCardInfo-module__details-card-info__label___LXTXh",
  "details-card-info__content": "lc-DetailsCardInfo-module__details-card-info__content___03cfr"
}, i_ = "details-card-info", Du = ({ children: e, label: a }) => /* @__PURE__ */ h("div", { className: l_[i_], children: [
  /* @__PURE__ */ t("div", { className: l_[`${i_}__label`], children: a }),
  /* @__PURE__ */ t("div", { className: l_[`${i_}__content`], children: e })
] }), Et = {
  "empty-state": "lc-EmptyState-module__empty-state___vtzjl",
  "empty-state--centered": "lc-EmptyState-module__empty-state--centered___NW4Cb",
  "empty-state--inline": "lc-EmptyState-module__empty-state--inline___GJs59",
  "empty-state--full": "lc-EmptyState-module__empty-state--full___SrQt1",
  "empty-state__image": "lc-EmptyState-module__empty-state__image___-Sl-v",
  "empty-state__icon--full": "lc-EmptyState-module__empty-state__icon--full___vYFVG",
  "empty-state__description": "lc-EmptyState-module__empty-state__description___cMfKv",
  "empty-state__content-inline": "lc-EmptyState-module__empty-state__content-inline___gCYVX",
  "empty-state__title": "lc-EmptyState-module__empty-state__title___JSD4P",
  "empty-state__actions": "lc-EmptyState-module__empty-state__actions___gnEFS",
  "empty-state__actions--inline": "lc-EmptyState-module__empty-state__actions--inline___OuON7"
}, Tt = "empty-state", Ou = ({
  type: e = "full",
  image: a,
  icon: r,
  title: _,
  description: o,
  actions: l,
  centered: i = !1
}) => /* @__PURE__ */ h(
  "div",
  {
    className: u(
      Et[Tt],
      Et[`${Tt}--${e}`],
      i && Et[`${Tt}--centered`]
    ),
    children: [
      a && /* @__PURE__ */ t(
        "img",
        {
          className: Et[`${Tt}__image`],
          src: a,
          alt: _
        }
      ),
      e === "inline" ? /* @__PURE__ */ h("div", { className: Et[`${Tt}__content-inline`], children: [
        r && /* @__PURE__ */ t(X_, { "data-testid": "icon", children: r }),
        /* @__PURE__ */ t(D, { noMargin: !0, children: _ })
      ] }) : /* @__PURE__ */ h(Z, { children: [
        r && /* @__PURE__ */ t(
          X_,
          {
            className: Et[`${Tt}__icon--${e}`],
            "data-testid": "icon",
            children: r
          }
        ),
        /* @__PURE__ */ t(he, { className: Et[`${Tt}__title`], children: _ })
      ] }),
      e === "full" && o && /* @__PURE__ */ t(D, { noMargin: !0, className: Et[`${Tt}__description`], children: o }),
      l && /* @__PURE__ */ t(
        "div",
        {
          className: u(
            Et[`${Tt}__actions`],
            Et[`${Tt}__actions--${e}`]
          ),
          children: l
        }
      )
    ]
  }
), lo = {
  "field-error": "lc-FieldError-module__field-error___-rtI3",
  "field-error__icon": "lc-FieldError-module__field-error__icon___4KpOc"
}, io = "field-error", P_ = (_) => {
  var o = _, {
    children: e,
    className: a = ""
  } = o, r = U(o, [
    "children",
    "className"
  ]);
  const l = u(lo[io], a);
  return /* @__PURE__ */ h(D, B(y({ as: "span", size: "sm" }, r), { className: l, children: [
    /* @__PURE__ */ t(
      R,
      {
        source: No,
        className: lo[`${io}__icon`],
        size: "small"
      }
    ),
    e
  ] }));
}, n_ = {
  "field-group": "lc-FieldGroup-module__field-group___--i2x",
  "field-group--inline": "lc-FieldGroup-module__field-group--inline___iSg4S",
  "field-group--stretched": "lc-FieldGroup-module__field-group--stretched___4Evlw"
}, c_ = "field-group", Mu = (n) => {
  var d = n, {
    className: e = "",
    children: a,
    description: r,
    error: _,
    inline: o,
    stretch: l
  } = d, i = U(d, [
    "className",
    "children",
    "description",
    "error",
    "inline",
    "stretch"
  ]);
  const s = u(n_[c_], e, {
    [n_[`${c_}--inline`]]: o,
    [n_[`${c_}--stretched`]]: l
  });
  return /* @__PURE__ */ h("div", B(y({}, i), { className: s, children: [
    a,
    _ && /* @__PURE__ */ t(P_, { children: _ }),
    r && /* @__PURE__ */ t(Vr, { children: r })
  ] }));
}, Tc = "lc-Form-module__form___ddwfw", Bc = "lc-Form-module__form__header___mr4AX", Ic = "lc-Form-module__form__footer___NJUBH", Ac = "lc-Form-module__form__label___2hAXA", Dc = "lc-Form-module__form__helper___r1lJG", Pa = {
  form: Tc,
  form__header: Bc,
  form__footer: Ic,
  form__label: Ac,
  form__helper: Dc
}, Fa = "form", Pu = (i) => {
  var n = i, {
    className: e,
    children: a,
    labelText: r,
    helperText: _,
    formFooter: o
  } = n, l = U(n, [
    "className",
    "children",
    "labelText",
    "helperText",
    "formFooter"
  ]);
  return /* @__PURE__ */ h("form", B(y({ className: u(Pa[Fa], e) }, l), { children: [
    (r || _) && /* @__PURE__ */ h("div", { className: Pa[`${Fa}__header`], children: [
      r && /* @__PURE__ */ t(he, { size: "sm", className: Pa[`${Fa}__label`], children: r }),
      _ && /* @__PURE__ */ t(D, { as: "p", size: "sm", className: Pa[`${Fa}__helper`], children: _ })
    ] }),
    a,
    o && /* @__PURE__ */ t("div", { className: Pa[`${Fa}__footer`], children: o })
  ] }));
}, ie = {
  "form-field": "lc-FormField-module__form-field___kx7Vx",
  "form-field--inline": "lc-FormField-module__form-field--inline___1xuhX",
  "form-field__wrapper--inline": "lc-FormField-module__form-field__wrapper--inline___MPvG-",
  "form-field__label": "lc-FormField-module__form-field__label___xZ4Qz",
  "form-field__label--inline": "lc-FormField-module__form-field__label--inline___x9AUt",
  "form-field__label--no-text": "lc-FormField-module__form-field__label--no-text___h2VqV",
  "form-field__label-wrapper": "lc-FormField-module__form-field__label-wrapper___O1XAl",
  "form-field__label-wrapper--inline": "lc-FormField-module__form-field__label-wrapper--inline___5hqdR",
  "form-field__label-adornment": "lc-FormField-module__form-field__label-adornment___4uieF",
  "form-field__label-adornment--inline": "lc-FormField-module__form-field__label-adornment--inline___Uj4Y6",
  "form-field__label-left-node": "lc-FormField-module__form-field__label-left-node___XWg6l",
  "form-field__label-left-node--read-only": "lc-FormField-module__form-field__label-left-node--read-only___WnnjA",
  "form-field__label-right-node": "lc-FormField-module__form-field__label-right-node___dzUl6",
  "form-field__label-right-node--inline": "lc-FormField-module__form-field__label-right-node--inline___zfQ8H",
  "form-field__row-break": "lc-FormField-module__form-field__row-break___ibOb7",
  "form-field__content": "lc-FormField-module__form-field__content___7Cnwe",
  "form-field__content__description": "lc-FormField-module__form-field__content__description___qdMlU"
}, ne = "form-field", Oc = ({
  inline: e,
  error: a,
  description: r,
  labelText: _,
  labelAdornment: o,
  className: l,
  labelFor: i,
  children: n,
  labelRightNode: d,
  boldLabel: s = !1,
  readOnly: c = !1
}) => {
  const p = v.useRef(null), [m, f] = v.useState("auto"), { isEmpty: g } = Ot(), w = u(
    ie[ne],
    {
      [ie[`${ne}--inline`]]: e
    },
    l
  );
  return v.useEffect(() => {
    const x = p;
    return e && x.current ? f(`${x.current.clientHeight}px`) : f("auto");
  }), /* @__PURE__ */ h("div", { className: w, children: [
    d && e && /* @__PURE__ */ h(v.Fragment, { children: [
      /* @__PURE__ */ t(
        D,
        {
          as: "div",
          size: "sm",
          className: u(
            ie[`${ne}__label-right-node`],
            ie[`${ne}__label-right-node--inline`]
          ),
          children: d
        }
      ),
      /* @__PURE__ */ t("div", { className: ie[`${ne}__row-break`] })
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(
          ie[`${ne}__wrapper`],
          e && ie[`${ne}__wrapper--inline`]
        ),
        children: [
          (_ || d) && /* @__PURE__ */ h(
            "div",
            {
              className: u(
                ie[`${ne}__label`],
                e && ie[`${ne}__label--inline`],
                !_ && ie[`${ne}__label--no-text`]
              ),
              children: [
                _ && /* @__PURE__ */ h(
                  "div",
                  {
                    className: u(
                      ie[`${ne}__label-wrapper`],
                      e && ie[`${ne}__label-wrapper--inline`]
                    ),
                    style: {
                      height: m
                    },
                    children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          className: u(
                            ie[`${ne}__label-left-node`],
                            c && ie[`${ne}__label-left-node--read-only`]
                          ),
                          htmlFor: i,
                          children: /* @__PURE__ */ t(
                            D,
                            {
                              as: "span",
                              size: "sm",
                              bold: !c && s,
                              customColor: g ? "var(--content-basic-secondary)" : void 0,
                              children: _
                            }
                          )
                        }
                      ),
                      o && /* @__PURE__ */ t(
                        D,
                        {
                          as: "div",
                          size: "sm",
                          className: u(
                            ie[`${ne}__label-adornment`],
                            e && ie[`${ne}__label-adornment--inline`]
                          ),
                          children: o
                        }
                      )
                    ]
                  }
                ),
                d && !e && /* @__PURE__ */ t(
                  D,
                  {
                    as: "div",
                    size: "sm",
                    className: u(ie[`${ne}__label-right-node`]),
                    children: d
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h("div", { className: u(ie[`${ne}__content`]), children: [
            /* @__PURE__ */ t("div", { ref: p, children: n }),
            a && /* @__PURE__ */ t(P_, { children: a }),
            !a && r && /* @__PURE__ */ t(
              Vr,
              {
                className: u(ie[`${ne}__content__description`]),
                children: r
              }
            )
          ] })
        ]
      }
    )
  ] });
}, Fu = (r) => {
  var _ = r, {
    readOnly: e
  } = _, a = U(_, [
    "readOnly"
  ]);
  return /* @__PURE__ */ t(xn, { readOnly: e, children: /* @__PURE__ */ t(Oc, y({ readOnly: e }, a)) });
}, Nr = {
  "form-group": "lc-FormGroup-module__form-group___uAHnp",
  "form-group__header": "lc-FormGroup-module__form-group__header___U4FrR",
  "form-group__label": "lc-FormGroup-module__form-group__label___9AcBX",
  "form-group__helper": "lc-FormGroup-module__form-group__helper___2XQcm"
}, Sr = "form-group", Ru = (l) => {
  var i = l, {
    className: e = "",
    children: a,
    labelText: r,
    helperText: _
  } = i, o = U(i, [
    "className",
    "children",
    "labelText",
    "helperText"
  ]);
  const n = u(Nr[Sr], e);
  return /* @__PURE__ */ h(
    "div",
    B(y(B(y({}, o), {
      role: "group"
    }), r && { "aria-label": r }), {
      className: n,
      children: [
        (r || _) && /* @__PURE__ */ h("div", { className: Nr[`${Sr}__header`], children: [
          r && /* @__PURE__ */ t(
            he,
            {
              as: "div",
              size: "sm",
              className: Nr[`${Sr}__label`],
              children: r
            }
          ),
          _ && /* @__PURE__ */ t(D, { as: "div", size: "sm", className: Nr[`${Sr}__helper`], children: _ })
        ] }),
        a
      ]
    })
  );
}, Mc = "lc-AnimatedButton-module__icon___x-2D0", Pc = "lc-AnimatedButton-module__text___JEZ-a", Fc = "lc-AnimatedButton-module__expanded___oXA4t", xr = {
  "animated-button": "lc-AnimatedButton-module__animated-button___d1ume",
  icon: Mc,
  text: Pc,
  expanded: Fc
}, Rc = ({
  icon: e,
  text: a,
  onClick: r,
  className: _,
  isExpanded: o
}) => {
  const [l, i] = de(!1), n = o !== void 0, d = n ? o : l, s = () => {
    i(!0);
  }, c = () => {
    i(!1);
  };
  return V(() => {
    n && !o && i(!1);
  }, [n, o]), /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: u(
        xr["animated-button"],
        { [xr.expanded]: d },
        _
      ),
      onClick: r,
      onMouseEnter: s,
      onMouseLeave: c,
      children: [
        /* @__PURE__ */ t("span", { className: xr.icon, children: e }),
        /* @__PURE__ */ t("span", { className: xr.text, children: a })
      ]
    }
  );
}, no = {
  available: 1,
  unavailable: 2,
  unknown: 3
}, Gc = (e) => [...e].sort((a, r) => no[a.status] - no[r.status]), Ze = {
  "invite-agents": "lc-InviteAgents-module__invite-agents___XHov-",
  "invite-agents--empty": "lc-InviteAgents-module__invite-agents--empty___-uyZv",
  "invite-agents--only-unavailable": "lc-InviteAgents-module__invite-agents--only-unavailable___rwGmo",
  "invite-agents__not-accepting": "lc-InviteAgents-module__invite-agents__not-accepting___GF-hX",
  "invite-agents__tooltip": "lc-InviteAgents-module__invite-agents__tooltip___8CJxu",
  "invite-agents__tooltip-trigger": "lc-InviteAgents-module__invite-agents__tooltip-trigger___I77qz",
  "invite-agents__not-accepting-status-dot": "lc-InviteAgents-module__invite-agents__not-accepting-status-dot___BnVII",
  "invite-agents__avatar-container": "lc-InviteAgents-module__invite-agents__avatar-container___r56c3",
  "invite-agents__avatar": "lc-InviteAgents-module__invite-agents__avatar___Qs6yT",
  "invite-agents__available-agents-number": "lc-InviteAgents-module__invite-agents__available-agents-number___WpNqr",
  "invite-agents__accepting-agents": "lc-InviteAgents-module__invite-agents__accepting-agents___KNMQw",
  "invite-agents__accepting-agents-row": "lc-InviteAgents-module__invite-agents__accepting-agents-row___bTb9i"
}, je = "invite-agents", Uc = 50, Lc = (s) => {
  var c = s, {
    agents: e,
    onSetUpChatbotClick: a,
    onAddTeammateClick: r,
    className: _,
    animatedInviteButton: o = !1,
    tooltipArrowOffset: l = 13,
    onAvailableAgentsClick: i,
    showBotsInTooltip: n = !0
  } = c, d = U(c, [
    "agents",
    "onSetUpChatbotClick",
    "onAddTeammateClick",
    "className",
    "animatedInviteButton",
    "tooltipArrowOffset",
    "onAvailableAgentsClick",
    "showBotsInTooltip"
  ]);
  const [p, m] = de(!1), [f, g] = de(!1), {
    availableAgentsNumber: w,
    visibleAgents: x,
    hasOnlyUnavailableAgents: S,
    onlyAgentsNumber: E,
    onlyBotsNumber: N
  } = wa(() => {
    const I = e.filter(
      (L) => L.status === "available"
    ), T = Gc(I), F = I.length, A = T.length > 4 ? T.slice(0, 3) : T, O = e.length > 0 && F === 0, G = I.filter(
      (L) => !L.isBot
    ).length, P = F - G;
    return {
      availableAgentsNumber: F,
      visibleAgents: A,
      hasOnlyUnavailableAgents: O,
      onlyAgentsNumber: G,
      onlyBotsNumber: P
    };
  }, [e]), C = () => {
    a(), m(!1), g(!1);
  }, $ = () => {
    r(), m(!1), g(!1);
  }, b = () => {
    i(), m(!1), g(!1);
  }, k = [
    {
      key: "chatbot",
      onClick: C,
      element: /* @__PURE__ */ t(rr, { leftNode: /* @__PURE__ */ t(R, { source: kl }), children: "Set up ChatBot" })
    },
    {
      key: "teammate",
      element: /* @__PURE__ */ t(rr, { leftNode: /* @__PURE__ */ t(R, { source: wl }), children: "Invite teammate" }),
      onClick: $
    }
  ];
  return /* @__PURE__ */ h(
    "div",
    B(y({}, d), {
      className: u(
        Qt.Dark,
        Ze[je],
        {
          [Ze[`${je}--empty`]]: e.length === 0,
          [Ze[`${je}--only-unavailable`]]: S
        },
        _
      ),
      children: [
        e.length > 0 && /* @__PURE__ */ t(
          ea,
          {
            isVisible: f && !p,
            offsetMainAxis: l,
            floatingStrategy: "fixed",
            hoverOnDelay: Uc,
            onOpen: () => g(!0),
            onClose: () => g(!1),
            className: u(Qt.Dark, Ze[`${je}__tooltip`]),
            triggerRenderer: S ? /* @__PURE__ */ h(
              "div",
              {
                className: Ze[`${je}__not-accepting`],
                onClick: b,
                children: [
                  /* @__PURE__ */ t(
                    "div",
                    {
                      className: u(
                        Ze[`${je}__not-accepting-status-dot`]
                      )
                    }
                  ),
                  /* @__PURE__ */ t(D, { noMargin: !0, bold: !0, size: "sm", children: "No active agents" })
                ]
              }
            ) : /* @__PURE__ */ h(
              "div",
              {
                className: Ze[`${je}__tooltip-trigger`],
                onClick: b,
                children: [
                  /* @__PURE__ */ t("div", { className: Ze[`${je}__avatar-container`], children: x.map((I, T) => /* @__PURE__ */ t(
                    M_,
                    {
                      text: I.name,
                      className: Ze[`${je}__avatar`],
                      type: I.avatar ? "image" : "text",
                      size: "xsmall",
                      status: I.status,
                      src: I.avatar,
                      style: { zIndex: e.length - T }
                    },
                    I.email
                  )) }),
                  w > 0 && /* @__PURE__ */ t(
                    D,
                    {
                      className: Ze[`${je}__available-agents-number`],
                      children: w
                    }
                  )
                ]
              }
            ),
            children: S ? /* @__PURE__ */ t(
              Wi,
              {
                header: "No one's available to assist customers",
                text: "Offer 24/7 support with ChatBot.",
                primaryButton: {
                  handleClick: C,
                  label: "Set up ChatBot"
                }
              }
            ) : /* @__PURE__ */ h(
              D,
              {
                as: "div",
                noMargin: !0,
                size: "md",
                className: Ze[`${je}__accepting-agents`],
                children: [
                  /* @__PURE__ */ t(D, { bold: !0, noMargin: !0, children: "Accepting chats:" }),
                  /* @__PURE__ */ h(
                    D,
                    {
                      noMargin: !0,
                      className: Ze[`${je}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(R, { source: bl }),
                        Rr(
                          E,
                          "1 agent",
                          `${E} agents`
                        )
                      ]
                    }
                  ),
                  n && /* @__PURE__ */ h(
                    D,
                    {
                      noMargin: !0,
                      className: Ze[`${je}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(R, { source: vl }),
                        Rr(N, "1 bot", `${N} bots`)
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          D_,
          {
            floatingStrategy: "fixed",
            visible: p,
            onOpen: () => m(!0),
            onClose: () => m(!1),
            options: k,
            triggerRenderer: /* @__PURE__ */ t(
              Rc,
              {
                icon: /* @__PURE__ */ t(R, { source: yl }),
                text: "Invite",
                onClick: () => m((I) => !I),
                isExpanded: o ? p || void 0 : !0
              }
            )
          }
        )
      ]
    })
  );
}, Gu = dl(Lc), qc = "lc-Link-module__link___35Vo1", co = {
  link: qc,
  "link--bold": "lc-Link-module__link--bold___9Uq3Z"
}, so = "link", Uu = (_) => {
  var o = _, {
    bold: e = !1,
    className: a = ""
  } = o, r = U(o, [
    "bold",
    "className"
  ]);
  return /* @__PURE__ */ t(
    "a",
    y({
      className: u(
        co[so],
        e && co[`${so}--bold`],
        a
      )
    }, r)
  );
}, zc = "lc-Modal-module__modal__body___K3X3J", Hc = "lc-Modal-module__modal__header___22qVU", Vc = "lc-Modal-module__modal__heading___TQl-G", Wc = "lc-Modal-module__modal__footer___-z-ze", Ae = {
  "modal-base": "lc-Modal-module__modal-base___W3hsn",
  "fade-in": "lc-Modal-module__fade-in___uf1sy",
  "modal-base--full-space": "lc-Modal-module__modal-base--full-space___I5mqs",
  "modal-base__overlay": "lc-Modal-module__modal-base__overlay___BXG-c",
  "modal-base__overlay--visible": "lc-Modal-module__modal-base__overlay--visible___SkPQ3",
  "modal-base__overlay--labelled": "lc-Modal-module__modal-base__overlay--labelled___XJo16",
  "modal-base__close": "lc-Modal-module__modal-base__close___a2xPW",
  "modal-base__close--label-type": "lc-Modal-module__modal-base__close--label-type___IWIlG",
  modal__body: zc,
  modal__header: Hc,
  "modal__header--without-heading": "lc-Modal-module__modal__header--without-heading___-zvH5",
  "modal__label-header": "lc-Modal-module__modal__label-header___LL-pz",
  modal__heading: Vc,
  "modal__label-heading": "lc-Modal-module__modal__label-heading___OZoP1",
  modal__footer: Wc
}, Ra = "modal-base", Kc = (d) => {
  var s = d, {
    children: e,
    className: a = "",
    onClose: r,
    closeOnEscPress: _ = !0,
    closeOnOverlayPress: o = !0,
    fullSpaceContent: l,
    isLabelled: i
  } = s, n = U(s, [
    "children",
    "className",
    "onClose",
    "closeOnEscPress",
    "closeOnOverlayPress",
    "fullSpaceContent",
    "isLabelled"
  ]);
  const c = u(
    Ae[Ra],
    a,
    l && Ae[`${Ra}--full-space`]
  );
  return v.useEffect(() => {
    if (!_)
      return;
    const m = (f) => {
      f.key === ue.esc && r();
    };
    return document.addEventListener("keyup", m, !0), () => document.removeEventListener("keyup", m, !0);
  }, [_]), /* @__PURE__ */ t(
    Yl,
    {
      "data-testid": "lc-modal-overlay",
      onMouseDown: (m) => {
        o && m.target === m.currentTarget && r();
      },
      className: u(
        Ae[`${Ra}__overlay`],
        Ae[`${Ra}__overlay--visible`],
        i && Ae[`${Ra}__overlay--labelled`]
      ),
      children: /* @__PURE__ */ t(
        "div",
        B(y({
          role: "dialog",
          "aria-modal": !0,
          className: c
        }, n), {
          children: e
        })
      )
    }
  );
}, uo = ({
  labelType: e,
  customColor: a,
  onClick: r
}) => /* @__PURE__ */ t(
  H,
  {
    type: "button",
    kind: "plain",
    "aria-label": "Close modal",
    title: "Close modal",
    className: u(
      Ae["modal-base__close"],
      e && Ae["modal-base__close--label-type"]
    ),
    onClick: r,
    icon: /* @__PURE__ */ t(R, { source: dt, size: "medium", customColor: a })
  }
), jt = "modal", Lu = (s) => {
  var c = s, {
    children: e,
    className: a = "",
    heading: r,
    labelHeading: _,
    fullSpaceContent: o,
    footer: l,
    onClose: i,
    contentClassName: n
  } = c, d = U(c, [
    "children",
    "className",
    "heading",
    "labelHeading",
    "fullSpaceContent",
    "footer",
    "onClose",
    "contentClassName"
  ]);
  const p = u(Ae[jt], a), m = typeof e == "string", f = (g) => {
    g.preventDefault(), g.stopPropagation(), i();
  };
  return /* @__PURE__ */ h(
    Kc,
    B(y({
      className: p,
      fullSpaceContent: o,
      onClose: i,
      isLabelled: !!_
    }, d), {
      children: [
        _ && /* @__PURE__ */ h("div", { className: Ae[`${jt}__label-header`], children: [
          /* @__PURE__ */ t(
            he,
            {
              size: "sm",
              as: "div",
              className: Ae[`${jt}__label-heading`],
              children: _
            }
          ),
          /* @__PURE__ */ t(
            uo,
            {
              labelType: !!_,
              customColor: "var(--color-white)",
              onClick: f
            }
          )
        ] }),
        !_ && /* @__PURE__ */ h(
          "div",
          {
            className: u(Ae[`${jt}__header`], {
              [Ae[`${jt}__header--without-heading`]]: !r
            }),
            children: [
              r && /* @__PURE__ */ t(
                he,
                {
                  size: "sm",
                  as: "div",
                  className: Ae[`${jt}__heading`],
                  children: r
                }
              ),
              /* @__PURE__ */ t(uo, { onClick: f })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "modal-body",
            className: u(Ae[`${jt}__body`], n),
            children: m ? /* @__PURE__ */ t(D, { as: "div", children: e }) : e
          }
        ),
        l && /* @__PURE__ */ t("div", { className: Ae[`${jt}__footer`], children: l })
      ]
    })
  );
}, qu = ({
  children: e,
  className: a = "",
  parentElementName: r = "body",
  zIndex: _
}) => {
  const o = Xt(document.createElement("div"));
  return V(() => {
    const l = o.current, i = document.querySelector(r);
    return i && i.appendChild(l), () => {
      i && i.removeChild(l);
    };
  }, [r]), V(() => {
    const l = o.current;
    a && (l.className = a), _ && (l.style.zIndex = `${_}`);
  }, [a, _]), jl(/* @__PURE__ */ t(Z, { children: e }), o.current);
}, Ga = {
  "modal-header": "lc-ModalHeader-module__modal-header___YwkiN",
  "modal-header__heading-left-node": "lc-ModalHeader-module__modal-header__heading-left-node___SZBRX",
  "modal-header__heading-body": "lc-ModalHeader-module__modal-header__heading-body___aBgMz",
  "modal-header__heading-description": "lc-ModalHeader-module__modal-header__heading-description___dpbWK"
}, Ua = "modal-header", zu = ({ title: e, iconProps: a, avatarProps: r, children: _, className: o = "" }) => {
  const l = u(Ga[Ua], o);
  return /* @__PURE__ */ h("div", { className: l, children: [
    a && /* @__PURE__ */ t(
      R,
      y({
        className: Ga[`${Ua}__heading-left-node`]
      }, a)
    ),
    r && /* @__PURE__ */ t(
      M_,
      y({
        className: Ga[`${Ua}__heading-left-node`]
      }, r)
    ),
    /* @__PURE__ */ h("div", { className: Ga[`${Ua}__heading-body`], children: [
      /* @__PURE__ */ t(he, { as: "div", size: "sm", children: e }),
      _ && /* @__PURE__ */ t(
        D,
        {
          as: "div",
          className: Ga[`${Ua}__heading-description`],
          children: _
        }
      )
    ] })
  ] });
}, La = {
  "action-modal-content": "lc-ActionModalContent-module__action-modal-content___LGNxr",
  "action-modal-content__icon": "lc-ActionModalContent-module__action-modal-content__icon___JYTP2",
  "action-modal-content__heading": "lc-ActionModalContent-module__action-modal-content__heading___gGgOD",
  "action-modal-content__content": "lc-ActionModalContent-module__action-modal-content__content___K4e5r",
  "action-modal-content__actions": "lc-ActionModalContent-module__action-modal-content__actions___bgnDV"
}, qa = "action-modal-content", Hu = ({
  children: e,
  className: a,
  icon: r,
  heading: _,
  actions: o,
  headerClassName: l,
  contentClassName: i
}) => {
  const n = u(La[qa], a);
  return /* @__PURE__ */ h("div", { className: n, children: [
    r && /* @__PURE__ */ t("div", { className: La[`${qa}__icon`], children: r }),
    _ && /* @__PURE__ */ t(
      he,
      {
        className: u(La[`${qa}__heading`], l),
        children: _
      }
    ),
    /* @__PURE__ */ t(
      D,
      {
        as: "div",
        className: u(La[`${qa}__content`], i),
        children: e
      }
    ),
    o && /* @__PURE__ */ t("div", { className: La[`${qa}__actions`], children: o })
  ] });
}, ba = {
  "numeric-input": "lc-NumericInput-module__numeric-input___qYvYK",
  "numeric-input__increment": "lc-NumericInput-module__numeric-input__increment___7AdPN",
  "numeric-input__decrement": "lc-NumericInput-module__numeric-input__decrement___18Raa",
  "numeric-input--disabled": "lc-NumericInput-module__numeric-input--disabled___s2O8w",
  "numeric-input--no-controls": "lc-NumericInput-module__numeric-input--no-controls___nO8zN",
  "numeric-input--error": "lc-NumericInput-module__numeric-input--error___y9v6f"
}, va = "numeric-input", Vu = (p) => {
  var m = p, {
    className: e,
    error: a,
    value: r,
    max: _,
    min: o,
    disabled: l,
    noControls: i,
    style: n,
    onChange: d,
    noDataFallbackText: s = "No data"
  } = m, c = U(m, [
    "className",
    "error",
    "value",
    "max",
    "min",
    "disabled",
    "noControls",
    "style",
    "onChange",
    "noDataFallbackText"
  ]);
  const f = v.useRef(null), { readOnly: g } = Ot(), w = g || c.readOnly, x = u(
    ba[va],
    {
      [ba[`${va}--error`]]: a,
      [ba[`${va}--no-controls`]]: i,
      [ba[`${va}--disabled`]]: l
    },
    e
  ), S = (T) => d(String(T)), E = (T) => _ !== void 0 && T > _ ? _ : o !== void 0 && T < o ? o : T, N = (T) => {
    const F = parseInt(r, 10) + T;
    return S(E(F));
  }, C = (T) => {
    T.key === ue.arrowDown && (T.preventDefault(), N(-1)), T.key === ue.arrowUp && (T.preventDefault(), N(1));
  }, $ = (T, F) => F !== void 0 && parseInt(T, 10) === F, b = (T) => {
    T.preventDefault(), T.stopPropagation();
    const F = T.currentTarget.value.replace(
      /((?!([-]|([-]?\d+))).)/,
      ""
    );
    if (F === "" || F === "-")
      return S(F);
    const A = parseInt(F, 10);
    return S(E(A));
  }, k = () => {
    var T;
    return (T = f.current) == null || T.focus(), N(1);
  }, I = () => {
    var T;
    return (T = f.current) == null || T.focus(), N(-1);
  };
  return w ? /* @__PURE__ */ t(
    xa,
    {
      value: r == null ? void 0 : r.toString(),
      noDataFallbackText: s
    }
  ) : /* @__PURE__ */ h("div", { className: x, style: n, children: [
    /* @__PURE__ */ t(
      "input",
      B(y({
        type: "text",
        ref: f
      }, c), {
        value: r,
        disabled: l,
        onChange: b,
        onKeyDown: C,
        min: o,
        max: _
      })
    ),
    !i && /* @__PURE__ */ h(Z, { children: [
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: l || $(r, _),
          onClick: k,
          "aria-label": "Increment value",
          className: ba[`${va}__increment`],
          type: "button",
          children: /* @__PURE__ */ t(
            R,
            {
              source: or,
              disabled: l || $(r, _),
              kind: "primary"
            }
          )
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: l || $(r, o),
          "aria-label": "Decrement value",
          className: ba[`${va}__decrement`],
          onClick: I,
          type: "button",
          children: /* @__PURE__ */ t(
            R,
            {
              source: ta,
              kind: "primary",
              disabled: l || $(r, o)
            }
          )
        }
      )
    ] })
  ] });
}, Ee = {
  "checklist-item": "lc-CheckListItem-module__checklist-item___iuIlB",
  "checklist-item--active": "lc-CheckListItem-module__checklist-item--active___aoLek",
  "checklist-item__check-mark": "lc-CheckListItem-module__checklist-item__check-mark___stkGB",
  "checklist-item__check-mark--checked": "lc-CheckListItem-module__checklist-item__check-mark--checked___qcaKG",
  "checklist-item__content": "lc-CheckListItem-module__checklist-item__content___dUQrj",
  "checklist-item__content--open": "lc-CheckListItem-module__checklist-item__content--open___Gb8Bj",
  "checklist-item__content__label": "lc-CheckListItem-module__checklist-item__content__label___IECjY",
  "checklist-item__content__label--open": "lc-CheckListItem-module__checklist-item__content__label--open___bXXcm",
  "checklist-item__content__label--checked": "lc-CheckListItem-module__checklist-item__content__label--checked___v-CRg",
  "checklist-item__content__hint": "lc-CheckListItem-module__checklist-item__content__hint___zyxAI",
  "checklist-item__content__inner": "lc-CheckListItem-module__checklist-item__content__inner___T9e7f",
  "checklist-item__content__inner--open": "lc-CheckListItem-module__checklist-item__content__inner--open___hVtIm",
  "checklist-item__content__inner__description": "lc-CheckListItem-module__checklist-item__content__inner__description___oQx09",
  "checklist-item__content__inner__cta": "lc-CheckListItem-module__checklist-item__content__inner__cta___pPrxs",
  "checklist-item__chevron": "lc-CheckListItem-module__checklist-item__chevron___S9Cp1"
}, Te = "checklist-item", Yc = 7, Xc = ({
  id: e,
  isActive: a,
  isChecked: r,
  title: _,
  titleHint: o,
  description: l,
  customContent: i,
  onClick: n,
  cta: d
}) => {
  const s = v.useRef(null), c = v.useRef(null), [p, m] = v.useState(0), f = v.useRef(p);
  return v.useEffect(() => {
    a && s.current && s.current.focus();
  }, [a]), v.useEffect(() => {
    const g = !!window.ResizeObserver;
    if (c.current && g) {
      const w = new ResizeObserver((x) => {
        const S = x[0];
        if (!S) return;
        const E = S.contentRect.height + Yc;
        f.current !== E && (m(E), f.current = E);
      });
      return w.observe(c.current), () => w.disconnect();
    }
  }, [c]), /* @__PURE__ */ h(
    "div",
    {
      className: u(Ee[Te], {
        [Ee[`${Te}--active`]]: a
      }),
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            className: u(Ee[`${Te}__check-mark`], {
              [Ee[`${Te}__check-mark--checked`]]: r
            }),
            children: r && /* @__PURE__ */ t(R, { size: "small", source: Na })
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            ref: s,
            "data-testid": `checklist-item-${e}`,
            "aria-expanded": a,
            tabIndex: 0,
            onFocus: a ? void 0 : () => n(e),
            onClick: a ? void 0 : () => n(e),
            className: u(Ee[`${Te}__content`], {
              [Ee[`${Te}__content--open`]]: a
            }),
            children: [
              /* @__PURE__ */ h("div", { children: [
                /* @__PURE__ */ h(
                  he,
                  {
                    size: "xs",
                    className: u(Ee[`${Te}__content__label`], {
                      [Ee[`${Te}__content__label--open`]]: a,
                      [Ee[`${Te}__content__label--checked`]]: r
                    }),
                    children: [
                      _,
                      " ",
                      o && /* @__PURE__ */ h(
                        D,
                        {
                          noMargin: !0,
                          size: "lg",
                          className: Ee[`${Te}__content__hint`],
                          children: [
                            " ",
                            o
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(Ee[`${Te}__content__inner`], {
                      [Ee[`${Te}__content__inner--open`]]: a
                    }),
                    style: { maxHeight: a ? p : 0 },
                    children: /* @__PURE__ */ h("div", { ref: c, children: [
                      l && /* @__PURE__ */ t(
                        D,
                        {
                          size: "lg",
                          className: Ee[`${Te}__content__inner__description`],
                          children: l
                        }
                      ),
                      i && /* @__PURE__ */ t(
                        "div",
                        {
                          className: Ee[`${Te}__content__inner__description`],
                          children: i
                        }
                      ),
                      /* @__PURE__ */ t("div", { className: Ee[`${Te}__content__inner__cta`], children: d })
                    ] })
                  }
                )
              ] }),
              !a && /* @__PURE__ */ t("div", { className: Ee[`${Te}__chevron`], children: /* @__PURE__ */ t(R, { source: Ur }) })
            ]
          }
        )
      ]
    }
  );
}, ce = {
  "onboarding-checklist": "lc-OnboardingChecklist-module__onboarding-checklist___98RSw",
  "onboarding-checklist--complete": "lc-OnboardingChecklist-module__onboarding-checklist--complete___Cmld9",
  "onboarding-checklist__complete": "lc-OnboardingChecklist-module__onboarding-checklist__complete___ihqN7",
  "onboarding-checklist__complete__icon": "lc-OnboardingChecklist-module__onboarding-checklist__complete__icon___LDJ-I",
  "onboarding-checklist__complete__label": "lc-OnboardingChecklist-module__onboarding-checklist__complete__label___-wqtx",
  "onboarding-checklist__complete__title": "lc-OnboardingChecklist-module__onboarding-checklist__complete__title___MvGM7",
  "onboarding-checklist__column": "lc-OnboardingChecklist-module__onboarding-checklist__column___juqpr",
  "onboarding-checklist__column--right": "lc-OnboardingChecklist-module__onboarding-checklist__column--right___9lOFL",
  "onboarding-checklist__column--right--completed": "lc-OnboardingChecklist-module__onboarding-checklist__column--right--completed___nHt44",
  "onboarding-checklist__header": "lc-OnboardingChecklist-module__onboarding-checklist__header___RB1O7",
  "onboarding-checklist__header__label": "lc-OnboardingChecklist-module__onboarding-checklist__header__label___O2yRJ",
  "onboarding-checklist__header__title": "lc-OnboardingChecklist-module__onboarding-checklist__header__title___H36qW",
  "onboarding-checklist__checklist": "lc-OnboardingChecklist-module__onboarding-checklist__checklist___0vKse",
  "onboarding-checklist__placeholder": "lc-OnboardingChecklist-module__onboarding-checklist__placeholder___JYc-z",
  "onboarding-checklist__button": "lc-OnboardingChecklist-module__onboarding-checklist__button___ZmZ2j",
  "onboarding-checklist__button__icon": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon___ta8M6",
  "onboarding-checklist__button__icon--open": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon--open___Jnrn8"
}, se = "onboarding-checklist", Wu = ({
  activeItemId: e,
  completedItemsIds: a,
  title: r,
  greetingText: _,
  items: o,
  onActiveChange: l,
  placeholderClassName: i,
  isCompleted: n = !1,
  completionMessageData: d,
  className: s
}) => {
  var N;
  const [c, p] = v.useState(n), [m, f] = v.useState(!n), [g, w] = v.useState(void 0), x = v.useRef(null), S = d.height || 96, E = () => {
    f((C) => !C);
  };
  return v.useEffect(() => {
    const C = d.delay || 1500, $ = x.current;
    if (n && $) {
      const b = $.offsetHeight;
      w(b);
      const k = setTimeout(() => {
        p(!0), f(!1);
      }, C);
      return () => {
        clearTimeout(k);
      };
    }
  }, [n]), /* @__PURE__ */ h(
    "div",
    {
      ref: x,
      className: u(
        ce[se],
        {
          [ce[`${se}--complete`]]: c && !m
        },
        s
      ),
      style: {
        height: !c || m ? g : S
      },
      children: [
        m && /* @__PURE__ */ h(Z, { children: [
          /* @__PURE__ */ h("div", { className: ce[`${se}__column`], children: [
            /* @__PURE__ */ h("div", { className: ce[`${se}__header`], children: [
              _ && /* @__PURE__ */ t(
                D,
                {
                  size: "lg",
                  semiBold: !0,
                  className: ce[`${se}__header__label`],
                  children: _
                }
              ),
              /* @__PURE__ */ t(
                he,
                {
                  size: "lg",
                  className: ce[`${se}__header__title`],
                  children: r
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { className: ce[`${se}__checklist`], children: o.map((C, $) => /* @__PURE__ */ t(
              Xc,
              {
                id: C.id,
                description: C.description,
                customContent: C.customContent,
                title: C.title,
                titleHint: C.titleHint,
                isActive: C.id === e,
                isChecked: a.includes(C.id),
                onClick: l,
                cta: C.cta
              },
              $
            )) })
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: u(
                ce[`${se}__column`],
                ce[`${se}__column--right`],
                {
                  [ce[`${se}__column--right--completed`]]: n
                },
                i
              ),
              children: [
                !n && /* @__PURE__ */ t("div", { className: ce[`${se}__placeholder`], children: (N = o.find((C) => C.id === e)) == null ? void 0 : N.placeholder }),
                n && /* @__PURE__ */ t("div", { className: ce[`${se}__placeholder`], children: d.placeholder })
              ]
            }
          )
        ] }),
        !m && /* @__PURE__ */ t(Z, { children: /* @__PURE__ */ h("div", { className: ce[`${se}__complete`], children: [
          /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
            R,
            {
              size: "large",
              className: ce[`${se}__complete__icon`],
              source: T_
            }
          ) }),
          /* @__PURE__ */ h("div", { children: [
            (d == null ? void 0 : d.greetingText) && /* @__PURE__ */ t(
              D,
              {
                size: "lg",
                className: ce[`${se}__complete__label`],
                children: d.greetingText
              }
            ),
            /* @__PURE__ */ t(
              he,
              {
                size: "sm",
                className: ce[`${se}__complete__title`],
                children: d.title
              }
            )
          ] })
        ] }) }),
        c && /* @__PURE__ */ t(
          H,
          {
            kind: m ? "float" : "text",
            icon: /* @__PURE__ */ t(
              R,
              {
                source: ta,
                className: u(
                  ce[`${se}__button__icon`],
                  m && ce[`${se}__button__icon--open`]
                )
              }
            ),
            className: ce[`${se}__button`],
            onClick: E,
            "aria-expanded": m
          }
        )
      ]
    }
  );
}, Zc = "lc-OverflowTooltipText-module__tooltipContent___M9T9h", jc = "lc-OverflowTooltipText-module__text___JcdMZ", mo = {
  tooltipContent: Zc,
  text: jc
}, Ku = ({ text: e }) => {
  const a = Xt(null), r = ui(a), { isHovered: _, handleMouseOut: o, handleMouseOver: l } = di(r), i = /* @__PURE__ */ t(
    "div",
    {
      onMouseEnter: l,
      onMouseLeave: o,
      ref: a,
      className: mo.text,
      children: e
    }
  );
  return /* @__PURE__ */ t(
    ea,
    {
      kind: "invert",
      isVisible: r && _,
      triggerRenderer: i,
      children: /* @__PURE__ */ t("div", { className: mo.tooltipContent, children: e })
    }
  );
}, Jc = "lc-Popover-module__popover___rvS3X", Qc = {
  popover: Jc
}, es = ({
  triggerRenderer: e,
  onClose: a,
  onOpen: r,
  children: _,
  className: o,
  triggerClassName: l,
  placement: i,
  flipOptions: n,
  offsetSize: d = 4,
  isVisible: s,
  openedOnInit: c,
  closeOnEsc: p = !0,
  useDismissHookProps: m,
  useClickHookProps: f,
  floatingStrategy: g,
  transitionOptions: w
}) => {
  const [x, S] = v.useState(c), E = Lr(), N = lr(), C = s !== void 0, $ = C ? s : x, b = typeof _ == "string", k = typeof e == "function", I = (K, j) => {
    K ? r == null || r(j) : a == null || a(j), !C && S(K);
  }, { refs: T, context: F, floatingStyles: A } = ir({
    nodeId: N,
    open: $,
    onOpenChange: I,
    middleware: [nr(d), qr(n), B_()],
    placement: i,
    strategy: g,
    whileElementsMounted: cr
  }), O = sr(F, f), G = dr(F, y({
    escapeKey: p
  }, m)), P = ur(F), { getReferenceProps: L, getFloatingProps: M } = mr([
    O,
    G,
    P
  ]), q = {
    initial: ({ side: K }) => y({
      opacity: 0
    }, K === "bottom" && {
      marginTop: -10
    } || K === "top" && {
      marginTop: 10
    } || K === "left" && {
      marginLeft: 10
    } || K === "right" && {
      marginLeft: -10
    })
  }, { isMounted: Y, styles: te } = zr(
    F,
    w || q
  ), Ce = u(Qc.popover, o), fe = /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ t(
      "div",
      B(y({
        "data-testid": "popover-trigger-button",
        ref: T.setReference
      }, L()), {
        className: l,
        children: k ? e() : e
      })
    ),
    /* @__PURE__ */ t(Sa, { id: N, children: Y && /* @__PURE__ */ t(C_, { context: F, modal: !1, children: /* @__PURE__ */ t(
      "div",
      B(y({
        className: Ce,
        ref: T.setFloating,
        style: y(y({}, A), te)
      }, M()), {
        children: b ? /* @__PURE__ */ t(D, { as: "div", children: _ }) : _
      })
    ) }) })
  ] });
  return E === null ? /* @__PURE__ */ t(Hr, { children: fe }) : fe;
}, rt = {
  "outer-border": "lc-ProductTile-module__outer-border___tsyqh",
  "product-tile-wrapper": "lc-ProductTile-module__product-tile-wrapper___iKDxM",
  "product-tile-wrapper__animated": "lc-ProductTile-module__product-tile-wrapper__animated___xwIAa",
  "product-tile": "lc-ProductTile-module__product-tile___SAnnV",
  "product-tile__second-layer": "lc-ProductTile-module__product-tile__second-layer___YFtzE",
  "product-tile__third-layer": "lc-ProductTile-module__product-tile__third-layer___W0nsL",
  "product-tile__main-product": "lc-ProductTile-module__product-tile__main-product___Imdix",
  "product-tile__badge": "lc-ProductTile-module__product-tile__badge___EwFjs",
  "product-tile__badge--bordered": "lc-ProductTile-module__product-tile__badge--bordered___H08Ep",
  "product-tile__icon": "lc-ProductTile-module__product-tile__icon___IQqzd",
  "product-tile__icon--large": "lc-ProductTile-module__product-tile__icon--large___Ta9v0",
  "product-tile__icon--expired": "lc-ProductTile-module__product-tile__icon--expired___5PbNr"
}, zt = "product-tile", Jo = ({
  icon: e,
  iconColor: a,
  expired: r,
  backgroundColors: _,
  borderColor: o,
  notificationCount: l,
  withBorder: i = !1,
  isMainProduct: n = !1
}) => /* @__PURE__ */ t("div", { className: u({ [rt["outer-border"]]: i }), children: /* @__PURE__ */ h(
  "div",
  {
    tabIndex: n ? 0 : -1,
    className: u(rt["product-tile-wrapper"], {
      [rt["product-tile-wrapper__animated"]]: n
    }),
    children: [
      n && /* @__PURE__ */ h(Z, { children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: rt[`${zt}__third-layer`],
            style: { background: _.third }
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: rt[`${zt}__second-layer`],
            style: { background: _.second }
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          className: u(rt[zt], {
            [rt[`${zt}__main-product`]]: n
          }),
          style: {
            background: r ? "var(--surface-moderate-default)" : _.main,
            border: o ? `1px solid ${o}` : ""
          },
          children: [
            l && !r ? /* @__PURE__ */ t(
              Pr,
              {
                size: "compact",
                count: l,
                className: u(rt[`${zt}__badge`], {
                  [rt[`${zt}__badge--bordered`]]: n
                })
              }
            ) : null,
            /* @__PURE__ */ t(
              R,
              {
                source: e,
                className: u(rt[`${zt}__icon`], {
                  [rt[`${zt}__icon--large`]]: n,
                  [rt[`${zt}__icon--expired`]]: r
                }),
                customColor: a
              }
            )
          ]
        }
      )
    ]
  }
) }), gt = {
  "product-row": "lc-ProductRow-module__product-row___eDpb-",
  "product-row--expired": "lc-ProductRow-module__product-row--expired___-ttqU",
  "product-row__divider": "lc-ProductRow-module__product-row__divider___Fe--b",
  "product-row__heading": "lc-ProductRow-module__product-row__heading___xjZuH",
  "product-row__shortcut": "lc-ProductRow-module__product-row__shortcut___g3-0w",
  "product-row__name": "lc-ProductRow-module__product-row__name___qAIq-",
  "product-row__tooltip-icon": "lc-ProductRow-module__product-row__tooltip-icon___XO-IY",
  "product-row__trial-tooltip": "lc-ProductRow-module__product-row__trial-tooltip___naThN",
  "product-row__tooltip-dark-shadow": "lc-ProductRow-module__product-row__tooltip-dark-shadow___U8Tqp"
}, ht = "product-row", ts = ({
  product: {
    id: e,
    icon: a,
    iconColor: r,
    backgroundColors: _,
    borderColor: o,
    notificationCount: l,
    name: i,
    url: n,
    withDivider: d,
    shortcutKey: s,
    expired: c,
    trialDaysLeft: p,
    nameAdornment: m
  },
  onClick: f,
  isActive: g = !1,
  isDarkMode: w
}) => /* @__PURE__ */ h(Z, { children: [
  d && /* @__PURE__ */ t("div", { className: gt[`${ht}__divider`] }),
  /* @__PURE__ */ h(
    "a",
    {
      href: n,
      target: "_blank",
      "aria-label": `Go to ${i} product`,
      onClick: (x) => f(x, e),
      className: u(gt[ht], {
        [gt[`${ht}--expired`]]: c
      }),
      children: [
        /* @__PURE__ */ h("div", { className: gt[`${ht}__heading`], children: [
          /* @__PURE__ */ t(
            Jo,
            {
              icon: a,
              iconColor: r,
              expired: c,
              backgroundColors: _,
              borderColor: o,
              notificationCount: l,
              withBorder: g
            }
          ),
          /* @__PURE__ */ h(D, { as: "div", bold: !0, className: gt[`${ht}__name`], children: [
            i,
            c && /* @__PURE__ */ t(
              ea,
              {
                className: u({
                  [gt[`${ht}__tooltip-dark-shadow`]]: w
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  R,
                  {
                    source: Mr,
                    className: gt[`${ht}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: "Your licence is expired."
              }
            ),
            typeof p != "undefined" && /* @__PURE__ */ h(
              ea,
              {
                className: u(gt[`${ht}__trial-tooltip`], {
                  [gt[`${ht}__tooltip-dark-shadow`]]: w
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  R,
                  {
                    source: Mr,
                    className: gt[`${ht}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: [
                  p,
                  " ",
                  Rr(p, "day", "days"),
                  " left in your trial. Time to upgrade."
                ]
              }
            ),
            m
          ] })
        ] }),
        s && /* @__PURE__ */ h(D, { size: "sm", className: gt[`${ht}__shortcut`], children: [
          "⌘",
          s
        ] })
      ]
    }
  )
] }), za = {
  "product-switcher": "lc-ProductSwitcher-module__product-switcher___Dqwcp",
  "product-switcher__content": "lc-ProductSwitcher-module__product-switcher__content___-P5yw",
  "product-switcher__footer": "lc-ProductSwitcher-module__product-switcher__footer___YRPN9",
  "product-switcher__footer-link": "lc-ProductSwitcher-module__product-switcher__footer-link___X0VOn",
  "product-switcher__tooltip": "lc-ProductSwitcher-module__product-switcher__tooltip___kcVyp"
}, Ha = "product-switcher", Yu = ({
  productOptions: e,
  mainProductId: a,
  openedOnInit: r = !1,
  isVisible: _,
  isDarkMode: o = !0,
  onOpen: l,
  onClose: i,
  onSelect: n,
  textURL: d = "https://www.text.com"
}) => {
  const [s, c] = v.useState(r), [p, m] = de(
    !1
  ), f = Lr(), g = lr(), w = _ !== void 0, x = w ? _ : s, S = (M, q) => {
    M ? l == null || l(q) : i == null || i(q), !w && c(M);
  }, { refs: E, context: N, floatingStyles: C } = ir({
    nodeId: g,
    strategy: "fixed",
    placement: "right-start",
    open: x,
    onOpenChange: (M, q) => {
      m(!1), S(M, q);
    },
    middleware: [nr({ mainAxis: 5 })],
    whileElementsMounted: cr
  }), $ = sr(N), b = ur(N), k = dr(N), { isMounted: I, styles: T } = zr(N, {
    duration: 200,
    common: {
      transformOrigin: "left top"
    },
    initial: {
      opacity: 0,
      transform: "scale(0.84) translateX(-22px)"
    }
  }), { getReferenceProps: F, getFloatingProps: A } = mr([
    $,
    k,
    b
  ]), O = e.find(
    (M) => M.id === a
  );
  if (!O)
    return null;
  const G = (M, q) => {
    q === a && M.preventDefault(), c(!1), n == null || n(q);
  }, P = e.reduce(
    (M, q) => M + (q.notificationCount || 0),
    0
  ), L = /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ t("div", B(y({ ref: E.setReference }, F()), { children: /* @__PURE__ */ t(
      ea,
      {
        isVisible: p,
        onOpen: () => m(!0),
        onClose: () => m(!1),
        offsetCrossAxis: 2,
        arrowOffsetY: 2,
        offsetMainAxis: 10,
        hoverOnDelay: 400,
        className: u(za[`${Ha}__tooltip`]),
        placement: "right",
        floatingStrategy: "fixed",
        kind: "invert",
        triggerRenderer: /* @__PURE__ */ t(
          Jo,
          {
            isMainProduct: !0,
            icon: O.icon,
            iconColor: O.iconColor,
            backgroundColors: O.backgroundColors,
            notificationCount: P
          }
        ),
        closeOnTriggerBlur: !0,
        children: "Switch product"
      }
    ) })),
    /* @__PURE__ */ t(Sa, { id: g, children: /* @__PURE__ */ t(
      "div",
      B(y({
        ref: E.setFloating,
        style: C
      }, A()), {
        children: I && /* @__PURE__ */ h(
          "div",
          {
            className: u(
              o ? "lc-dark-theme" : "lc-light-theme",
              za[Ha]
            ),
            style: T,
            children: [
              /* @__PURE__ */ t("div", { className: za[`${Ha}__content`], children: e.map((M) => /* @__PURE__ */ t(
                ts,
                {
                  isDarkMode: o,
                  isActive: M.id === a,
                  product: M,
                  onClick: G
                },
                M.id
              )) }),
              /* @__PURE__ */ t("div", { className: za[`${Ha}__footer`], children: /* @__PURE__ */ h(
                "a",
                {
                  href: d,
                  target: "_blank",
                  className: za[`${Ha}__footer-link`],
                  onClick: () => S(!1),
                  children: [
                    /* @__PURE__ */ t(D, { noMargin: !0, children: "powered by" }),
                    /* @__PURE__ */ t(
                      R,
                      {
                        size: "xlarge",
                        source: Cl,
                        customColor: "var(--content-basic-primary)"
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      })
    ) })
  ] });
  return f === null ? /* @__PURE__ */ t(Hr, { children: L }) : L;
}, as = 'data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cg clip-path="url(%23clip0_24854_8994)"%3E%3Crect width="40" height="40" fill="%230066FF"/%3E%3Cg filter="url(%23filter0_f_24854_8994)"%3E%3Cpath d="M32.6382 31.0816C41.9891 31.0816 49.5694 23.5012 49.5694 14.1504C49.5694 4.79953 41.9891 -2.78082 32.6382 -2.78082C23.2874 -2.78082 15.707 4.79953 15.707 14.1504C15.707 23.5012 23.2874 31.0816 32.6382 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter1_f_24854_8994)"%3E%3Cpath d="M10.417 50.1292C19.7679 50.1292 27.3482 42.5488 27.3482 33.198C27.3482 23.8471 19.7679 16.2668 10.417 16.2668C1.0662 16.2668 -6.51416 23.8471 -6.51416 33.198C-6.51416 42.5488 1.0662 50.1292 10.417 50.1292Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter2_f_24854_8994)"%3E%3Cpath d="M9.35788 16.2667C15.2022 16.2667 19.9399 11.529 19.9399 5.68472C19.9399 -0.159555 15.2022 -4.89728 9.35788 -4.89728C3.5136 -4.89728 -1.22412 -0.159555 -1.22412 5.68472C-1.22412 11.529 3.5136 16.2667 9.35788 16.2667Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter3_f_24854_8994)"%3E%3Cpath d="M7.24274 18.3831C13.6714 18.3831 18.8829 13.1716 18.8829 6.74292C18.8829 0.314217 13.6714 -4.89728 7.24274 -4.89728C0.814034 -4.89728 -4.39746 0.314217 -4.39746 6.74292C-4.39746 13.1716 0.814034 18.3831 7.24274 18.3831Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter4_f_24854_8994)"%3E%3Cpath d="M8.29938 21.5577C14.7281 21.5577 19.9396 16.3462 19.9396 9.91748C19.9396 3.48878 14.7281 -1.72272 8.29938 -1.72272C1.87068 -1.72272 -3.34082 3.48878 -3.34082 9.91748C-3.34082 16.3462 1.87068 21.5577 8.29938 21.5577Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter5_f_24854_8994)"%3E%3Cpath d="M33.6973 45.8964C40.126 45.8964 45.3375 40.6849 45.3375 34.2562C45.3375 27.8275 40.126 22.616 33.6973 22.616C27.2686 22.616 22.0571 27.8275 22.0571 34.2562C22.0571 40.6849 27.2686 45.8964 33.6973 45.8964Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter6_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter7_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter8_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter9_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter10_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter11_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter12_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter13_f_24854_8994)"%3E%3Cpath d="M9.35898 38.489C12.8655 38.489 15.7082 35.6463 15.7082 32.1398C15.7082 28.6332 12.8655 25.7906 9.35898 25.7906C5.8524 25.7906 3.00977 28.6332 3.00977 32.1398C3.00977 35.6463 5.8524 38.489 9.35898 38.489Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter14_f_24854_8994)"%3E%3Cpath d="M38.9871 31.0816C46.5846 31.0816 52.7437 24.9225 52.7437 17.325C52.7437 9.7274 46.5846 3.56836 38.9871 3.56836C31.3895 3.56836 25.2305 9.7274 25.2305 17.325C25.2305 24.9225 31.3895 31.0816 38.9871 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter15_f_24854_8994)"%3E%3Cpath d="M38.9879 25.7905C45.4166 25.7905 50.6281 20.579 50.6281 14.1503C50.6281 7.72157 45.4166 2.51007 38.9879 2.51007C32.5592 2.51007 27.3477 7.72157 27.3477 14.1503C27.3477 20.579 32.5592 25.7905 38.9879 25.7905Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter16_f_24854_8994)"%3E%3Cpath d="M9.35868 21.5578C14.0341 21.5578 17.8243 17.7676 17.8243 13.0922C17.8243 8.41674 14.0341 4.62656 9.35868 4.62656C4.68325 4.62656 0.893066 8.41674 0.893066 13.0922C0.893066 17.7676 4.68325 21.5578 9.35868 21.5578Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter17_f_24854_8994)"%3E%3Cpath d="M31.5797 18.3831C35.0862 18.3831 37.9289 15.5404 37.9289 12.0339C37.9289 8.5273 35.0862 5.68466 31.5797 5.68466C28.0731 5.68466 25.2305 8.5273 25.2305 12.0339C25.2305 15.5404 28.0731 18.3831 31.5797 18.3831Z" fill="%23FF2E00"/%3E%3C/g%3E%3Cg filter="url(%23filter18_f_24854_8994)"%3E%3Cpath d="M12.5312 14.1503C18.3755 14.1503 23.1132 9.41257 23.1132 3.5683C23.1132 -2.27598 18.3755 -7.0137 12.5312 -7.0137C6.68694 -7.0137 1.94922 -2.27598 1.94922 3.5683C1.94922 9.41257 6.68694 14.1503 12.5312 14.1503Z" fill="%233851FF"/%3E%3C/g%3E%3Cg filter="url(%23filter19_f_24854_8994)"%3E%3Cpath d="M28.4057 13.0921C34.25 13.0921 38.9877 8.35441 38.9877 2.51013C38.9877 -3.33415 34.25 -8.07187 28.4057 -8.07187C22.5615 -8.07187 17.8237 -3.33415 17.8237 2.51013C17.8237 8.35441 22.5615 13.0921 28.4057 13.0921Z" fill="%23F3354D"/%3E%3C/g%3E%3Cg filter="url(%23filter20_f_24854_8994)"%3E%3Cpath d="M33.6958 48.0128C39.54 48.0128 44.2778 43.275 44.2778 37.4308C44.2778 31.5865 39.54 26.8488 33.6958 26.8488C27.8515 26.8488 23.1138 31.5865 23.1138 37.4308C23.1138 43.275 27.8515 48.0128 33.6958 48.0128Z" fill="%23FFD101"/%3E%3C/g%3E%3Cg filter="url(%23filter21_f_24854_8994)"%3E%3Cpath d="M8.30173 43.78C14.146 43.78 18.8837 39.0422 18.8837 33.198C18.8837 27.3537 14.146 22.616 8.30173 22.616C2.45745 22.616 -2.28027 27.3537 -2.28027 33.198C-2.28027 39.0422 2.45745 43.78 8.30173 43.78Z" fill="%237FCF35"/%3E%3C/g%3E%3Cg filter="url(%23filter22_f_24854_8994)"%3E%3Cpath d="M6.18454 34.2562C12.0288 34.2562 16.7665 29.5184 16.7665 23.6742C16.7665 17.8299 12.0288 13.0922 6.18454 13.0922C0.340261 13.0922 -4.39746 17.8299 -4.39746 23.6742C-4.39746 29.5184 0.340261 34.2562 6.18454 34.2562Z" fill="%231D7DD0"/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id="filter0_f_24854_8994" x="-8.29297" y="-26.7808" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter1_f_24854_8994" x="-30.5142" y="-7.73322" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter2_f_24854_8994" x="-25.2241" y="-28.8973" width="69.1641" height="69.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter3_f_24854_8994" x="-28.3975" y="-28.8973" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter4_f_24854_8994" x="-27.3408" y="-25.7227" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter5_f_24854_8994" x="-1.94287" y="-1.38403" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter6_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter7_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter8_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter9_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter10_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter11_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter12_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter13_f_24854_8994" x="-20.9902" y="1.79056" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter14_f_24854_8994" x="1.23047" y="-20.4316" width="75.5132" height="75.5132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter15_f_24854_8994" x="3.34766" y="-21.4899" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter16_f_24854_8994" x="-23.1069" y="-19.3734" width="64.9312" height="64.9312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter17_f_24854_8994" x="1.23047" y="-18.3153" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter18_f_24854_8994" x="-9.05078" y="-18.0137" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter19_f_24854_8994" x="6.82373" y="-19.0719" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter20_f_24854_8994" x="12.1138" y="15.8488" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter21_f_24854_8994" x="-13.2803" y="11.616" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter22_f_24854_8994" x="-15.3975" y="2.09216" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3CclipPath id="clip0_24854_8994"%3E%3Crect width="40" height="40" fill="white"/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A', rs = [
  {
    id: "livechat",
    name: "LiveChat",
    icon: $l,
    backgroundColors: {
      main: "var(--products-livechat)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "chatbot",
    name: "ChatBot",
    icon: Nl,
    backgroundColors: {
      main: "var(--products-chatbot)",
      second: "var(--products-livechat)",
      third: "var(--products-helpdesk)"
    },
    url: ""
  },
  {
    id: "helpdesk",
    name: "HelpDesk",
    icon: Sl,
    backgroundColors: {
      main: "var(--products-helpdesk)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: "",
    expired: !0
  },
  {
    id: "knowledgebase",
    name: "KnowledgeBase",
    icon: xl,
    backgroundColors: {
      main: "var(--products-knowledgebase)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: "",
    trialDaysLeft: 2
  },
  {
    id: "openwidget",
    name: "OpenWidget",
    icon: El,
    backgroundColors: {
      main: `url('${as}')`,
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "teamchat",
    name: "TeamChat",
    icon: Tl,
    backgroundColors: {
      main: "var(--products-hello)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "accounts",
    name: "Text Accounts",
    icon: Bl,
    backgroundColors: {
      main: "var(--surface-locked-white)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    iconColor: "var(--content-locked-black)",
    withDivider: !0,
    url: "",
    borderColor: "var(--border-basic-secondary)"
  }
], _s = [
  {
    clientId: "58737b5829e65621a45d598aa6f2ed8e",
    redirectUri: "https://my.labs.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "ee078090-b721-4e2b-9cf2-65e95904634c",
    redirectUri: "https://app.labs.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "9638698004690917c9b787a2e16fc007",
    redirectUri: "https://app.staging.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "40f0baca4e364c84c2d89bf3403caa31",
    redirectUri: "https://app.labs.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "de5fce27f8c77fa41e9fa621beeed111",
    redirectUri: "https://app.staging.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6193fd6d9771645e2dc6a4614c677314",
    redirectUri: "https://teamchat.labs.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "0ab5cf9b99447db22109ff70003d4507",
    redirectUri: "https://accounts.labs.livechat.com/panel",
    product: "Accounts"
  }
], os = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.staging.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.staging.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6c493637185258c1a937e68886906831",
    redirectUri: "https//teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.staging.livechat.com/panel",
    product: "Accounts"
  }
], Qo = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "1ebfa721f575b1346b9c76bb8f86583c",
    redirectUri: "https://teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.livechat.com/panel",
    product: "Accounts"
  }
], ls = [
  "livechat",
  "chatbot",
  "helpdesk",
  "accounts"
], F_ = {
  livechat: "LiveChat",
  helpdesk: "HelpDesk",
  accounts: "Accounts",
  knowledgebase: "KnowledgeBase",
  chatbot: "ChatBot",
  openwidget: "OpenWidget",
  teamchat: "TeamChat"
}, is = (e, a, r, _, o) => {
  let l = "";
  o && o !== "prod" ? l += `https://accounts.${o}.livechat.com` : l += "https://accounts.livechat.com";
  const i = ds(o, _), n = `${l}?client_id=${e}&redirect_uri=${encodeURIComponent(
    a
  )}&response_type=token&organization_id=${r}`;
  return i ? `${n}&utm_source=${i}&utm_medium=referral&utm_campaign=productswitcher` : n;
}, ns = (e) => {
  const a = new Date(e), r = /* @__PURE__ */ new Date();
  return ti(a) ? 0 : Eo(a, r);
}, cs = (e, a) => ls.includes(e) || a.some(
  (r) => r.product === F_[e]
), ss = (e, a, r, _, o, l) => {
  var n, d, s, c, p;
  const i = a.find(
    (m) => m.product === F_[e.id]
  );
  if (!i)
    throw new Error(`Product data for ${e.id} not found`);
  return B(y({}, e), {
    trialDaysLeft: r[e.id] && ((n = r[e.id]) == null ? void 0 : n.status) === "trial" && ((d = r[e.id]) != null && d.next_charge_at) ? ns((c = (s = r[e.id]) == null ? void 0 : s.next_charge_at) != null ? c : "") : void 0,
    expired: ((p = r[e.id]) == null ? void 0 : p.status) === "expired",
    url: is(
      i.clientId,
      i.redirectUri,
      _,
      o,
      l
    )
  });
}, el = (e) => {
  switch (e) {
    case "prod":
      return Qo;
    case "staging":
      return os;
    case "labs":
      return _s;
    default:
      return [];
  }
}, ds = (e, a) => {
  const _ = el(e).find(
    (o) => o.product === F_[a]
  );
  return _ == null ? void 0 : _.redirectUri.replace("https://", "");
}, Xu = ({
  env: e = "prod",
  installedProducts: a,
  subscriptions: r,
  organizationId: _,
  mainProductId: o
}) => {
  if (!a || !r || !_)
    throw new Error("Missing required parameters");
  const l = e ? el(e) : Qo;
  return {
    products: rs.reduce(
      (i, n) => (cs(n.id, a) && i.push(
        ss(
          n,
          l,
          r,
          _,
          o,
          e
        )
      ), i),
      []
    )
  };
}, us = (e) => Math.min(Math.max(e, 0), 100);
function tl(e, a = 0) {
  return e === "error" ? 0 : us(parseInt(a.toString(), 10));
}
const Va = {
  "progress-circle": "lc-ProgressCircle-module__progress-circle___H4Abd",
  "progress-circle--small": "lc-ProgressCircle-module__progress-circle--small___BH3y7",
  "progress-circle--medium": "lc-ProgressCircle-module__progress-circle--medium___0GWFs",
  "progress-circle--large": "lc-ProgressCircle-module__progress-circle--large___AxNYV",
  "progress-circle__bg-line--normal": "lc-ProgressCircle-module__progress-circle__bg-line--normal___LYe5F",
  "progress-circle__bg-line--success": "lc-ProgressCircle-module__progress-circle__bg-line--success___51Jk6",
  "progress-circle__bg-line--error": "lc-ProgressCircle-module__progress-circle__bg-line--error___uIy7L",
  "progress-circle__indicator--normal": "lc-ProgressCircle-module__progress-circle__indicator--normal___LVjBb",
  "progress-circle__indicator--success": "lc-ProgressCircle-module__progress-circle__indicator--success___JnXe0",
  "progress-circle__indicator--error": "lc-ProgressCircle-module__progress-circle__indicator--error___HejoU"
}, ms = {
  small: 2,
  medium: 3,
  large: 4
}, ps = {
  small: 15,
  medium: 36,
  large: 56
}, Wa = "progress-circle", gs = v.forwardRef(
  (i, l) => {
    var n = i, {
      status: e = "normal",
      progressValue: a,
      className: r,
      size: _ = "medium"
    } = n, o = U(n, [
      "status",
      "progressValue",
      "className",
      "size"
    ]);
    const d = tl(e, a), s = ms[_], c = ps[_], p = u(
      Va[Wa],
      {
        [Va[`${Wa}--${_}`]]: _,
        [Va[`${Wa}--${e}`]]: e
      },
      r
    ), m = 2 * Math.PI * ((c - s) / 2), f = {
      strokeDasharray: m.toFixed(3),
      strokeDashoffset: `${((100 - d) / 100 * m).toFixed(3)}px`
    }, g = `${c / 2} ${c / 2} ${c} ${c}`;
    return /* @__PURE__ */ t(
      "div",
      B(y({
        className: p,
        ref: l,
        role: "progressbar"
      }, o), {
        children: /* @__PURE__ */ h("svg", { viewBox: g, children: [
          /* @__PURE__ */ t(
            "circle",
            {
              className: Va[`${Wa}__bg-line--${e}`],
              cx: c,
              cy: c,
              r: (c - s) / 2,
              fill: "none",
              strokeWidth: s
            }
          ),
          /* @__PURE__ */ t(
            "circle",
            {
              className: Va[`${Wa}__indicator--${e}`],
              style: f,
              cx: c,
              cy: c,
              r: (c - s) / 2,
              fill: "none",
              strokeWidth: s
            }
          )
        ] })
      })
    );
  }
), Er = {
  "progress-bar": "lc-ProgressBar-module__progress-bar___ERC2D",
  "progress-bar--small": "lc-ProgressBar-module__progress-bar--small___PPhCr",
  "progress-bar--medium": "lc-ProgressBar-module__progress-bar--medium___GgSEb",
  "progress-bar--large": "lc-ProgressBar-module__progress-bar--large___Seq-t",
  "progress-bar--error": "lc-ProgressBar-module__progress-bar--error___2AR1I",
  "progress-bar--success": "lc-ProgressBar-module__progress-bar--success___-fKPU",
  "progress-bar--normal": "lc-ProgressBar-module__progress-bar--normal___WboRI",
  "progress-bar__indicator--success": "lc-ProgressBar-module__progress-bar__indicator--success___MHAlN",
  "progress-bar__indicator--normal": "lc-ProgressBar-module__progress-bar__indicator--normal___sjEAI"
}, Tr = "progress-bar", hs = v.forwardRef(
  (i, l) => {
    var n = i, {
      status: e = "normal",
      percent: a,
      size: r = "medium",
      className: _ = ""
    } = n, o = U(n, [
      "status",
      "percent",
      "size",
      "className"
    ]);
    const d = tl(e, a), s = u(
      Er[Tr],
      {
        [Er[`${Tr}--${r}`]]: r,
        [Er[`${Tr}--${e}`]]: e
      },
      _
    );
    return /* @__PURE__ */ t(
      "div",
      B(y({}, o), {
        className: s,
        ref: l,
        role: "progressbar",
        children: /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "progress-bar-indicator",
            className: Er[`${Tr}__indicator--${e}`],
            style: { width: `${d}%` }
          }
        )
      })
    );
  }
), Bt = {
  "main-wrapper": "lc-PromoBannerV2-module__main-wrapper___6Ka0j",
  "promo-banner-v2": "lc-PromoBannerV2-module__promo-banner-v2___vkVos",
  "promo-banner-v2__content": "lc-PromoBannerV2-module__promo-banner-v2__content___16-yG",
  "promo-banner-v2__content__cta": "lc-PromoBannerV2-module__promo-banner-v2__content__cta___59Ml7",
  "promo-banner-v2__content__cta__secondary": "lc-PromoBannerV2-module__promo-banner-v2__content__cta__secondary___ka6nD",
  "promo-banner-v2__additional-content": "lc-PromoBannerV2-module__promo-banner-v2__additional-content___QsE3z",
  "promo-banner-v2__close": "lc-PromoBannerV2-module__promo-banner-v2__close___HA3Hr",
  "promo-banner-v2__close__btn": "lc-PromoBannerV2-module__promo-banner-v2__close__btn___23Qui",
  "promo-banner-v2--dark": "lc-PromoBannerV2-module__promo-banner-v2--dark___pmXpS",
  "promo-banner-v2--vertical": "lc-PromoBannerV2-module__promo-banner-v2--vertical___hXlPD"
}, Ht = "promo-banner-v2", Zu = ({
  children: e,
  className: a,
  additionalContent: r,
  primaryButton: _,
  secondaryButton: o,
  vertical: l,
  contentClassName: i,
  additionalContentClassName: n,
  onClose: d,
  kind: s = "default"
}) => {
  const c = u(
    Bt["main-wrapper"],
    Bt[`${Ht}--${s}`],
    s === "dark" && Qt.Dark,
    a
  );
  return /* @__PURE__ */ t("div", { role: "banner", className: c, children: /* @__PURE__ */ h(
    "div",
    {
      className: u(
        Bt[Ht],
        l && Bt[`${Ht}--vertical`]
      ),
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            "data-testId": "content",
            className: u(Bt[`${Ht}__content`], i),
            children: [
              e,
              (_ || o) && /* @__PURE__ */ h("div", { className: Bt[`${Ht}__content__cta`], children: [
                _ && /* @__PURE__ */ t(
                  H,
                  B(y({}, _), {
                    kind: (_ == null ? void 0 : _.kind) || "high-contrast",
                    onClick: _.handleClick,
                    children: _.label
                  })
                ),
                o && /* @__PURE__ */ t(
                  H,
                  B(y({}, o), {
                    kind: (o == null ? void 0 : o.kind) || "text",
                    onClick: o.handleClick,
                    className: u(
                      Bt[`${Ht}__content__cta__secondary`],
                      o.className
                    ),
                    children: o.label
                  })
                )
              ] })
            ]
          }
        ),
        r && /* @__PURE__ */ t(
          "div",
          {
            "data-testId": "additional-content",
            className: u(
              Bt[`${Ht}__additional-content`],
              n
            ),
            children: r
          }
        ),
        d && /* @__PURE__ */ t("div", { className: Bt[`${Ht}__close`], children: /* @__PURE__ */ t(
          H,
          {
            className: Bt[`${Ht}__close__btn`],
            onClick: d,
            icon: /* @__PURE__ */ t(R, { source: dt, kind: "primary" }),
            kind: "plain",
            size: "compact",
            "aria-label": "Close banner"
          }
        ) })
      ]
    }
  ) });
}, It = {
  "radio-button": "lc-RadioButton-module__radio-button___PtGXj",
  "radio-button__circle": "lc-RadioButton-module__radio-button__circle___-RXEf",
  "radio-button__label": "lc-RadioButton-module__radio-button__label___WGhio",
  "radio-button__inner-circle": "lc-RadioButton-module__radio-button__inner-circle___T5nYz",
  "radio-button__text": "lc-RadioButton-module__radio-button__text___8q8cs",
  "radio-button__input": "lc-RadioButton-module__radio-button__input___nd4MZ",
  "radio-button__helper": "lc-RadioButton-module__radio-button__helper___X4Ihv",
  "radio-button--read-only": "lc-RadioButton-module__radio-button--read-only___pSy5f",
  "radio-button--selected": "lc-RadioButton-module__radio-button--selected___00LlN",
  "radio-button--disabled": "lc-RadioButton-module__radio-button--disabled___StpOi"
}, At = "radio-button", fs = v.forwardRef(
  (n, i) => {
    var d = n, { children: e, className: a = "", description: r, checked: _, disabled: o } = d, l = U(d, ["children", "className", "description", "checked", "disabled"]);
    const { readOnly: s } = Ot(), c = s || l.readOnly, p = u(It[At], a, {
      [It[`${At}--selected`]]: _,
      [It[`${At}--disabled`]]: o,
      [It[`${At}--read-only`]]: c
    });
    return /* @__PURE__ */ h("div", { className: p, children: [
      /* @__PURE__ */ h("label", { className: It[`${At}__label`], children: [
        /* @__PURE__ */ h("div", { className: It[`${At}__circle`], children: [
          /* @__PURE__ */ t("span", { className: It[`${At}__inner-circle`] }),
          /* @__PURE__ */ t(
            "input",
            B(y({}, l), {
              className: It[`${At}__input`],
              ref: i,
              type: "radio",
              checked: _,
              disabled: o
            })
          )
        ] }),
        e && /* @__PURE__ */ t(D, { as: "div", size: "md", className: It[`${At}__text`], children: e })
      ] }),
      r && /* @__PURE__ */ t(Vr, { className: It[`${At}__helper`], children: r })
    ] });
  }
), po = {
  "range-date-picker-v2-label": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label___jHKH2",
  "range-date-picker-v2-label--selected": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label--selected___I-O8x"
}, go = "range-date-picker-v2-label", bs = ({
  tempDate: e,
  date: a,
  selectedOptionName: r
}) => {
  const _ = () => e != null && e.from ? `${gr(e.from, "dd-MM-yy")}` : a != null && a.from ? `${gr(a.from, "dd-MM-yy")}` : "Start date", o = () => e != null && e.to ? `${gr(e.to, "dd-MM-yy")}` : a != null && a.to ? `${gr(a.to, "dd-MM-yy")}` : "End date";
  return /* @__PURE__ */ h(
    D,
    {
      className: u(po[`${go}`], {
        [po[`${go}--selected`]]: (a == null ? void 0 : a.from) && (a == null ? void 0 : a.to)
      }),
      children: [
        _(),
        " - ",
        o(),
        " ",
        r && `(${r})`
      ]
    }
  );
}, _t = To(), Br = [
  {
    id: "today",
    label: "Today",
    value: { from: _t, to: _t }
  },
  {
    id: "yesterday",
    label: "Yesterday",
    value: { from: hr(_t, 1), to: hr(_t, 1) }
  },
  {
    id: "last7days",
    label: "Last 7 days",
    value: { from: hr(_t, 6), to: _t }
  },
  {
    id: "last30days",
    label: "Last 30 days",
    value: { from: hr(_t, 29), to: _t }
  },
  {
    id: "lastMonth",
    label: "Last month",
    value: {
      from: H_(ia(_t, 1)),
      to: ai(ia(_t, 1))
    }
  },
  {
    id: "currentMonth",
    label: "Current month",
    value: { from: H_(_t), to: _t }
  }
], vs = (e, a) => a != null && a.from && (a != null && a.to) && (e != null && e.from) && (e != null && e.to) ? a.from.getTime() === e.from.getTime() && a.to.getTime() === e.to.getTime() : !1, Re = {
  "range-date-picker__popover": "lc-RangeDatePickerV2-module__range-date-picker__popover___0Q1sv",
  "range-date-picker__trigger": "lc-RangeDatePickerV2-module__range-date-picker__trigger___QX-yx",
  "range-date-picker__trigger__right-node--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node--active___HYCcu",
  "range-date-picker__trigger__right-node__icon": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__icon___fHaPd",
  "range-date-picker__trigger__right-node__button": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__button___XqDl3",
  "range-date-picker__trigger__right-node": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node___amiev",
  "range-date-picker__trigger--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger--active___JX1bA",
  "range-date-picker__date-picker": "lc-RangeDatePickerV2-module__range-date-picker__date-picker___dzDlt",
  "range-date-picker__date-picker__list": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list___tlSQ8",
  "range-date-picker__date-picker__list__item": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item___uH4Y9",
  "range-date-picker__date-picker__list__item--selected": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item--selected___-0-d6",
  "range-date-picker__date-picker__list__item__icon": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item__icon___5A--A",
  "range-date-picker__date-picker__callendar": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__callendar___3dPDs"
}, Ge = "range-date-picker", ys = To(), ks = 680, ju = (i) => {
  var n = i, {
    initiallyOpen: e = !1,
    initialSelectedOptionId: a,
    onRangeSelect: r,
    triggerClassName: _,
    rangeDatePickerClassName: o
  } = n, l = U(n, [
    "initiallyOpen",
    "initialSelectedOptionId",
    "onRangeSelect",
    "triggerClassName",
    "rangeDatePickerClassName"
  ]);
  const { initialFromDate: d, initialToDate: s } = l, c = d || s ? {
    from: d,
    to: s
  } : void 0, [p, m] = de(c), [f, g] = de(!1), [w, x] = de(), [S, E] = de(e), [N, C] = de(), $ = Xt(-1), b = Xt(null);
  window.onresize = () => window.innerWidth <= ks ? g(!0) : g(!1);
  const k = (P) => $.current + P, I = (P) => {
    var q, Y;
    $.current = k(P);
    const L = (q = b.current) == null ? void 0 : q.children, M = L && ((Y = L[$.current]) == null ? void 0 : Y.children[0]);
    return M == null ? void 0 : M.focus();
  }, T = (P) => {
    P.key === ue.arrowUp && $.current > 0 && (P.preventDefault(), I(-1)), P.key === ue.arrowDown && $.current + 1 < Br.length && (P.preventDefault(), I(1));
  }, F = (P, L) => {
    m(P || void 0), r(P, L), x(void 0), C(void 0);
  }, A = () => {
    x(void 0), E(!1);
  }, O = kt(
    ({ from: P, to: L }, M) => {
      F({ from: P, to: L }, M), A(), C(M);
    },
    [F, A]
  ), G = kt(
    (P) => {
      !P || vs(P, p) || (F(P), A());
    },
    [p]
  );
  return V(() => {
    if (S)
      return document.addEventListener("keydown", T), () => document.removeEventListener("keydown", T);
    $.current = -1;
  }, [S, T]), V(() => {
    if (a && !p) {
      const P = Br.find(({ id: L }) => L === a);
      P && O(P.value, P.id);
    }
  }, [a, p, O]), /* @__PURE__ */ t("div", { className: Re[Ge], children: /* @__PURE__ */ t(
    es,
    {
      isVisible: S,
      onOpen: () => E(!0),
      onClose: A,
      className: Re[`${Ge}__popover`],
      placement: "bottom-start",
      triggerRenderer: () => {
        var P;
        return /* @__PURE__ */ h(
          "div",
          {
            tabIndex: 0,
            role: "button",
            "data-testid": "range-date-picker-trigger",
            "aria-label": "Select date range",
            className: u(
              Re[`${Ge}__trigger`],
              {
                [Re[`${Ge}__trigger--active`]]: S
              },
              _
            ),
            onKeyDown: (L) => {
              (L.key === ue.enter || L.key === ue.spacebar) && I(1);
            },
            children: [
              /* @__PURE__ */ t(
                bs,
                {
                  tempDate: w,
                  date: p,
                  selectedOptionName: (P = Br.find(({ id: L }) => L === N)) == null ? void 0 : P.label
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: u(
                    Re[`${Ge}__trigger__right-node`],
                    p && Re[`${Ge}__trigger__right-node--active`]
                  ),
                  children: [
                    /* @__PURE__ */ t(
                      R,
                      {
                        source: Il,
                        className: Re[`${Ge}__trigger__right-node__icon`]
                      }
                    ),
                    p && /* @__PURE__ */ t(
                      H,
                      {
                        size: "xcompact",
                        kind: "plain",
                        icon: /* @__PURE__ */ t(R, { size: "xsmall", source: dt }),
                        className: Re[`${Ge}__trigger__right-node__button`],
                        onClick: () => F(null)
                      }
                    )
                  ]
                }
              )
            ]
          }
        );
      },
      children: /* @__PURE__ */ h(
        "div",
        {
          "data-testid": "range-date-picker",
          id: "date-range-popup",
          className: u(
            Re[`${Ge}__date-picker`],
            o
          ),
          children: [
            /* @__PURE__ */ t(
              "ul",
              {
                role: "menu",
                ref: b,
                className: Re[`${Ge}__date-picker__list`],
                children: Br.map((P) => /* @__PURE__ */ t("li", { role: "none", children: /* @__PURE__ */ h(
                  "button",
                  {
                    "aria-selected": N === P.id,
                    role: "menuitem",
                    className: u(
                      Re[`${Ge}__date-picker__list__item`],
                      {
                        [Re[`${Ge}__date-picker__list__item--selected`]]: N === P.id
                      }
                    ),
                    onClick: () => O(P.value, P.id),
                    onMouseEnter: () => x(P.value),
                    onMouseLeave: () => x(void 0),
                    children: [
                      /* @__PURE__ */ t(D, { as: "span", children: P.label }),
                      N === P.id && /* @__PURE__ */ t(
                        "div",
                        {
                          className: Re[`${Ge}__date-picker__list__item__icon`],
                          children: /* @__PURE__ */ t(R, { source: Na, kind: "action-primary" })
                        }
                      )
                    ]
                  }
                ) }, P.id))
              }
            ),
            /* @__PURE__ */ t("div", { className: Re[`${Ge}__date-picker__callendar`], children: /* @__PURE__ */ t(
              jo,
              B(y({
                onRangeSelect: G,
                customTempFromDate: (w == null ? void 0 : w.from) || (p == null ? void 0 : p.from),
                customTempToDate: (w == null ? void 0 : w.to) || (p == null ? void 0 : p.to),
                onCustomTempDateRangeChange: x,
                initialToDate: (p == null ? void 0 : p.to) || ys
              }, l), {
                children: ({ datepicker: P }) => /* @__PURE__ */ t(Sc, B(y({}, P), { numberOfMonths: f ? 1 : 2 }))
              })
            ) })
          ]
        }
      )
    }
  ) });
}, Ue = {
  "search-input": "lc-SearchInput-module__search-input___3J4w9",
  "search-input--compact": "lc-SearchInput-module__search-input--compact___4hBLm",
  "search-input--medium": "lc-SearchInput-module__search-input--medium___c3OEc",
  "search-input--large": "lc-SearchInput-module__search-input--large___RcwfK",
  "search-input--focused": "lc-SearchInput-module__search-input--focused___XvA05",
  "search-input--disabled": "lc-SearchInput-module__search-input--disabled___m1suy",
  "search-input--collapsable": "lc-SearchInput-module__search-input--collapsable___LgOIB",
  "search-input--collapsable--compact": "lc-SearchInput-module__search-input--collapsable--compact___QgiH-",
  "search-input--collapsable--medium": "lc-SearchInput-module__search-input--collapsable--medium___KVwWI",
  "search-input--collapsable--large": "lc-SearchInput-module__search-input--collapsable--large___ks2s-",
  "search-input__search-icon": "lc-SearchInput-module__search-input__search-icon___KYne6",
  "search-input--collapsable--open": "lc-SearchInput-module__search-input--collapsable--open___a3kOq",
  "search-input__search-icon--compact": "lc-SearchInput-module__search-input__search-icon--compact___3imck",
  "search-input__search-icon--medium": "lc-SearchInput-module__search-input__search-icon--medium___exSsN",
  "search-input__search-icon--large": "lc-SearchInput-module__search-input__search-icon--large___qFfxH",
  "search-input__clear-icon": "lc-SearchInput-module__search-input__clear-icon___PgKgA",
  "search-input__loader": "lc-SearchInput-module__search-input__loader___9veIC",
  "search-input__input-wrapper": "lc-SearchInput-module__search-input__input-wrapper___9NT39",
  "search-input__input-wrapper--compact": "lc-SearchInput-module__search-input__input-wrapper--compact___d-GJ7",
  "search-input__input-wrapper--medium": "lc-SearchInput-module__search-input__input-wrapper--medium___VN8Dh",
  "search-input__input-wrapper--large": "lc-SearchInput-module__search-input__input-wrapper--large___ZwZ0o",
  "search-input__input-wrapper--crop": "lc-SearchInput-module__search-input__input-wrapper--crop___JA7J1"
}, it = "search-input", s_ = `${it}__input-wrapper`, ws = v.forwardRef(
  (p, c) => {
    var m = p, {
      isCollapsable: e,
      isDisabled: a,
      isLoading: r,
      placeholder: _ = "Search ...",
      size: o = "medium",
      value: l,
      className: i,
      cropOnBlur: n = !0,
      onChange: d
    } = m, s = U(m, [
      "isCollapsable",
      "isDisabled",
      "isLoading",
      "placeholder",
      "size",
      "value",
      "className",
      "cropOnBlur",
      "onChange"
    ]);
    const f = v.useRef(null);
    v.useImperativeHandle(c, () => f.current, [c]);
    const [g, w] = v.useState(!0), [x, S] = v.useState(!1), E = !!l && !a && !r, N = e && !g && "true", C = u(
      i,
      Ue[it],
      Ue[`${it}--${o}`],
      x && Ue[`${it}--focused`],
      a && Ue[`${it}--disabled`],
      e && Ue[`${it}--collapsable`],
      e && Ue[`${it}--collapsable--${o}`],
      !g && Ue[`${it}--collapsable--open`]
    );
    v.useEffect(() => {
      e && l && w(!1);
    }, [e, l]);
    const $ = (A) => {
      const O = A.currentTarget.value;
      d(O);
    }, b = () => {
      d("");
    }, k = () => {
      f.current && f.current.focus();
    }, I = () => {
      e && w(!1), S(!0);
    }, T = () => {
      e && !l && w(!0), S(!1);
    }, F = (A) => {
      A.key === ue.enter && (A.preventDefault(), d(l));
    };
    return /* @__PURE__ */ h(
      "div",
      {
        "aria-expanded": N,
        role: "search",
        className: C,
        onClick: k,
        children: [
          /* @__PURE__ */ t(
            R,
            {
              className: u(
                Ue[`${it}__search-icon`],
                Ue[`${it}__search-icon--${o}`]
              ),
              source: Al,
              disabled: a,
              kind: "primary"
            }
          ),
          /* @__PURE__ */ t(
            D,
            {
              as: "div",
              className: u(
                Ue[s_],
                Ue[`${s_}--${o}`],
                n && Ue[`${s_}--crop`]
              ),
              children: /* @__PURE__ */ t(
                "input",
                y({
                  role: "searchbox",
                  ref: f,
                  type: "text",
                  value: l,
                  placeholder: _,
                  onChange: $,
                  onBlur: T,
                  onFocus: I,
                  onKeyDown: F,
                  disabled: a
                }, s)
              )
            }
          ),
          E && /* @__PURE__ */ t(
            H,
            {
              "aria-label": "Clear search",
              title: "Clear search",
              className: Ue[`${it}__clear-icon`],
              onClick: b,
              icon: /* @__PURE__ */ t(R, { source: dt, kind: "primary" }),
              kind: "text",
              size: "compact"
            }
          ),
          r && /* @__PURE__ */ t("div", { className: Ue[`${it}__loader`], children: /* @__PURE__ */ t(O_, { size: "small" }) })
        ]
      }
    );
  }
);
ws.displayName = "SearchInput";
const Ka = {
  "selectable-card": "lc-SelectableCard-module__selectable-card___b2hXr",
  "selectable-card--thumbnail": "lc-SelectableCard-module__selectable-card--thumbnail___lS1aG",
  "selectable-card__select-indicator": "lc-SelectableCard-module__selectable-card__select-indicator___JalkO",
  "selectable-card--gallery": "lc-SelectableCard-module__selectable-card--gallery___0sJB1",
  "selectable-card--interactive": "lc-SelectableCard-module__selectable-card--interactive___r8N-q",
  "selectable-card--selected": "lc-SelectableCard-module__selectable-card--selected___StMaB",
  "selectable-card__select-indicator__checkbox": "lc-SelectableCard-module__selectable-card__select-indicator__checkbox___qoZSh"
}, Ya = "selectable-card", R_ = (d) => {
  var s = d, {
    children: e,
    className: a,
    kind: r = "interactive",
    selectionType: _,
    isSelected: o = !1,
    onClick: l,
    style: i
  } = s, n = U(s, [
    "children",
    "className",
    "kind",
    "selectionType",
    "isSelected",
    "onClick",
    "style"
  ]);
  const c = u(
    Ka[Ya],
    Ka[`${Ya}--${r}`],
    {
      [Ka[`${Ya}--selected`]]: o
    },
    a
  ), { handleInteractiveClick: p } = si({ onClick: l });
  return /* @__PURE__ */ h(
    "div",
    B(y({
      "aria-selected": o,
      "aria-label": typeof e == "string" ? e : void 0,
      role: "button",
      tabIndex: 0,
      className: c,
      onClick: p,
      onKeyDown: (f) => {
        f.currentTarget === document.activeElement && (f.key === "Enter" || f.key === " " || f.key === "Spacebar" || f.key === "Space") && (f.preventDefault(), l == null || l());
      },
      style: i
    }, n), {
      children: [
        /* @__PURE__ */ t("div", { className: Ka[`${Ya}__select-indicator`], children: _ === "radio" ? /* @__PURE__ */ t(fs, { tabIndex: -1, onClick: l, checked: o }) : /* @__PURE__ */ t(
          Wr,
          {
            tabIndex: -1,
            onClick: l,
            className: Ka[`${Ya}__select-indicator__checkbox`],
            checked: o
          }
        ) }),
        e
      ]
    })
  );
}, Xa = {
  "thumbnail-selectable-card": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card___G2B0C",
  "thumbnail-selectable-card__icon": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__icon___GRN1c",
  "thumbnail-selectable-card__content": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content___-O6lf",
  "thumbnail-selectable-card__content__description": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content__description___b7-vQ"
}, Za = "thumbnail-selectable-card", Ju = (i) => {
  var n = i, {
    label: e,
    description: a,
    icon: r,
    customElement: _,
    contentClassName: o
  } = n, l = U(n, [
    "label",
    "description",
    "icon",
    "customElement",
    "contentClassName"
  ]);
  return /* @__PURE__ */ t(R_, B(y({}, l), { kind: "thumbnail", children: /* @__PURE__ */ h(
    "div",
    {
      role: "presentation",
      className: u(Xa[Za], o),
      children: [
        !_ && /* @__PURE__ */ h(Z, { children: [
          r && /* @__PURE__ */ t("div", { className: Xa[`${Za}__icon`], children: r }),
          /* @__PURE__ */ h("div", { className: Xa[`${Za}__content`], children: [
            /* @__PURE__ */ t(D, { as: "span", className: Xa[`${Za}__content__label`], children: e }),
            /* @__PURE__ */ t(
              D,
              {
                size: "sm",
                as: "span",
                className: Xa[`${Za}__content__description`],
                children: a
              }
            )
          ] })
        ] }),
        _
      ]
    }
  ) }));
}, d_ = {
  "gallery-selectable-card": "lc-GallerySelectableCard-module__gallery-selectable-card___z-d6f",
  "gallery-selectable-card--with-label": "lc-GallerySelectableCard-module__gallery-selectable-card--with-label___cXRfx",
  "gallery-selectable-card__label": "lc-GallerySelectableCard-module__gallery-selectable-card__label___XTehc"
}, u_ = "gallery-selectable-card", Qu = (i) => {
  var n = i, {
    label: e,
    icon: a,
    customElement: r,
    contentClassName: _,
    className: o
  } = n, l = U(n, [
    "label",
    "icon",
    "customElement",
    "contentClassName",
    "className"
  ]);
  return /* @__PURE__ */ t(
    R_,
    B(y({}, l), {
      className: u(o, {
        [d_[`${u_}--with-label`]]: e
      }),
      kind: "gallery",
      children: /* @__PURE__ */ h(
        "div",
        {
          role: "presentation",
          className: u(d_[u_], _),
          children: [
            a && !r && a,
            r,
            e && /* @__PURE__ */ t(D, { as: "span", className: d_[`${u_}__label`], children: e })
          ]
        }
      )
    })
  );
}, Cs = {
  "gallery-selectable-card": "lc-InteractiveSelectableCard-module__gallery-selectable-card___FkMyM",
  "gallery-selectable-card__label": "lc-InteractiveSelectableCard-module__gallery-selectable-card__label___2fKRM"
}, $s = "interactive-selectable-card", em = (_) => {
  var o = _, {
    children: e,
    contentClassName: a
  } = o, r = U(o, [
    "children",
    "contentClassName"
  ]);
  return /* @__PURE__ */ t(R_, B(y({}, r), { kind: "interactive", children: /* @__PURE__ */ t(
    "div",
    {
      role: "presentation",
      className: u(Cs[$s], a),
      children: e
    }
  ) }));
}, al = {
  "grid-wrapper": "lc-InteractiveGrid-module__grid-wrapper___FnLIP",
  "grid-row": "lc-InteractiveGrid-module__grid-row___YsMbS",
  "grid-col": "lc-InteractiveGrid-module__grid-col___jDoA6"
}, Ns = "grid-wrapper", tm = ({
  children: e,
  className: a
}) => /* @__PURE__ */ t("div", { className: `${al[Ns]} ${a || ""}`, children: e }), rl = ({ children: e, className: a, baseClass: r, role: _ = "presentation" }) => /* @__PURE__ */ t("div", { role: _, className: `${al[r]} ${a || ""}`, children: e }), am = (e) => /* @__PURE__ */ t(rl, B(y({}, e), { baseClass: "grid-row" })), rm = (e) => /* @__PURE__ */ t(rl, B(y({}, e), { baseClass: "grid-col" })), Ss = "lc-Skeleton-module__loading___fc1WK", na = {
  "skeleton-wrapper": "lc-Skeleton-module__skeleton-wrapper___5N-1n",
  "skeleton-wrapper--vertical": "lc-Skeleton-module__skeleton-wrapper--vertical___0sU7e",
  "skeleton-avatar": "lc-Skeleton-module__skeleton-avatar___7-CDQ",
  "skeleton-avatar--square": "lc-Skeleton-module__skeleton-avatar--square___NlK0K",
  "skeleton-avatar--animated": "lc-Skeleton-module__skeleton-avatar--animated___iFXkb",
  loading: Ss,
  "skeleton-text": "lc-Skeleton-module__skeleton-text___WnwUw",
  "skeleton-text--animated": "lc-Skeleton-module__skeleton-text--animated___Bnr3Z"
}, ho = "skeleton-wrapper", _m = (o) => {
  var l = o, { children: e, vertical: a, animated: r } = l, _ = U(l, ["children", "vertical", "animated"]);
  const i = v.Children.map(e, (n) => v.isValidElement(n) ? v.cloneElement(n, {
    animated: r
  }) : n);
  return /* @__PURE__ */ t(
    "div",
    B(y({
      className: u(na[`${ho}`], {
        [na[`${ho}--vertical`]]: a
      })
    }, _), {
      children: i
    })
  );
}, m_ = "skeleton-avatar", om = ({
  square: e = !1,
  size: a = 16,
  animated: r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(na[`${m_}`], {
      [na[`${m_}--square`]]: e,
      [na[`${m_}--animated`]]: r
    }),
    style: {
      width: a,
      height: a
    }
  }
), fo = "skeleton-text", lm = ({
  height: e = 13,
  width: a,
  animated: r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(na[`${fo}`], {
      [na[`${fo}--animated`]]: r
    }),
    style: {
      height: e,
      width: a
    }
  }
), p_ = {
  "status-badge": "lc-StatusBadge-module__status-badge___lygXF",
  "status-badge--3XS": "lc-StatusBadge-module__status-badge--3XS___A-lDu",
  "status-badge--2XS": "lc-StatusBadge-module__status-badge--2XS___7u4kB",
  "status-badge--XS": "lc-StatusBadge-module__status-badge--XS___M5fdN",
  "status-badge--SM": "lc-StatusBadge-module__status-badge--SM___How9K",
  "status-badge--MD": "lc-StatusBadge-module__status-badge--MD___tlaxX",
  "status-badge--LG": "lc-StatusBadge-module__status-badge--LG___2-7IC",
  "status-badge--XL": "lc-StatusBadge-module__status-badge--XL___m-MzF",
  "status-badge--2XL": "lc-StatusBadge-module__status-badge--2XL___lSyzS",
  "status-badge--3XL": "lc-StatusBadge-module__status-badge--3XL___LpjBZ",
  "status-badge--offline": "lc-StatusBadge-module__status-badge--offline___90IJN",
  "status-badge--accept": "lc-StatusBadge-module__status-badge--accept___UvRWg",
  "status-badge--not-accept": "lc-StatusBadge-module__status-badge--not-accept___bhNkL"
}, g_ = "status-badge", im = (o) => {
  var l = o, {
    className: e,
    kind: a = "offline",
    size: r = "MD"
  } = l, _ = U(l, [
    "className",
    "kind",
    "size"
  ]);
  const i = u(
    p_[g_],
    p_[`${g_}--${a}`],
    p_[`${g_}--${r}`],
    e
  );
  return /* @__PURE__ */ t("span", y({ className: i }, _));
}, xs = "lc-Switch-module__switch__input___-bYMW", Es = "lc-Switch-module__switch__container___dYb8a", Ts = "lc-Switch-module__switch__track___3lNXx", Bs = "lc-Switch-module__switch__slider___NmDHK", Is = "lc-Switch-module__switch__loader___Pbo1Q", As = "lc-Switch-module__switch__icon___tCZTq", ve = {
  switch: "lc-Switch-module__switch___PKzsW",
  "switch__track--enabled": "lc-Switch-module__switch__track--enabled___Dwbmx",
  "switch__track--on": "lc-Switch-module__switch__track--on___7vdEj",
  "switch__track--off": "lc-Switch-module__switch__track--off___IAZA0",
  "switch--large": "lc-Switch-module__switch--large___dMF98",
  "switch--compact": "lc-Switch-module__switch--compact___T4bhh",
  "switch--medium": "lc-Switch-module__switch--medium___uruMu",
  "switch--focused": "lc-Switch-module__switch--focused___XADLL",
  switch__input: xs,
  "switch__input--disabled": "lc-Switch-module__switch__input--disabled___c1vVD",
  switch__container: Es,
  switch__track: Ts,
  "switch__container--focused": "lc-Switch-module__switch__container--focused___120ao",
  "switch__track--disabled": "lc-Switch-module__switch__track--disabled___pz3md",
  switch__slider: Bs,
  "switch__slider--large": "lc-Switch-module__switch__slider--large___0-Vky",
  "switch__slider--large--on": "lc-Switch-module__switch__slider--large--on___HXudz",
  "switch__slider--large--off": "lc-Switch-module__switch__slider--large--off___zPuP6",
  "switch__slider--compact": "lc-Switch-module__switch__slider--compact___GD-ov",
  "switch__slider--compact--on": "lc-Switch-module__switch__slider--compact--on___VhXTF",
  "switch__slider--compact--off": "lc-Switch-module__switch__slider--compact--off___a0WyG",
  "switch__slider--medium": "lc-Switch-module__switch__slider--medium___j3xMd",
  "switch__slider--medium--on": "lc-Switch-module__switch__slider--medium--on___WNNGh",
  "switch__slider--medium--off": "lc-Switch-module__switch__slider--medium--off___pkbCl",
  "switch__slider--disabled": "lc-Switch-module__switch__slider--disabled___6rrSU",
  switch__loader: Is,
  "switch__loader--compact": "lc-Switch-module__switch__loader--compact___jKLak",
  "switch__loader--medium": "lc-Switch-module__switch__loader--medium___XpfaO",
  "switch__loader--large": "lc-Switch-module__switch__loader--large___NDgeg",
  switch__icon: As
}, ge = "switch", nm = (p) => {
  var m = p, {
    className: e = "",
    defaultOn: a = !1,
    disabled: r = !1,
    name: _ = ge,
    on: o,
    onChange: l,
    size: i = "large",
    state: n = "regular",
    innerRef: d,
    ariaLabel: s
  } = m, c = U(m, [
    "className",
    "defaultOn",
    "disabled",
    "name",
    "on",
    "onChange",
    "size",
    "state",
    "innerRef",
    "ariaLabel"
  ]);
  const f = o !== void 0, [g, w] = v.useState(
    () => f ? o : a
  ), [x, S] = v.useState(!1), E = f ? o : g, N = n === "loading", C = n === "locked", $ = i === "large" ? "small" : "xsmall", b = E ? "on" : "off", k = r || N || C, I = k ? "disabled" : "enabled", T = u(
    ve[ge],
    ve[`${ge}--${i}`],
    {
      [ve[`${ge}--focused`]]: x
    },
    e
  ), F = (A) => {
    l == null || l(A, !E), f || (A.stopPropagation(), w((O) => !O));
  };
  return /* @__PURE__ */ h("span", { className: T, children: [
    /* @__PURE__ */ t(
      "input",
      B(y({
        type: "checkbox",
        className: u(
          ve[`${ge}__input`],
          ve[`${ge}__input--${I}`]
        ),
        onChange: F,
        checked: E,
        name: _,
        ref: d,
        disabled: k,
        "aria-label": s
      }, c), {
        onFocus: () => S(!0),
        onBlur: () => S(!1)
      })
    ),
    /* @__PURE__ */ h(
      "span",
      {
        className: u(ve[`${ge}__container`], {
          [ve[`${ge}__container--focused`]]: x
        }),
        children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: u(
                ve[`${ge}__track`],
                ve[`${ge}__track--${b}`],
                ve[`${ge}__track--${I}`]
              )
            }
          ),
          /* @__PURE__ */ h(
            "span",
            {
              className: u(
                ve[`${ge}__slider`],
                ve[`${ge}__slider--${I}`],
                ve[`${ge}__slider--${i}`],
                ve[`${ge}__slider--${i}--${b}`]
              ),
              children: [
                N && /* @__PURE__ */ t(
                  O_,
                  {
                    "data-testid": "switch-loader",
                    className: u(
                      ve[`${ge}__loader`],
                      ve[`${ge}__loader--${i}`]
                    )
                  }
                ),
                C && /* @__PURE__ */ t(
                  R,
                  {
                    className: ve[`${ge}__icon`],
                    "data-testid": "lock-icon",
                    size: $,
                    source: Dl,
                    kind: "primary"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, Ds = "lc-Tab-module__tab___ShyYn", Os = "lc-Tab-module__tab__count___7QKoz", Ms = "lc-Tab-module__tab__icon___eCD-d", Ps = "lc-Tab-module__tab__badge___nwfVJ", ra = {
  tab: Ds,
  tab__count: Os,
  "tab--compact": "lc-Tab-module__tab--compact___yetP5",
  "tab--medium": "lc-Tab-module__tab--medium___KhPsI",
  "tab--large": "lc-Tab-module__tab--large___3GE8k",
  tab__icon: Ms,
  tab__badge: Ps,
  "tab--selected": "lc-Tab-module__tab--selected___vsPhT",
  "tab--disabled": "lc-Tab-module__tab--disabled___JPMHC"
}, _a = "tab", cm = (d) => {
  var s = d, {
    children: e,
    className: a,
    count: r,
    isSelected: _,
    asBadge: o,
    size: l = "medium",
    icon: i
  } = s, n = U(s, [
    "children",
    "className",
    "count",
    "isSelected",
    "asBadge",
    "size",
    "icon"
  ]);
  const { disabled: c } = n, p = r !== void 0 && !o, m = r !== void 0 && o;
  return /* @__PURE__ */ h(
    D,
    B(y({}, n), {
      as: n.href ? "a" : "button",
      "aria-selected": _,
      size: "md",
      bold: _,
      className: u(
        a,
        ra[_a],
        ra[`${_a}--${l}`],
        _ && ra[`${_a}--selected`],
        c && ra[`${_a}--disabled`]
      ),
      children: [
        i && /* @__PURE__ */ t("div", { "data-testId": "icon", className: ra[`${_a}__icon`], children: i }),
        e,
        p && /* @__PURE__ */ h(D, { as: "span", size: "md", className: ra[`${_a}__count`], children: [
          "(",
          r,
          ")"
        ] }),
        m && /* @__PURE__ */ t(
          Pr,
          {
            "data-testid": "tab-badge",
            count: r,
            size: "compact",
            className: ra[`${_a}__badge`]
          }
        )
      ]
    })
  );
}, Fs = "lc-TabsWrapper-module__tabs___rJby-", Rs = "lc-TabsWrapper-module__tabs__list___ylJuP", _l = {
  tabs: Fs,
  tabs__list: Rs
}, ol = "tabs", sm = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { className: u(_l[ol], e), children: a }), dm = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { role: "tablist", className: u(_l[`${ol}__list`], e), children: a }), Gs = ({
  data: e,
  getRowId: a,
  selectedRows: r,
  onSelectionChange: _
}) => {
  const o = kt(
    (n) => !!(r != null && r.has(n)),
    [r]
  ), l = kt(
    (n) => {
      const d = new Set(r || []);
      d.has(n) ? d.delete(n) : d.add(n), _ == null || _(d);
    },
    [r, _]
  ), i = kt(() => {
    const n = new Set(e.map(a)), s = (r == null ? void 0 : r.size) === e.length ? /* @__PURE__ */ new Set() : n;
    _ == null || _(s);
  }, [e, a, r, _]);
  return {
    isSelected: o,
    toggleRowSelection: l,
    toggleSelectAll: i,
    selectedCount: r == null ? void 0 : r.size
  };
}, Us = "lc-TableRow-module__row___NrIRP", Ls = "lc-TableRow-module__table__header___eVCSg", qs = "lc-TableRow-module__row__selected___8IvPR", h_ = {
  row: Us,
  table__header: Ls,
  "row__select-cell": "lc-TableRow-module__row__select-cell___SecNT",
  row__selected: qs
}, f_ = "row", zs = ({
  row: e,
  columns: a,
  columnWidths: r,
  selectable: _,
  isSelected: o,
  toggleRowSelection: l,
  rowId: i
}) => /* @__PURE__ */ h(
  "tr",
  {
    className: u(
      h_[f_],
      o(i) ? h_[`${f_}__selected`] : void 0
    ),
    children: [
      _ && /* @__PURE__ */ t(
        "td",
        {
          role: "cell",
          "aria-selected": o(i),
          className: h_[`${f_}__select-cell`],
          children: /* @__PURE__ */ t(
            Wr,
            {
              checked: o(i),
              onChange: () => l(i)
            }
          )
        }
      ),
      a.map((n, d) => /* @__PURE__ */ t(
        "td",
        {
          style: {
            width: r[d] ? `${r[d]}px` : "auto"
          },
          role: "cell",
          "data-column": String(n.key),
          children: /* @__PURE__ */ t(D, { size: "md", noMargin: !0, children: e[n.key] })
        },
        String(n.key)
      ))
    ]
  }
), Hs = ({
  data: e,
  columns: a,
  getRowId: r,
  columnWidths: _,
  selectable: o,
  isSelected: l,
  toggleRowSelection: i
}) => /* @__PURE__ */ t("tbody", { role: "rowgroup", children: e.map((n) => {
  const d = r(n);
  return /* @__PURE__ */ t(
    zs,
    {
      row: n,
      columns: a,
      columnWidths: _,
      selectable: o,
      isSelected: l,
      toggleRowSelection: i,
      rowId: r(n)
    },
    d
  );
}) });
var ze = /* @__PURE__ */ ((e) => (e.Ascending = "asc", e.Descending = "desc", e.None = "none", e))(ze || {});
const Vs = "lc-TableHeader-module__header___JDLIB", Ws = "lc-TableHeader-module__header__cell___aYvzx", Ks = "lc-TableHeader-module__header__hiddenIcon___NNtMw", Ys = "lc-TableHeader-module__header__resizer___h-Al0", Xs = "lc-TableHeader-module__header__content___LRMNn", oa = {
  header: Vs,
  header__cell: Ws,
  "header__cell--hoverDisabled": "lc-TableHeader-module__header__cell--hoverDisabled___PaQRH",
  header__hiddenIcon: Ks,
  header__resizer: Ys,
  header__content: Xs,
  "header__select-cell": "lc-TableHeader-module__header__select-cell___H9qHi",
  "header--selectable": "lc-TableHeader-module__header--selectable___yPgDs"
}, ca = "header", Zs = `${ca}__cell`, js = `${ca}__resizer`, Js = `${ca}__content`, Qs = `${ca}__hiddenIcon`;
function ed(e, a, r, _) {
  return e.key === a && e.direction !== ze.None && r ? /* @__PURE__ */ t(
    R,
    {
      source: e.direction === ze.Ascending ? Ol : Ml,
      kind: "primary"
    }
  ) : _ && r ? /* @__PURE__ */ t(R, { source: Pl, kind: "subtle" }) : /* @__PURE__ */ t(R, { source: Fl, className: oa[Qs] });
}
const td = ({
  columns: e,
  sortConfig: a,
  handleSort: r,
  resizable: _,
  handleMouseDown: o,
  columnRefs: l,
  selectable: i,
  hoveredColumnIndex: n,
  setHoveredColumnIndex: d,
  selectedCount: s,
  dataLength: c,
  toggleSelectAll: p
}) => /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ h(
  "tr",
  {
    className: u(oa[ca], {
      [oa[`${ca}--selectable`]]: i && !!s
    }),
    children: [
      i && /* @__PURE__ */ t(
        "th",
        {
          className: oa[`${ca}__select-cell`],
          onClick: p,
          children: /* @__PURE__ */ t(
            Wr,
            {
              checked: s === c,
              indeterminate: s !== void 0 && s > 0 && s < (c || 0)
            }
          )
        }
      ),
      e.map((m, f) => {
        var g;
        return /* @__PURE__ */ t(
          "th",
          {
            ref: (w) => {
              l.current && (l.current[f] = w);
            },
            className: u({
              [oa[`${Zs}--hoverDisabled`]]: !m.sortable
            }),
            onMouseEnter: () => d(f),
            onMouseLeave: () => d(null),
            role: "columnheader",
            children: /* @__PURE__ */ h(
              "span",
              {
                onClick: () => {
                  m.sortable && r(m.key);
                },
                className: oa[Js],
                children: [
                  /* @__PURE__ */ t(D, { size: "sm", bold: !0, noMargin: !0, children: m.header }),
                  ed(
                    a,
                    m.key,
                    (g = m.sortable) != null ? g : !1,
                    n === f
                  ),
                  _ && /* @__PURE__ */ t(
                    "span",
                    {
                      className: oa[js],
                      onMouseDown: (w) => o(f, w),
                      role: "button",
                      "aria-label": "resize"
                    }
                  )
                ]
              }
            )
          },
          String(m.key)
        );
      })
    ]
  }
) }), ad = "lc-Table-module__table___-ZPCW", rd = "lc-Table-module__table__cell___8rtqj", _d = "lc-Table-module__table__selected___f9beX", od = "lc-Table-module__table__selected__divider___VlK4B", ld = "lc-Table-module__table__selected__checkbox___4yJlB", id = "lc-Table-module__table__selected__content___9LKcS", Dt = {
  table: ad,
  "table--small": "lc-Table-module__table--small___DuQa-",
  "table--medium": "lc-Table-module__table--medium___pe9rZ",
  "table--large": "lc-Table-module__table--large___8PMkf",
  "table--pinned_header": "lc-Table-module__table--pinned_header___5SrTn",
  "table--pinned_header--selectable": "lc-Table-module__table--pinned_header--selectable___R5ZXX",
  "table--has-selected": "lc-Table-module__table--has-selected___U7gSR",
  "table--pinned_leftColumn": "lc-Table-module__table--pinned_leftColumn___GWfss",
  table__cell: rd,
  table__selected: _d,
  "table__selected--visible": "lc-Table-module__table__selected--visible___RTjMS",
  "table__selected--hidden": "lc-Table-module__table__selected--hidden___Wu9PE",
  table__selected__divider: od,
  table__selected__checkbox: ld,
  table__selected__content: id,
  "table--stripped_rows": "lc-Table-module__table--stripped_rows___ALUEi",
  "table--stripped_columns": "lc-Table-module__table--stripped_columns___JQlQW"
}, la = "table", Ir = `${la}__selected`, um = ({
  data: e,
  columns: a,
  stripped: r,
  size: _ = "medium",
  pin: o,
  selectable: l,
  getRowId: i,
  resizable: n,
  selectedRows: d,
  onSelectionChange: s,
  rowSelectionMessage: c,
  rowActions: p,
  testId: m
}) => {
  const f = v.useRef([]), [g, w] = v.useState(null), { isSelected: x, toggleRowSelection: S, toggleSelectAll: E, selectedCount: N } = Gs({
    data: e,
    getRowId: i,
    selectedRows: d,
    onSelectionChange: s
  }), [C, $] = v.useState({
    key: null,
    direction: ze.None
  }), [b, k] = v.useState(Array(a.length).fill(void 0)), I = (A, O) => {
    O.preventDefault();
    const G = O.clientX, P = b[A] || O.currentTarget.offsetWidth, L = b[A + 1] || 0, M = 1.05, q = (te) => {
      const Ce = (te.clientX - G) * M;
      k((fe) => {
        const K = [...fe], j = Math.max(50, P + Ce), ut = Math.max(50, L - Ce);
        return K[A] = j, A + 1 < K.length && (K[A + 1] = ut), K;
      });
    }, Y = () => {
      document.removeEventListener("mousemove", q), document.removeEventListener("mouseup", Y);
    };
    document.addEventListener("mousemove", q), document.addEventListener("mouseup", Y);
  }, T = (A) => {
    const O = a.find((G) => G.key === A);
    !O || O.sortable === !1 || $((G) => {
      if (G.key === A) {
        let P;
        switch (G.direction) {
          case ze.None:
            P = ze.Ascending;
            break;
          case ze.Ascending:
            P = ze.Descending;
            break;
          default:
            P = ze.None;
        }
        return {
          key: P === ze.None ? null : A,
          direction: P
        };
      } else
        return { key: A, direction: ze.Ascending };
    });
  }, F = v.useMemo(() => {
    if (!C.key || C.direction === ze.None)
      return e;
    const A = a.find((O) => O.key === C.key);
    return A ? [...e].sort((O, G) => {
      const P = A.sortable ? A.sortValue(O) : O[C.key], L = A.sortable ? A.sortValue(G) : G[C.key];
      return P < L ? C.direction === ze.Ascending ? -1 : 1 : P > L ? C.direction === ze.Ascending ? 1 : -1 : 0;
    }) : e;
  }, [e, C, a]);
  return v.useEffect(() => {
    const A = f.current.map(
      (O) => (O == null ? void 0 : O.offsetWidth) || 0
    );
    k(A);
  }, []), /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: u(Dt[`${Ir}`], {
          [Dt[`${Ir}--visible`]]: l && !!N,
          [Dt[`${Ir}--hidden`]]: !l
        }),
        children: [
          /* @__PURE__ */ t("div", { className: Dt[`${Ir}__content`], children: c || /* @__PURE__ */ h(D, { noMargin: !0, bold: !0, size: "sm", children: [
            N,
            " selected"
          ] }) }),
          /* @__PURE__ */ t("div", { children: p })
        ]
      }
    ),
    /* @__PURE__ */ h(
      "table",
      {
        className: u(
          Dt[`${la}`],
          Dt[`${la}--${_}`],
          Dt[`${la}--pinned_${o}`],
          l && Dt[`${la}--pinned_header--selectable`],
          l && !!N && Dt[`${la}--has-selected`],
          Dt[`${la}--stripped_${r}`]
        ),
        "data-testid": m,
        children: [
          /* @__PURE__ */ t(
            td,
            {
              columns: a,
              sortConfig: C,
              handleSort: T,
              resizable: n,
              handleMouseDown: I,
              columnRefs: f,
              selectable: l,
              hoveredColumnIndex: g,
              setHoveredColumnIndex: w,
              selectedCount: N,
              dataLength: e.length,
              toggleSelectAll: E
            }
          ),
          /* @__PURE__ */ t(
            Hs,
            {
              data: F,
              columns: a,
              getRowId: i,
              columnWidths: b,
              selectable: l,
              isSelected: x,
              toggleRowSelection: S
            }
          )
        ]
      }
    )
  ] });
}, Qa = {
  "tag-input": "lc-TagInput-module__tag-input___zQKuG",
  "tag-input--error": "lc-TagInput-module__tag-input--error___0iuR-",
  "tag-input__input": "lc-TagInput-module__tag-input__input___skuNT",
  "tag-input__input--medium": "lc-TagInput-module__tag-input__input--medium___9ifYO",
  "tag-input__input--large": "lc-TagInput-module__tag-input__input--large___0xBUb",
  "tag-input__tag__content": "lc-TagInput-module__tag-input__tag__content___glcu0"
}, nd = ({
  className: e = "",
  innerEditableRef: a,
  inputRef: r,
  change: _,
  remove: o,
  value: l
}) => {
  const [i, n] = v.useState(!1), d = () => a.current, s = () => {
    const g = d();
    return g ? g.innerText : "";
  }, c = () => {
    r && r.current && r.current.focus();
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ref: a,
      className: e,
      contentEditable: !0,
      onPaste: (g) => {
        g.preventDefault();
        const w = g.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", !1, V_(w));
      },
      onBlur: () => {
        const g = d();
        if (!(i || !g)) {
          if (g.innerText === "") {
            o();
            return;
          }
          _(g.innerText);
        }
      },
      onKeyDown: (g) => {
        if (g.key === ue.enter) {
          g.preventDefault(), c();
          return;
        }
        g.key === ue.backspace && s() === "" && (n(!0), o(), c());
      },
      dangerouslySetInnerHTML: { __html: V_(l) }
    }
  );
}, cd = "tag-input__tag", bo = ({
  children: e,
  index: a,
  remove: r,
  validator: _,
  inputRef: o,
  update: l,
  size: i,
  tagProps: n
}) => {
  const d = v.useMemo(() => _ !== void 0 ? _(e) : !0, [e, _]), s = v.useRef(null), c = () => r(a), p = () => d ? n ? n.kind : "default" : "error";
  return /* @__PURE__ */ t(Wo, B(y({ size: i }, n), { kind: p(), onRemove: c, children: /* @__PURE__ */ t(
    nd,
    {
      value: e,
      inputRef: o,
      innerEditableRef: s,
      className: Qa[`${cd}__content`],
      change: (m) => l(a, m),
      remove: c,
      validator: _
    }
  ) }));
}, Ar = "tag-input", sd = [
  ue.enter,
  ue.spacebar,
  ue.tab,
  ue.semicolon,
  ue.comma
], dd = [ue.backspace, ue.delete], ud = (g) => {
  var w = g, {
    id: e,
    tags: a,
    onChange: r,
    validator: _,
    error: o,
    placeholder: l,
    size: i = "medium",
    className: n,
    inputClassName: d,
    onBlur: s,
    addOnBlur: c = !0,
    readOnly: p,
    noDataFallbackText: m = "No data"
  } = w, f = U(w, [
    "id",
    "tags",
    "onChange",
    "validator",
    "error",
    "placeholder",
    "size",
    "className",
    "inputClassName",
    "onBlur",
    "addOnBlur",
    "readOnly",
    "noDataFallbackText"
  ]);
  const x = u(
    Qa[Ar],
    {
      [Qa[`${Ar}--error`]]: o
    },
    n
  ), S = u(
    d,
    Qa[`${Ar}__input`],
    Qa[`${Ar}__input--${i}`]
  ), [E, N] = v.useState(""), C = v.useRef(null), { readOnly: $ } = Ot(), b = $ || p, k = (M) => {
    M.trim() !== "" && (r([...a || [], M]), N(""));
  }, I = (M) => {
    const q = [...a || []];
    q.splice(M, 1), r(q);
  }, T = (M) => N(M.target.value), F = (M) => {
    if (sd.includes(M.key)) {
      if (M.preventDefault(), E === "")
        return;
      k(E);
    } else if (dd.includes(M.key)) {
      if (E !== "" || !(a != null && a.length))
        return;
      I(a.length - 1);
    }
  }, A = (M) => {
    c && k(E), s == null || s(M);
  }, O = (M, q) => {
    const Y = [...a || []];
    Y.reduce(
      (Ce, fe, K) => Ce + (fe === q && K !== M ? 1 : 0),
      0
    ) > 0 ? Y.splice(M, 1) : Y[M] = q, r(Y);
  }, G = (M) => {
    M.preventDefault();
    const Y = M.clipboardData.getData("text/plain").split(/[\s,;\n]+/);
    r([...a || [], ...Y]);
  }, P = (M) => typeof M == "string" ? M : M.value || (typeof M.children == "string" ? M.children : "");
  if (b)
    return /* @__PURE__ */ t(
      xa,
      {
        value: a == null ? void 0 : a.filter(Boolean).map(P).join(", "),
        noDataFallbackText: m
      }
    );
  const L = (M, q) => typeof M == "string" ? /* @__PURE__ */ t(
    bo,
    {
      index: q,
      update: O,
      remove: I,
      inputRef: C,
      validator: _,
      size: i,
      children: M
    },
    `${q}${M}`
  ) : /* @__PURE__ */ t(
    bo,
    {
      index: q,
      update: O,
      remove: I,
      inputRef: C,
      validator: _,
      size: i,
      tagProps: M,
      children: M.value || M.children
    },
    `${q}${M.children}`
  );
  return /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ h(D, { as: "div", className: x, children: [
      a == null ? void 0 : a.map(L),
      /* @__PURE__ */ t(
        "input",
        B(y({}, f), {
          id: e,
          ref: C,
          className: S,
          placeholder: l,
          value: E,
          onChange: T,
          onKeyDown: F,
          onPaste: G,
          onBlur: A
        })
      )
    ] }),
    o && /* @__PURE__ */ t(P_, { children: o })
  ] });
}, md = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/i, pd = "name@company.com", gd = (e) => md.test(e), mm = (r) => {
  var _ = r, {
    placeholder: e = pd
  } = _, a = U(_, [
    "placeholder"
  ]);
  return /* @__PURE__ */ t(ud, B(y({}, a), { placeholder: e, validator: gd }));
}, hd = "lc-Toast-module__toast___ngbBR", fd = "lc-Toast-module__toast__content___XGt2m", bd = "lc-Toast-module__toast__actions___iFshW", vd = "lc-Toast-module__toast__actions__button___sQIbQ", we = {
  toast: hd,
  toast__content: fd,
  toast__actions: bd,
  toast__actions__button: vd,
  "toast__actions__button--success": "lc-Toast-module__toast__actions__button--success___p53MR",
  "toast__actions__button--warning": "lc-Toast-module__toast__actions__button--warning___fCMO5",
  "toast__actions__button--error": "lc-Toast-module__toast__actions__button--error___hct1w",
  "toast__actions__button--info": "lc-Toast-module__toast__actions__button--info___KLzoG",
  "toast__actions--custom": "lc-Toast-module__toast__actions--custom___Lao00",
  "toast--success": "lc-Toast-module__toast--success___AcCed",
  "toast--warning": "lc-Toast-module__toast--warning___RsGqU",
  "toast--error": "lc-Toast-module__toast--error___a7RTS",
  "toast--info": "lc-Toast-module__toast--info___9t8Za",
  "toast-wrapper": "lc-Toast-module__toast-wrapper___jVb0j",
  "toast-wrapper--fixed": "lc-Toast-module__toast-wrapper--fixed___Wo3QO",
  "toast-wrapper--block": "lc-Toast-module__toast-wrapper--block___LNWD0",
  "toast-wrapper--horizontal-center": "lc-Toast-module__toast-wrapper--horizontal-center___yR1at",
  "toast-wrapper--horizontal-left": "lc-Toast-module__toast-wrapper--horizontal-left___CY-Z-",
  "toast-wrapper--horizontal-right": "lc-Toast-module__toast-wrapper--horizontal-right___f7ts5",
  "toast-wrapper--vertical-top": "lc-Toast-module__toast-wrapper--vertical-top___-8YHw",
  "toast-appear--slide": "lc-Toast-module__toast-appear--slide___vNvCV",
  "toast-appear-active--slide": "lc-Toast-module__toast-appear-active--slide___ROIEb",
  "toast-exit--slide": "lc-Toast-module__toast-exit--slide___DVOQp",
  "toast-exit-active--slide": "lc-Toast-module__toast-exit-active--slide___rBWPS",
  "toast-wrapper--vertical-bottom": "lc-Toast-module__toast-wrapper--vertical-bottom___rihzw",
  "toast-appear--fade": "lc-Toast-module__toast-appear--fade___AcODR",
  "toast-appear-active--fade": "lc-Toast-module__toast-appear-active--fade___Z39eu",
  "toast-exit--fade": "lc-Toast-module__toast-exit--fade___1t0Qp",
  "toast-exit-active--fade": "lc-Toast-module__toast-exit-active--fade___UK5Kw"
}, yd = {
  success: {
    source: T_
  },
  warning: {
    source: Co
  },
  error: {
    source: $o
  },
  info: {
    source: Mr
  }
}, Jt = "toast", kd = (n) => {
  var d = n, {
    action: e,
    className: a,
    children: r,
    removable: _,
    kind: o = "info",
    onClose: l
  } = d, i = U(d, [
    "action",
    "className",
    "children",
    "removable",
    "kind",
    "onClose"
  ]);
  const s = u(
    we[Jt],
    we[`${Jt}--${o}`],
    a
  ), c = typeof r == "string", p = (m) => m && m.closesOnClick && l ? (m.onClick(), l()) : m.onClick();
  return /* @__PURE__ */ h("div", B(y({ className: s }, i), { children: [
    /* @__PURE__ */ t("div", { className: we[`${Jt}__icon`], children: /* @__PURE__ */ t(R, B(y({}, yd[o]), { size: "medium" })) }),
    /* @__PURE__ */ t("div", { className: we[`${Jt}__content`], children: c ? /* @__PURE__ */ t(D, { as: "div", children: r }) : r }),
    (e || _) && /* @__PURE__ */ h("div", { className: we[`${Jt}__actions`], children: [
      e && /* @__PURE__ */ t(
        H,
        {
          className: we[`${Jt}__actions--custom`],
          kind: "text",
          size: "compact",
          onClick: () => p(e),
          children: e.label
        }
      ),
      _ && /* @__PURE__ */ t(
        "button",
        {
          className: u(
            we[`${Jt}__actions__button`],
            we[`${Jt}__actions__button--${o}`]
          ),
          "aria-label": "Close toast",
          onClick: l,
          children: /* @__PURE__ */ t(R, { source: dt, size: "medium" })
        }
      )
    ] })
  ] }));
}, wd = 200, ja = "toast-wrapper", pm = ({
  className: e,
  toasts: a = [],
  fixed: r = !0,
  block: _ = !1,
  animationType: o = "slide",
  verticalPosition: l = "top",
  horizontalPosition: i = "center"
}) => {
  const n = u(
    we[ja],
    {
      [we[`${ja}--fixed`]]: r,
      [we[`${ja}--block`]]: !r && _,
      [we[`${ja}--horizontal-${i}`]]: i,
      [we[`${ja}--vertical-${l}`]]: l
    },
    e
  );
  return /* @__PURE__ */ t("div", { className: n, children: /* @__PURE__ */ t(Bo, { component: null, children: a.map(({ id: d, kind: s, content: c, removable: p, action: m, onClose: f }) => /* @__PURE__ */ t(
    Io,
    {
      classNames: {
        enter: we[`toast-appear--${o}`],
        enterActive: we[`toast-appear-active--${o}`],
        exit: we[`toast-exit--${o}`],
        exitActive: we[`toast-exit-active--${o}`]
      },
      timeout: wd,
      children: /* @__PURE__ */ t(
        kd,
        {
          kind: s,
          onClose: f,
          removable: p,
          action: m,
          children: c
        }
      )
    },
    d
  )) }) });
}, Cd = "lc-Textarea-module__textarea___yE6jp", Dr = {
  textarea: Cd,
  "textarea--focused": "lc-Textarea-module__textarea--focused___YnB5S",
  "textarea--disabled": "lc-Textarea-module__textarea--disabled___zZJAq",
  "textarea--error": "lc-Textarea-module__textarea--error___n-fD5"
}, Or = "textarea", gm = v.forwardRef(
  (l, o) => {
    var i = l, { className: e, noDataFallbackText: a = "No data", error: r } = i, _ = U(i, ["className", "noDataFallbackText", "error"]);
    var S;
    const { disabled: n, onBlur: d, onFocus: s } = _, { readOnly: c } = Ot(), p = c || _.readOnly, [m, f] = v.useState(!1), g = u(e, Dr[Or], {
      [Dr[`${Or}--disabled`]]: n,
      [Dr[`${Or}--focused`]]: m,
      [Dr[`${Or}--error`]]: r
    }), w = (E) => {
      f(!1), d == null || d(E);
    }, x = (E) => {
      f(!0), s == null || s(E);
    };
    return p ? /* @__PURE__ */ t(
      xa,
      {
        value: (S = _ == null ? void 0 : _.value) == null ? void 0 : S.toString(),
        noDataFallbackText: a
      }
    ) : /* @__PURE__ */ t(D, { as: "div", className: g, children: /* @__PURE__ */ t(
      "textarea",
      B(y({}, _), {
        ref: o,
        onFocus: x,
        onBlur: w
      })
    ) });
  }
), $d = {
  "update-badge": "lc-UpdateBadge-module__update-badge___heZyU"
}, Nd = "update-badge", hm = () => /* @__PURE__ */ t("span", { className: $d[Nd] }), Sd = "data:image/svg+xml,%3csvg%20width='40'%20height='43'%20viewBox='0%200%2040%2043'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d_2511_27812)'%3e%3cpath%20d='M12.1399%2028.6143L20.0002%2010.6475L27.8604%2028.6143L20.0002%2025.3255L12.1399%2028.6143Z'%20fill='%23050505'/%3e%3cpath%20d='M20.9164%2010.2467C20.7572%209.88266%2020.3976%209.64746%2020.0002%209.64746C19.6029%209.64746%2019.2433%209.88266%2019.0841%2010.2466L11.2237%2028.2134C11.0599%2028.5879%2011.1404%2029.0243%2011.4271%2029.3156C11.7138%2029.607%2012.1488%2029.6945%2012.5259%2029.5368L20.0002%2026.4095L27.4744%2029.5368C27.8514%2029.6945%2028.2865%2029.607%2028.5731%2029.3156C28.8598%2029.0243%2028.9403%2028.5879%2028.7765%2028.2135L20.9164%2010.2467Z'%20stroke='url(%23paint0_linear_2511_27812)'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_2511_27812'%20x='0.139893'%20y='0.647461'%20width='39.7205'%20height='41.9668'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='2'/%3e%3cfeGaussianBlur%20stdDeviation='5'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_2511_27812'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_2511_27812'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_2511_27812'%20x1='19'%20y1='37'%20x2='19.9864'%20y2='9.0268'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.318907'%20stop-color='%23CE97FE'/%3e%3cstop%20offset='0.456699'%20stop-color='%237000FF'/%3e%3cstop%20offset='0.690444'%20stop-color='%2300B3FF'/%3e%3cstop%20offset='0.955729'%20stop-color='white'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
class xd {
  constructor(a, r) {
    a_(this, "element");
    a_(this, "padding");
    this.element = a, this.padding = r;
  }
  addPadding(a) {
    const r = Math.ceil(a.left) - this.padding, _ = Math.ceil(a.top) - this.padding, o = Math.ceil(a.width) + 2 * this.padding, l = Math.ceil(a.height) + 2 * this.padding, i = _, n = r, d = i + l, s = n + o;
    return {
      x: r,
      y: _,
      width: o,
      height: l,
      top: i,
      left: n,
      bottom: d,
      right: s
    };
  }
  getBoundingClientRect() {
    return this.addPadding(this.element.getBoundingClientRect());
  }
  get clientWidth() {
    return this.getBoundingClientRect().width;
  }
  get clientHeight() {
    return this.getBoundingClientRect().height;
  }
}
const ft = {
  "user-guide__overlay": "lc-UserGuide-module__user-guide__overlay___xc8t9",
  "fade-in": "lc-UserGuide-module__fade-in___KEPPX",
  "user-guide__overlay__content": "lc-UserGuide-module__user-guide__overlay__content___Yu-6p",
  "user-guide__floating": "lc-UserGuide-module__user-guide__floating___RgxA2",
  "user-guide__floating--fast1": "lc-UserGuide-module__user-guide__floating--fast1___atd8C",
  "user-guide__floating--fast2": "lc-UserGuide-module__user-guide__floating--fast2___9zmT1",
  "user-guide__floating--moderate1": "lc-UserGuide-module__user-guide__floating--moderate1___4ZyOo",
  "user-guide__floating--moderate2": "lc-UserGuide-module__user-guide__floating--moderate2___-21Qx",
  "user-guide__guide": "lc-UserGuide-module__user-guide__guide___jCOMd",
  "user-guide__guide--right-start": "lc-UserGuide-module__user-guide__guide--right-start___dL15C",
  "user-guide__guide--left-start": "lc-UserGuide-module__user-guide__guide--left-start___d0zgg",
  "user-guide__guide--right": "lc-UserGuide-module__user-guide__guide--right___l-xa1",
  "user-guide__guide--left": "lc-UserGuide-module__user-guide__guide--left___b37DE",
  "user-guide__guide--right-end": "lc-UserGuide-module__user-guide__guide--right-end___ZrcKz",
  "user-guide__guide--left-end": "lc-UserGuide-module__user-guide__guide--left-end___P2R4X",
  "user-guide__guide--bottom-start": "lc-UserGuide-module__user-guide__guide--bottom-start___2nDLB",
  "user-guide__guide--top-start": "lc-UserGuide-module__user-guide__guide--top-start___dVZk-",
  "user-guide__guide--bottom": "lc-UserGuide-module__user-guide__guide--bottom___xKUf7",
  "user-guide__guide--top": "lc-UserGuide-module__user-guide__guide--top___VyXt3",
  "user-guide__guide--bottom-end": "lc-UserGuide-module__user-guide__guide--bottom-end___Sb3iU",
  "user-guide__guide--top-end": "lc-UserGuide-module__user-guide__guide--top-end___8BFCP",
  "user-guide__guide__arrow": "lc-UserGuide-module__user-guide__guide__arrow___Q5eJf",
  "user-guide__guide__arrow--fast1": "lc-UserGuide-module__user-guide__guide__arrow--fast1___p2D2X",
  "user-guide__guide__arrow--fast2": "lc-UserGuide-module__user-guide__guide__arrow--fast2___0uHUD",
  "user-guide__guide__arrow--moderate1": "lc-UserGuide-module__user-guide__guide__arrow--moderate1___5HE6Z",
  "user-guide__guide__arrow--moderate2": "lc-UserGuide-module__user-guide__guide__arrow--moderate2___jc9X8",
  "user-guide__guide__arrow--right-start": "lc-UserGuide-module__user-guide__guide__arrow--right-start___-uKZa",
  "user-guide__guide__arrow--right": "lc-UserGuide-module__user-guide__guide__arrow--right___gk-Jy",
  "user-guide__guide__arrow--right-end": "lc-UserGuide-module__user-guide__guide__arrow--right-end___FivLG",
  "user-guide__guide__arrow--bottom-start": "lc-UserGuide-module__user-guide__guide__arrow--bottom-start___RgKv9",
  "user-guide__guide__arrow--bottom": "lc-UserGuide-module__user-guide__guide__arrow--bottom___biAvs",
  "user-guide__guide__arrow--bottom-end": "lc-UserGuide-module__user-guide__guide__arrow--bottom-end___-UTZt",
  "user-guide__guide__arrow--top-start": "lc-UserGuide-module__user-guide__guide__arrow--top-start___suNzB",
  "user-guide__guide__arrow--top": "lc-UserGuide-module__user-guide__guide__arrow--top___2Jhvm",
  "user-guide__guide__arrow--top-end": "lc-UserGuide-module__user-guide__guide__arrow--top-end___flgo3",
  "user-guide__guide__arrow--left-start": "lc-UserGuide-module__user-guide__guide__arrow--left-start___wsidk",
  "user-guide__guide__arrow--left": "lc-UserGuide-module__user-guide__guide__arrow--left___44rSO",
  "user-guide__guide__arrow--left-end": "lc-UserGuide-module__user-guide__guide__arrow--left-end___SkNP2",
  "user-guide__guide__content": "lc-UserGuide-module__user-guide__guide__content___zlQji",
  "user-guide__guide__content--right-start": "lc-UserGuide-module__user-guide__guide__content--right-start___O1mf7",
  "fade-in-right-start": "lc-UserGuide-module__fade-in-right-start___n3frf",
  "user-guide__guide__content--right": "lc-UserGuide-module__user-guide__guide__content--right___G8NhS",
  "fade-in-right": "lc-UserGuide-module__fade-in-right___BBHBW",
  "user-guide__guide__content--right-end": "lc-UserGuide-module__user-guide__guide__content--right-end___1SSSy",
  "fade-in-right-end": "lc-UserGuide-module__fade-in-right-end___ETdwQ",
  "user-guide__guide__content--left-start": "lc-UserGuide-module__user-guide__guide__content--left-start___oCXn1",
  "fade-in-left-start": "lc-UserGuide-module__fade-in-left-start___8ggIA",
  "user-guide__guide__content--left": "lc-UserGuide-module__user-guide__guide__content--left___fgI-F",
  "fade-in-left": "lc-UserGuide-module__fade-in-left___hg0J0",
  "user-guide__guide__content--left-end": "lc-UserGuide-module__user-guide__guide__content--left-end___bR-YA",
  "fade-in-left-end": "lc-UserGuide-module__fade-in-left-end___Ui4wF",
  "user-guide__guide__content--top-start": "lc-UserGuide-module__user-guide__guide__content--top-start___zEKyj",
  "fade-in-top-start": "lc-UserGuide-module__fade-in-top-start___Ha6DR",
  "user-guide__guide__content--top": "lc-UserGuide-module__user-guide__guide__content--top___IsroR",
  "fade-in-top": "lc-UserGuide-module__fade-in-top___rYKUp",
  "user-guide__guide__content--top-end": "lc-UserGuide-module__user-guide__guide__content--top-end___dsuZm",
  "fade-in-top-end": "lc-UserGuide-module__fade-in-top-end___n2H6-",
  "user-guide__guide__content--bottom-start": "lc-UserGuide-module__user-guide__guide__content--bottom-start___o7-Uf",
  "fade-in-bottom-start": "lc-UserGuide-module__fade-in-bottom-start___tPQd1",
  "user-guide__guide__content--bottom": "lc-UserGuide-module__user-guide__guide__content--bottom___2gxXf",
  "fade-in-bottom": "lc-UserGuide-module__fade-in-bottom___2nyvW",
  "user-guide__guide__content--bottom-end": "lc-UserGuide-module__user-guide__guide__content--bottom-end___nT-g2",
  "fade-in-bottom-end": "lc-UserGuide-module__fade-in-bottom-end___89qmL",
  "user-guide__cursor": "lc-UserGuide-module__user-guide__cursor___9IuMJ",
  "user-guide__cursor--bottom": "lc-UserGuide-module__user-guide__cursor--bottom___jYXJ1",
  "user-guide__cursor--left": "lc-UserGuide-module__user-guide__cursor--left___h0ToJ",
  "user-guide__cursor--right": "lc-UserGuide-module__user-guide__cursor--right___Wc-yj"
}, bt = "user-guide", vo = (e, a = 0) => new xd(e, a), fm = ({
  className: e,
  children: a,
  cursorPosition: r = "bottom-start",
  cursorTiming: _ = "fast2",
  parentElementName: o,
  isVisible: l = !1,
  elementClassName: i,
  zIndex: n,
  isFirstStep: d,
  isLastStep: s
}) => {
  const [c, p] = de(null), [m, f] = de(null), g = Xt(null), w = Xt(null), x = d || s ? "bottom-start" : r, { refs: S, x: E, y: N, strategy: C, placement: $, update: b } = ri({
    middleware: [_i(), oi()],
    placement: x,
    open: !0,
    whileElementsMounted: li
  }), k = () => {
    c && f(
      vo(c).getBoundingClientRect()
    );
  };
  V(() => {
    if (c !== null)
      return window.addEventListener("resize", k), window.addEventListener("scroll", k), () => {
        window.removeEventListener("resize", k), window.removeEventListener("scroll", k);
      };
  }, [c]), V(() => (window.addEventListener("resize", b), () => window.removeEventListener("resize", b)), [b]), V(() => {
    if (o) {
      const T = document.querySelector(o);
      p(T), S.setReference(T);
    }
  }, [o]), V(() => {
    c && f(
      vo(c).getBoundingClientRect()
    );
  }, [c]), V(() => {
    if (c && g.current) {
      g.current.innerHTML = "";
      const T = c.cloneNode(!0);
      i && (T.className += ` ${i}`), g.current.appendChild(T);
    }
    return () => {
      g.current && (g.current.innerHTML = "");
    };
  }, [c, g.current, i]), V(() => (l ? document.body.classList.add("user-guide-visible") : document.body.classList.remove("user-guide-visible"), () => {
    document.body.classList.remove("user-guide-visible");
  }), [l]);
  const I = () => m ? /* @__PURE__ */ t(
    "div",
    {
      ref: g,
      style: {
        position: "absolute",
        top: m.top,
        left: m.left,
        width: m.width,
        height: m.height,
        pointerEvents: "none"
      }
    }
  ) : null;
  return /* @__PURE__ */ h(Z, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(ft[`${bt}__overlay`]),
        style: {
          display: l ? "flex" : "none",
          zIndex: n
        },
        children: c && I()
      }
    ),
    l && /* @__PURE__ */ t($a, { children: /* @__PURE__ */ t(
      "div",
      {
        ref: S.setFloating,
        style: {
          position: C,
          top: d || s ? "40%" : N,
          left: d || s ? "calc(50% - 211px)" : E
        },
        className: u(
          ft[`${bt}__floating`],
          ft[`${bt}__floating--${_}`],
          e
        ),
        children: /* @__PURE__ */ h(
          "div",
          {
            ref: w,
            className: u(
              ft[`${bt}__guide`],
              ft[`${bt}__guide--${$}`]
            ),
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: u(
                    ft[`${bt}__guide__arrow`],
                    ft[`${bt}__guide__arrow--${$}`],
                    ft[`${bt}__guide__arrow--${_}`]
                  ),
                  children: /* @__PURE__ */ t("img", { src: Sd, alt: "cursor" })
                }
              ),
              a && /* @__PURE__ */ t(
                "div",
                {
                  className: u(
                    ft[`${bt}__guide__content`],
                    ft[`${bt}__guide__content--${$}`],
                    ft[`${bt}__guide__content--${_}`]
                  ),
                  children: a
                },
                o
              )
            ]
          }
        )
      }
    ) })
  ] });
}, Be = {
  "user-guide-bubble-step": "lc-UserGuideBubbleStep-module__user-guide-bubble-step___85b6K",
  "user-guide-bubble-step__bubble-wrapper": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper___CsEDk",
  "user-guide-bubble-step__bubble-wrapper--completed": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper--completed___Ed8ua",
  "shadow-glow": "lc-UserGuideBubbleStep-module__shadow-glow___uMRE-",
  "user-guide-bubble-step__bubble": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble___CoHl4",
  "fade-in": "lc-UserGuideBubbleStep-module__fade-in___Pjz6d",
  "user-guide-bubble-step__bubble--next-msg": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--next-msg___bzw2-",
  "user-guide-bubble-step__bubble--header": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--header___frxyc",
  "user-guide-bubble-step__bubble--message": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--message___dCGqv",
  "user-guide-bubble-step__bubble--cta": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--cta___NcXxo"
}, Ie = "user-guide-bubble-step", bm = ({
  headerMessage: e,
  message: a,
  cta: r,
  isCompleted: _,
  handleAnimationComplete: o,
  disableTypingAnimations: l,
  typingDelay: i,
  typingSpeed: n,
  className: d
}) => {
  const [s, c] = de(["header"]), p = s.includes("header"), m = s.includes("message"), f = r && s.includes("cta");
  return V(() => {
    s.length === 3 && o && o();
  }, [s]), /* @__PURE__ */ h("div", { className: u("lc-light-theme", Be[`${Ie}`], d), children: [
    p && /* @__PURE__ */ t(
      "div",
      {
        className: u(Be[`${Ie}__bubble-wrapper`], {
          [Be[`${Ie}__bubble-wrapper--completed`]]: _
        }),
        children: /* @__PURE__ */ h(
          "div",
          {
            className: u(
              Be[`${Ie}__bubble`],
              Be[`${Ie}__bubble--header`],
              {
                [Be[`${Ie}__bubble--next-msg`]]: m
              }
            ),
            children: [
              /* @__PURE__ */ t("div", { className: Be[`${Ie}__bubble__icon`], children: /* @__PURE__ */ t(R, { size: "large", source: So }) }),
              /* @__PURE__ */ t(D, { as: "span", children: /* @__PURE__ */ t(
                S_,
                {
                  text: e,
                  typingAnimation: !l,
                  typingDelay: i,
                  typingSpeed: n,
                  onTypingEnd: () => c([...s, "message"])
                }
              ) })
            ]
          }
        )
      }
    ),
    m && /* @__PURE__ */ t(
      "div",
      {
        className: u(Be[`${Ie}__bubble-wrapper`], {
          [Be[`${Ie}__bubble-wrapper--completed`]]: _
        }),
        children: /* @__PURE__ */ t(
          "div",
          {
            className: u(
              Be[`${Ie}__bubble`],
              Be[`${Ie}__bubble--message`],
              {
                [Be[`${Ie}__bubble--next-msg`]]: f
              }
            ),
            children: /* @__PURE__ */ t(D, { as: "span", children: /* @__PURE__ */ t(
              S_,
              {
                text: a,
                typingAnimation: !l,
                typingSpeed: n,
                typingDelay: 0,
                onTypingEnd: () => c([...s, "cta"])
              }
            ) })
          }
        )
      }
    ),
    f && /* @__PURE__ */ t(
      "div",
      {
        className: u(Be[`${Ie}__bubble-wrapper`], {
          [Be[`${Ie}__bubble-wrapper--completed`]]: _
        }),
        children: /* @__PURE__ */ t(
          "div",
          {
            className: u(
              Be[`${Ie}__bubble`],
              Be[`${Ie}__bubble--cta`]
            ),
            children: r
          }
        )
      }
    )
  ] });
}, ot = {
  "user-guide-step": "lc-UserGuideStep-module__user-guide-step___WxRx-",
  "user-guide-step__heading": "lc-UserGuideStep-module__user-guide-step__heading___TmHOq",
  "user-guide-step__content": "lc-UserGuideStep-module__user-guide-step__content___1hIeo",
  "user-guide-step__media-wrapper": "lc-UserGuideStep-module__user-guide-step__media-wrapper___RF2FB",
  "user-guide-step__media": "lc-UserGuideStep-module__user-guide-step__media___GyJrq",
  "user-guide-step__footer": "lc-UserGuideStep-module__user-guide-step__footer___jhJ3K",
  "fade-in": "lc-UserGuideStep-module__fade-in___3sI4D",
  "user-guide-step__footer__step-counter": "lc-UserGuideStep-module__user-guide-step__footer__step-counter___GWY-W",
  "user-guide-step__footer__step-counter__current-step": "lc-UserGuideStep-module__user-guide-step__footer__step-counter__current-step___EfyHm",
  "user-guide-step__footer__button-primary": "lc-UserGuideStep-module__user-guide-step__footer__button-primary___1PHEv",
  "user-guide-step__footer__button-close": "lc-UserGuideStep-module__user-guide-step__footer__button-close___ShrtZ"
}, lt = "user-guide-step", vm = ({
  header: e,
  text: a,
  image: r,
  video: _,
  currentStep: o,
  stepMax: l,
  typingAnimation: i = !1,
  typingDelay: n,
  typingSpeed: d,
  handleCloseAction: s,
  handleClickPrimary: c,
  className: p
}) => {
  const [m, f] = de(!1);
  return V(() => {
    if (s)
      return document.addEventListener("keydown", s), () => {
        document.removeEventListener("keydown", s);
      };
  }, [s]), /* @__PURE__ */ h("div", { className: u("lc-light-theme", ot[`${lt}`], p), children: [
    /* @__PURE__ */ h("span", { className: ot[`${lt}__heading`], children: [
      /* @__PURE__ */ t(R, { size: "large", source: So }),
      /* @__PURE__ */ t(D, { size: "lg", bold: !0, as: "span", children: e })
    ] }),
    r && /* @__PURE__ */ t("div", { className: ot[`${lt}__media-wrapper`], children: /* @__PURE__ */ t(
      "img",
      {
        className: ot[`${lt}__media`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    _ && !r && /* @__PURE__ */ t("div", { className: ot[`${lt}__media-wrapper`], children: /* @__PURE__ */ t(
      "video",
      {
        className: ot[`${lt}__media`],
        "data-testid": "user-guide-step-video",
        src: _.src,
        playsInline: _.playsInline,
        autoPlay: _.autoPlay,
        muted: _.muted,
        loop: _.loop,
        controls: _.controls
      }
    ) }),
    /* @__PURE__ */ t(
      D,
      {
        id: "user-guide-step-typed-text",
        as: "span",
        className: ot[`${lt}__content`],
        children: /* @__PURE__ */ t(
          S_,
          {
            text: a,
            typingAnimation: i,
            typingDelay: n,
            typingSpeed: d,
            onTypingEnd: () => f(!0)
          }
        )
      }
    ),
    m && /* @__PURE__ */ h("div", { className: ot[`${lt}__footer`], children: [
      /* @__PURE__ */ t(
        H,
        {
          kind: "high-contrast",
          size: "large",
          onClick: c,
          className: ot[`${lt}__footer__button-primary`],
          children: o === l ? "Finish" : "Next"
        }
      ),
      /* @__PURE__ */ h("span", { children: [
        s && /* @__PURE__ */ t(
          H,
          {
            kind: "plain",
            size: "large",
            onClick: s,
            className: ot[`${lt}__footer__button-close`],
            children: "Skip all"
          }
        ),
        /* @__PURE__ */ h(
          D,
          {
            as: "span",
            className: ot[`${lt}__footer__step-counter`],
            children: [
              /* @__PURE__ */ t(
                "span",
                {
                  className: ot[`${lt}__footer__step-counter__current-step`],
                  children: o
                }
              ),
              " ",
              "/ ",
              l,
              " steps"
            ]
          }
        )
      ] })
    ] })
  ] });
}, b_ = {
  "file-upload-progress-actions": "lc-FileUploadProgressActions-module__file-upload-progress-actions___XINkF",
  "file-upload-progress-actions__close-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__close-button___BHRcO",
  "file-upload-progress-actions__retry-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__retry-button___2Xd72"
}, v_ = "file-upload-progress-actions", E_ = ({ status: e, onCloseButtonClick: a, onRetryButtonClick: r }) => /* @__PURE__ */ h("div", { className: b_[`${v_}`], children: [
  r && e === "error" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: b_[`${v_}__retry-button`],
      "aria-label": "Retry",
      onClick: r,
      children: /* @__PURE__ */ t(R, { size: "small", source: Rl })
    }
  ),
  a && e !== "success" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: b_[`${v_}__close-button`],
      "aria-label": "Close",
      onClick: a,
      children: /* @__PURE__ */ t(R, { size: "small", source: dt })
    }
  )
] }), vt = {
  "file-upload-progress": "lc-FileUploadProgress-module__file-upload-progress___cAUbT",
  "file-upload-progress__icon": "lc-FileUploadProgress-module__file-upload-progress__icon___ZCOg9",
  "file-upload-progress__icon--success": "lc-FileUploadProgress-module__file-upload-progress__icon--success___mQkAS",
  "file-upload-progress__wrapper": "lc-FileUploadProgress-module__file-upload-progress__wrapper___Hrlp6",
  "file-upload-progress__wrapper--with-icon": "lc-FileUploadProgress-module__file-upload-progress__wrapper--with-icon___t56aA",
  "file-upload-progress__wrapper__header": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header___DKuHl",
  "file-upload-progress__wrapper__header__actions": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__actions___AM74G",
  "file-upload-progress__wrapper__header__title": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title___EYxE3",
  "file-upload-progress__wrapper__header__title--success": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--success___P0XSe",
  "file-upload-progress__wrapper__header__title--error": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--error___la8oa"
}, Vt = "file-upload-progress", y_ = `${Vt}__wrapper__header__title`, Ed = v.forwardRef(
  ({
    actionsVisibility: e = "hidden",
    className: a,
    icon: r,
    title: _,
    progressValue: o,
    size: l,
    status: i = "normal",
    onCloseButtonClick: n,
    onRetryButtonClick: d
  }, s) => /* @__PURE__ */ h("div", { className: vt[Vt], ref: s, children: [
    r && i !== "success" && /* @__PURE__ */ t("div", { className: vt[`${Vt}__icon`], children: r }),
    i === "success" && /* @__PURE__ */ t(
      "div",
      {
        className: u(
          vt[`${Vt}__icon`],
          vt[`${Vt}__icon--success`]
        ),
        children: /* @__PURE__ */ t(R, { source: Na })
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(vt[`${Vt}__wrapper`], {
          [vt[`${Vt}__wrapper--with-icon`]]: r
        }),
        children: [
          /* @__PURE__ */ h("div", { className: vt[`${Vt}__wrapper__header`], children: [
            _ && /* @__PURE__ */ t(
              "div",
              {
                className: u(vt[y_], {
                  [vt[`${y_}--success`]]: i === "success",
                  [vt[`${y_}--error`]]: i === "error"
                }),
                children: /* @__PURE__ */ t(D, { size: "sm", as: "div", children: _ })
              }
            ),
            e !== "hidden" && /* @__PURE__ */ t(
              "div",
              {
                className: u({
                  [vt[`${Vt}__wrapper__header__actions`]]: e === "hover"
                }),
                children: /* @__PURE__ */ t(
                  E_,
                  {
                    status: i,
                    onCloseButtonClick: n,
                    onRetryButtonClick: d
                  }
                )
              }
            )
          ] }),
          i !== "success" && /* @__PURE__ */ t(
            hs,
            {
              className: a,
              percent: o,
              status: i,
              size: l
            }
          )
        ]
      }
    )
  ] })
), ee = {
  "upload-bar": "lc-UploadBar-module__upload-bar___0ZOP3",
  "upload-bar__loader-test": "lc-UploadBar-module__upload-bar__loader-test___4QKID",
  "upload-bar--error": "lc-UploadBar-module__upload-bar--error___83It3",
  "upload-bar__wrapper": "lc-UploadBar-module__upload-bar__wrapper___vk3pI",
  "upload-bar__wrapper__header": "lc-UploadBar-module__upload-bar__wrapper__header___3z6fH",
  "upload-bar__wrapper__header__icon": "lc-UploadBar-module__upload-bar__wrapper__header__icon___97HQo",
  "upload-bar__wrapper__header__title": "lc-UploadBar-module__upload-bar__wrapper__header__title___CqykW",
  "upload-bar__wrapper__header__collapse-button": "lc-UploadBar-module__upload-bar__wrapper__header__collapse-button___9n0O7",
  "upload-bar__wrapper__header__actions-container": "lc-UploadBar-module__upload-bar__wrapper__header__actions-container___80EgZ",
  "upload-bar__wrapper__header__success-icon": "lc-UploadBar-module__upload-bar__wrapper__header__success-icon___eau3A",
  "upload-bar__wrapper__header__error-icon": "lc-UploadBar-module__upload-bar__wrapper__header__error-icon___VZLl2",
  "upload-bar__wrapper__header__loader": "lc-UploadBar-module__upload-bar__wrapper__header__loader___h0F6t",
  "upload-bar__files": "lc-UploadBar-module__upload-bar__files___jMFT-",
  "upload-bar__files--enter": "lc-UploadBar-module__upload-bar__files--enter___BNcoJ",
  "upload-bar__files--enter-active": "lc-UploadBar-module__upload-bar__files--enter-active___yj9Mq",
  "upload-bar__files--exit": "lc-UploadBar-module__upload-bar__files--exit___iEuiQ",
  "upload-bar__files--exit-active": "lc-UploadBar-module__upload-bar__files--exit-active___mz8u3",
  "upload-bar__files--exit-done": "lc-UploadBar-module__upload-bar__files--exit-done___-N5nJ",
  "upload-bar__files-wrapper": "lc-UploadBar-module__upload-bar__files-wrapper___C3au9",
  "upload-bar__files__list": "lc-UploadBar-module__upload-bar__files__list___95G7b"
}, qe = "upload-bar", Yt = `${qe}__wrapper__header`, Td = 300, Bd = (e, a) => e === "success" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "success-icon",
    className: ee[`${Yt}__success-icon`],
    children: /* @__PURE__ */ t(R, { source: Na })
  }
) : e === "error" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "error-icon",
    className: ee[`${Yt}__error-icon`],
    children: /* @__PURE__ */ t(R, { source: No })
  }
) : /* @__PURE__ */ t(
  gs,
  {
    className: ee[`${Yt}__loader`],
    status: e,
    progressValue: a
  }
), ym = ({
  children: e,
  className: a,
  progressValue: r,
  title: _,
  isExpanded: o,
  errorMessage: l,
  status: i = "normal",
  icon: n,
  size: d,
  mode: s = "multiple",
  onCloseButtonClick: c,
  onRetryButtonClick: p
}) => {
  const [m, f] = v.useState(o || !1), g = i === "error", w = i === "success", x = u(ee[qe], a, {
    [ee[`${qe}--error`]]: g,
    [ee[`${qe}--success`]]: w
  }), S = !(g && (p || c)), E = () => f(!m);
  return s === "single" ? /* @__PURE__ */ t("div", { className: x, children: /* @__PURE__ */ h("div", { className: ee[`${qe}__wrapper`], children: [
    /* @__PURE__ */ t("div", { className: ee[`${Yt}`], children: /* @__PURE__ */ t(
      Ed,
      {
        title: g && l || _,
        progressValue: r,
        status: i,
        icon: n,
        size: d
      }
    ) }),
    i === "error" && /* @__PURE__ */ t(
      E_,
      {
        status: i,
        onCloseButtonClick: c,
        onRetryButtonClick: p
      }
    )
  ] }) }) : /* @__PURE__ */ h("div", { className: x, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: ee[`${qe}__wrapper`],
        onClick: E,
        children: /* @__PURE__ */ h("div", { className: ee[`${Yt}`], children: [
          /* @__PURE__ */ t("div", { className: ee[`${Yt}__icon`], children: Bd(i, r) }),
          /* @__PURE__ */ t("div", { className: ee[`${Yt}__title`], children: /* @__PURE__ */ t(D, { size: "sm", as: "div", children: g ? l : _ }) }),
          S && /* @__PURE__ */ t(
            "button",
            {
              className: ee[`${Yt}__collapse-button`],
              type: "button",
              "aria-label": "Collapse button",
              onClick: E,
              children: m ? /* @__PURE__ */ t(R, { source: or }) : /* @__PURE__ */ t(R, { source: ta })
            }
          ),
          i === "error" && /* @__PURE__ */ t("div", { className: ee[`${Yt}__actions-container`], children: /* @__PURE__ */ t(
            E_,
            {
              status: i,
              onCloseButtonClick: c,
              onRetryButtonClick: p
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ t(Bo, { component: null, children: m && /* @__PURE__ */ t(
      Io,
      {
        timeout: Td,
        classNames: {
          enter: ee[`${qe}__files--enter`],
          enterActive: ee[`${qe}__files--enter-active`],
          exit: ee[`${qe}__files--exit`],
          exitActive: ee[`${qe}__files--exit-active`],
          exitDone: ee[`${qe}__files--exit-done`]
        },
        children: /* @__PURE__ */ t("div", { className: ee[`${qe}__files`], children: /* @__PURE__ */ t("div", { className: ee[`${qe}__files-wrapper`], children: /* @__PURE__ */ t("div", { className: ee[`${qe}__files__list`], children: e }) }) })
      }
    ) })
  ] });
}, km = ({
  children: e,
  id: a,
  root: r,
  preserveTabOrder: _
}) => /* @__PURE__ */ t($a, { id: a, root: r, preserveTabOrder: _, children: e }), Id = "lc-Stepper-module__stepper__counter___K59ri", Ad = "lc-Stepper-module__stepper__steps__container___sYhuT", Dd = "lc-Stepper-module__stepper__step___mCyT-", ya = {
  stepper__counter: Id,
  stepper__steps__container: Ad,
  stepper__step: Dd,
  "stepper__step--completed": "lc-Stepper-module__stepper__step--completed___unE6n",
  "stepper__step--active": "lc-Stepper-module__stepper__step--active___uirCz"
}, ka = "stepper", wm = (l) => {
  var i = l, {
    activeStep: e,
    steps: a,
    className: r,
    "data-testid": _ = "stepper"
  } = i, o = U(i, [
    "activeStep",
    "steps",
    "className",
    "data-testid"
  ]);
  const n = Math.round(Math.max(1, a)), d = Math.round(
    Math.min(Math.max(1, e), n)
  ), s = u(ya[ka], r);
  return /* @__PURE__ */ h(
    "div",
    B(y({
      className: s,
      "data-testid": _,
      "aria-label": "Stepper"
    }, o), {
      children: [
        /* @__PURE__ */ h(D, { size: "sm", className: ya[`${ka}__counter`], children: [
          d,
          "/",
          n
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            className: ya[`${ka}__steps__container`],
            "data-testid": `${_}-container`,
            children: Array.from({ length: n }, (c, p) => {
              const m = p + 1, f = m <= d, g = m > d;
              return /* @__PURE__ */ t(
                "div",
                {
                  "aria-completed": f,
                  className: u(ya[`${ka}__step`], {
                    [ya[`${ka}__step--completed`]]: f,
                    [ya[`${ka}__step--active`]]: g
                  })
                },
                m
              );
            })
          }
        )
      ]
    })
  );
}, k_ = {
  "system-message-timestamp__value": "lc-SystemMessageTimestamp-module__system-message-timestamp__value___2E9S5",
  "system-message-timestamp__tooltip-wrapper": "lc-SystemMessageTimestamp-module__system-message-timestamp__tooltip-wrapper___OQVQr",
  "system-message-timestamp__tooltip-text": "lc-SystemMessageTimestamp-module__system-message-timestamp__tooltip-text___vMLWM"
}, w_ = "system-message-timestamp", Od = ({
  timestamp: e,
  timestampWithSeconds: a
}) => /* @__PURE__ */ t(
  ea,
  {
    "data-testid": "system-message-timestamp",
    placement: "top",
    kind: "invert",
    withFadeAnimation: !0,
    hoverOnDelay: 600,
    hoverOffDelay: 0,
    className: u(k_[`${w_}__tooltip-wrapper`]),
    triggerRenderer: () => /* @__PURE__ */ h(
      D,
      {
        size: "xs",
        className: k_[`${w_}__value`],
        "data-testid": "system-message-timestamp-value",
        children: [
          "• ",
          e
        ]
      }
    ),
    children: /* @__PURE__ */ t(
      D,
      {
        size: "xs",
        className: u(k_[`${w_}__tooltip-text`]),
        "data-testid": "system-message-timestamp-tooltip-text",
        children: a
      }
    )
  }
), ae = {
  "system-message__wrapper": "lc-SystemMessage-module__system-message__wrapper___ZvByq",
  "system-message__header-wrapper": "lc-SystemMessage-module__system-message__header-wrapper___L2mJw",
  "system-message__header-wrapper--alignment-left": "lc-SystemMessage-module__system-message__header-wrapper--alignment-left___nbtk7",
  "system-message__header-wrapper--alignment-right": "lc-SystemMessage-module__system-message__header-wrapper--alignment-right___dWNNV",
  "system-message__header-wrapper-title--kind-info": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-info___zTZIc",
  "system-message__header-wrapper-title--kind-positive": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-positive___HOpPL",
  "system-message__header-wrapper-title--kind-warning": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-warning___cMR-S",
  "system-message__header-wrapper-title--kind-error": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-error___9W4N4",
  "system-message__header-wrapper-title--kind-default": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-default___7Sz-W",
  "system-message__header-wrapper-title--bold": "lc-SystemMessage-module__system-message__header-wrapper-title--bold___Xgx6h",
  "system-message__header-wrapper-source": "lc-SystemMessage-module__system-message__header-wrapper-source___UFPCI",
  "system-message__header-wrapper-icon": "lc-SystemMessage-module__system-message__header-wrapper-icon___Fsoym",
  "system-message__details-wrapper": "lc-SystemMessage-module__system-message__details-wrapper___72AyK",
  "system-message__details-wrapper--alignment-left": "lc-SystemMessage-module__system-message__details-wrapper--alignment-left___0l8HF",
  "system-message__details-wrapper--alignment-left-margin": "lc-SystemMessage-module__system-message__details-wrapper--alignment-left-margin___K6M-H",
  "system-message__details-wrapper--alignment-right": "lc-SystemMessage-module__system-message__details-wrapper--alignment-right___me9LA",
  "system-message__details-toggle": "lc-SystemMessage-module__system-message__details-toggle___bGMIk",
  "system-message__details-line": "lc-SystemMessage-module__system-message__details-line___NBSiv",
  "system-message__details-first-line": "lc-SystemMessage-module__system-message__details-first-line___DZpbU",
  "system-message__details-first-line--alignment-left": "lc-SystemMessage-module__system-message__details-first-line--alignment-left___eId9x",
  "system-message__details-first-line--alignment-right": "lc-SystemMessage-module__system-message__details-first-line--alignment-right___d-Ur9",
  "system-message__actions-wrapper": "lc-SystemMessage-module__system-message__actions-wrapper___ZeV9m",
  "system-message__actions-wrapper--alignment-left": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-left___nXIND",
  "system-message__actions-wrapper--alignment-left-margin": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-left-margin___PDu3-",
  "system-message__actions-wrapper--alignment-right": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-right___F-y9M",
  "system-message__actions-wrapper-menu-trigger": "lc-SystemMessage-module__system-message__actions-wrapper-menu-trigger___y41Gz",
  "system-message__action-item": "lc-SystemMessage-module__system-message__action-item___uVowH"
}, re = "system-message", Cm = ({
  children: e,
  source: a,
  alignment: r = "right",
  kind: _ = "default",
  iconSource: o,
  titleBold: l = !1,
  details: i,
  timestamp: n,
  timestampWithSeconds: d,
  actions: s
}) => {
  const [c, p] = v.useState(!1), m = u(
    ae[`${re}__header-wrapper-title`],
    ae[`${re}__header-wrapper-title--kind-${_}`],
    {
      [ae[`${re}__header-wrapper-title--bold`]]: l
    }
  ), f = u(
    ae[`${re}__header-wrapper`],
    ae[`${re}__header-wrapper--alignment-${r}`]
  ), g = u(
    ae[`${re}__details-wrapper`],
    ae[`${re}__details-wrapper--alignment-${r}`],
    {
      [ae[`${re}__details-wrapper--alignment-left-margin`]]: r === "left" && o
    }
  ), w = u(
    ae[`${re}__details-line`],
    ae[`${re}__details-first-line`],
    ae[`${re}__details-first-line--alignment-${r}`]
  ), x = u(
    ae[`${re}__actions-wrapper`],
    ae[`${re}__actions-wrapper--alignment-${r}`],
    {
      [ae[`${re}__actions-wrapper--alignment-left-margin`]]: r === "left" && o
    }
  ), S = ($, b) => {
    let k = "primary";
    switch (b) {
      case "info":
        k = "primary";
        break;
      case "positive":
        k = "positive";
        break;
      case "warning":
        k = "warning";
        break;
      case "error":
        k = "error";
        break;
      case "default":
        k = "subtle";
        break;
      default:
        k = "subtle";
        break;
    }
    return /* @__PURE__ */ t(
      R,
      {
        size: "small",
        "data-testid": "system-message-header-icon",
        source: $,
        kind: k
      }
    );
  }, E = ($) => $.slice(2).map((b) => ({
    key: b.label,
    element: /* @__PURE__ */ t(
      rr,
      {
        leftNode: b.icon ? /* @__PURE__ */ t(R, { source: b.icon, kind: "primary" }) : void 0,
        children: b.label
      }
    ),
    onClick: b.callback
  })), N = ($) => /* @__PURE__ */ h("div", { className: x, children: [
    $.slice(0, 2).map((b) => /* @__PURE__ */ t(
      D,
      {
        className: ae[`${re}__action-item`],
        underline: !0,
        size: "xs",
        onClick: b.callback,
        children: b.label
      },
      b.label
    )),
    $.length > 2 && /* @__PURE__ */ t(
      D_,
      {
        placement: "bottom-end",
        options: E($),
        triggerRenderer: /* @__PURE__ */ t(
          H,
          {
            kind: "plain",
            size: "xcompact",
            "data-testid": "system-message-actions-menu-trigger",
            className: ae[`${re}__actions-wrapper-menu-trigger`],
            icon: /* @__PURE__ */ t(R, { source: Gl, kind: "primary" })
          }
        )
      }
    )
  ] }), C = ($) => /* @__PURE__ */ h(
    "div",
    {
      "data-testid": "system-message-details",
      className: g,
      children: [
        /* @__PURE__ */ h("div", { className: w, children: [
          $.slice(0, 1).map((b, k) => /* @__PURE__ */ t(D, { as: "div", size: "xs", children: b }, `detail-first-${k}`)),
          $.length > 1 && /* @__PURE__ */ t(
            H,
            {
              kind: "plain",
              size: "xcompact",
              "data-testid": "system-message-details-toggle",
              className: ae[`${re}__details-toggle`],
              onClick: () => p(!c),
              icon: /* @__PURE__ */ t(
                R,
                {
                  source: c ? or : ta,
                  kind: "primary"
                }
              )
            }
          )
        ] }),
        c && $.slice(1).map((b) => /* @__PURE__ */ t(
          "div",
          {
            className: ae[`${re}__details-line`],
            children: /* @__PURE__ */ t(D, { as: "div", size: "xs", children: b })
          },
          `detail-${$.indexOf(b)}`
        ))
      ]
    }
  );
  return /* @__PURE__ */ h(
    "div",
    {
      "data-testid": "system-message",
      className: u(ae[`${re}__wrapper`]),
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            "data-testid": "system-message-header",
            className: f,
            children: [
              o && /* @__PURE__ */ t("div", { className: ae[`${re}__header-wrapper-icon`], children: S(o, _) }),
              /* @__PURE__ */ t(
                D,
                {
                  as: "div",
                  size: "xs",
                  "data-testid": "system-message-title",
                  className: m,
                  children: e
                }
              ),
              a && /* @__PURE__ */ h(
                D,
                {
                  as: "div",
                  size: "xs",
                  "data-testid": "system-message-source",
                  className: ae[`${re}__header-wrapper-source`],
                  children: [
                    "• ",
                    a
                  ]
                }
              ),
              n && d && /* @__PURE__ */ t(
                Od,
                {
                  timestamp: n,
                  timestampWithSeconds: d
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ h(Z, { children: [
          i && C(i),
          s && N(s)
        ] })
      ]
    }
  );
};
export {
  wd as ANIMATION_TIME,
  cu as Accordion,
  fi as AccordionAnimatedLabel,
  bi as AccordionMultilineElement,
  su as AccordionPromo,
  gu as ActionBar,
  hu as ActionCard,
  D_ as ActionMenu,
  du as ActionMenuItem,
  Hu as ActionModalContent,
  fu as Alert,
  S_ as AnimatedTextContainer,
  bu as AppFrame,
  mi as AppFrameProvider,
  Eu as AutoComplete,
  M_ as Avatar,
  Pr as Badge,
  H as Button,
  Bu as Card,
  Wr as Checkbox,
  Sc as DatePicker,
  Iu as DatePickerRangeCalendarsWrapper,
  jd as DesignToken,
  Au as DetailsCard,
  Du as DetailsCardInfo,
  X_ as Display,
  mm as EmailTagInput,
  Ou as EmptyState,
  $u as ExpirationCounter,
  Vr as FieldDescription,
  P_ as FieldError,
  Mu as FieldGroup,
  Ed as FileUploadProgress,
  E_ as FileUploadProgressActions,
  km as FloatingPortal,
  Pu as Form,
  Fu as FormField,
  Ru as FormGroup,
  Qu as GallerySelectableCard,
  rm as GridCol,
  am as GridRow,
  tm as GridWrapper,
  nu as HEADING_SIZES,
  he as Heading,
  R as Icon,
  mu as Info,
  Tn as Input,
  qo as InputComponent,
  Su as InputPromo,
  Wi as Interactive,
  em as InteractiveSelectableCard,
  Gu as InviteAgents,
  Uu as Link,
  rr as ListItem,
  O_ as Loader,
  Nu as MobileNavigation,
  Lu as Modal,
  Kc as ModalBase,
  uo as ModalCloseButton,
  zu as ModalHeader,
  qu as ModalPortal,
  Cu as Navigation,
  ku as NavigationGroup,
  wu as NavigationItem,
  Uo as NavigationTopBar,
  $n as NavigationTopBarAlert,
  Cn as NavigationTopBarTitle,
  Vu as NumericInput,
  Wu as OnboardingChecklist,
  Ku as OverflowTooltipText,
  xu as Picker,
  Vo as PickerList,
  es as Popover,
  Yu as ProductSwitcher,
  rs as ProductSwitcherProducts,
  hs as ProgressBar,
  gs as ProgressCircle,
  Zu as PromoBannerV2,
  fs as RadioButton,
  eu as RadiusToken,
  jo as RangeDatePicker,
  ju as RangeDatePickerV2,
  pu as Reports,
  dn as SIDE_NAVIGATION_ACTIVE_ITEM_TEST_ID,
  sn as SIDE_NAVIGATION_ITEM_TEST_ID,
  un as SIDE_NAVIGATION_PARENT_ICON_TEST_ID,
  ws as SearchInput,
  Tu as SegmentedControl,
  R_ as SelectableCard,
  Qd as ShadowToken,
  vu as SideNavigation,
  yu as SideNavigationGroup,
  mn as SideNavigationItem,
  uu as Simple,
  om as SkeletonAvatar,
  lm as SkeletonText,
  _m as SkeletonWrapper,
  Jd as SpacingToken,
  im as StatusBadge,
  wm as Stepper,
  nm as Switch,
  Cm as SystemMessage,
  cm as Tab,
  um as Table,
  dm as TabsList,
  sm as TabsWrapper,
  Wo as Tag,
  ud as TagInput,
  D as Text,
  gm as Textarea,
  Qt as ThemeClassName,
  lu as ThemeProvider,
  Ju as ThumbnailSelectableCard,
  kd as Toast,
  pm as ToastWrapper,
  ea as Tooltip,
  ru as TransitionDelayToken,
  tu as TransitionDurationToken,
  au as TransitionTimingToken,
  hm as UpdateBadge,
  ym as UploadBar,
  fm as UserGuide,
  bm as UserGuideBubbleStep,
  vm as UserGuideStep,
  On as generateAvatarColor,
  iu as getDesignTokenWithOpacity,
  _u as getThemeClassName,
  sa as useAnimations,
  A_ as useAppFrame,
  Xu as useProductSwitcher,
  Gs as useTable,
  ou as useTheme
};
